// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { AnimatePresence, motion } from "framer-motion";
// import Cookies from "js-cookie";
// import { Home, List, Printer, Trash2, Users } from "lucide-react";
// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";
// import { toast } from "react-toastify";
// import Swal from "sweetalert2";
// import { useDeleteMember } from "../../API_Master/DeleteMutateAPI";
// import { useMemberListExportExcel } from "../../API_Master/ExcelAPI";
// import { useMemberListDataPagination } from "../../API_Master/FetchAPI";
// import { useNotVoterDeath, useSetChangeHead } from "../../API_Master/MutateAPI";
// import ExcelButton from "../../CommonComponents/ExcelButton";
// import Loader from "../../CommonComponents/Loader";
// import PageCountSelect from "../../CommonComponents/PageCountSelect";
// import PageEntries from "../../CommonComponents/PageEntries";
// import PaginationButtons from "../../CommonComponents/PaginationButtons";
// import TableFilterButton from "../../CommonComponents/TableFilterButton";
// import TableShimmer from "../../Components/TableShimmer";
// import { deleteConfirmation, exportToExcel, notifyError, notifySuccess, toIndianCurrency } from "../../MethodMaster/JSXComponentMothod";
// import { toggleOffcanvasStatus } from "../../Redux/Slices/ProjectSlice";
// import AddExistingVoter from "../AddExistingVoter/inde";
// import AddNewVoter from "../AddNewVoter";
// import ChangeHeadModal from "../ChangeHeadModal";
// import EditYojanaMemberDetail from "../EditYojanaMemberDetail";
// import YojanaSelect from "../YojanaSelect";
// import FilterMemberList from "./FilterMemberList";

// const PrintableSingleYojana = React.forwardRef(({ head }, ref) => {
//   return (
//     <div
//       ref={ref}
//       style={{
//         padding: "30px 50px",
//         fontFamily: "Arial, sans-serif",
//         background: "white",
//         color: "#000",

//       }}
//     >
//       {/* Header */}
//       <h3
//         style={{
//           textAlign: "center",
//           color: "#1A237E",
//           fontSize: "20px",

//           marginBottom: "-15px",
//         }}
//       >
//         સરકાર દ્વારા મળેલ લાભો
//       </h3>
//       <h3
//         style={{
//           textAlign: "center",
//           color: "#1A237E",
//           fontSize: "20px",

//           marginBottom: "-15px",
//         }}
//       >૧૫૫ - ઓલપાડ વિધાનસભા
//       </h3>
//       <h4
//         style={{
//           textAlign: "center",
//           color: "#1A237E",
//           fontSize: "-15px",
//         }}
//       >
//         લાભાર્થી પરિવાર :   {head.FullNameEnglish}
//       </h4>
//       <p
//         style={{
//           textAlign: "center",
//           color: "#555",
//           fontSize: "16px",
//           marginBottom: "20px",
//         }}
//       >
//         Village: {head.PartNameEnglish} | Locality: {head.LocalityEnglish}
//       </p>

//       {/* Main Benefits Table */}
//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "15px",
//           tableLayout: "fixed",
//           marginBottom: "40px",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "43%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>
//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th>No</th>
//             <th>Yojana Name</th>
//             <th>Member & Amount</th>
//             <th>Total Amount</th>
//           </tr>
//         </thead>
//         <tbody>
//           {head.MemberYojnaDetails?.map((yojana, i) => {
//             const memberDetails = yojana.MemberDetails ?? [];
//             const maxNameLen = Math.max(...memberDetails.map((m) => m?.MemberName?.trim().length || 0));
//             const memberList = memberDetails
//               .map((m, idx) => {
//                 const name = m?.MemberName?.trim() || "Unknown";
//                 const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//                 const paddedName = name.padEnd(maxNameLen + 2);
//                 const amtText = m.IsAmount
//                   ? m?.TimePeriod && m.TimePeriod !== "1"
//                     ? `${amount} × ${m.TimePeriod}`
//                     : amount
//                   : m.IsAmountEnterByUser
//                     ? toIndianCurrency(parseInt(m?.Amount || 0))
//                     : "1";
//                 const entryDate = m.GramYojnaMemberEntryDate;
//                 return `${idx + 1}) ${paddedName} ${amtText}\n   Entry Date: ${entryDate}`;
//               })
//             return (
//               <tr
//                 key={i}
//                 style={{
//                   pageBreakInside: "avoid", // Critical: Never split this row
//                   breakInside: "avoid",
//                 }}
//               >
//                 <td>{i + 1}</td>
//                 <td style={{ fontFamily: "monospace" }}>{yojana.GramYojnaName}</td>
//                 <td style={{
//                   border: "1px solid #333",
//                   padding: "8px",
//                   whiteSpace: "pre-line",
//                   fontFamily: "monospace",
//                   verticalAlign: "top",
//                 }}>
//                   {memberList.join("\n")}
//                   <br />
//                   {yojana?.MemberDetails?.[0]?.TimePeriod === "12" ? " ( દર માસ ) " : yojana?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ textAlign: "right", fontFamily: "monospace" }}>
//                   {yojana?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(yojana.Amount)
//                     : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(yojana.Amount)
//                       : `${yojana?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr style={{ backgroundColor: "#FFF3E0", fontWeight: "bold" }}>
//             <td colSpan={3} style={{ textAlign: "right" }}>
//               Total Amount
//             </td>
//             <td style={{ textAlign: "right" }}>{toIndianCurrency(head.OverAllFamilyAmount || 0)}</td>
//           </tr>
//         </tfoot>
//       </table>

//       {/* Village Level Benefits - Always starts on new page if needed */}
//       {/* {head?.GrantYojnaDetails && head.GrantYojnaDetails.length > 0 && (
//         <>
//           <div style={{ pageBreakBefore: "always" }}></div>
//           <h4
//             style={{
//               textAlign: "center",
//               color: "#1A237E",
//               fontSize: "18px",
//               margin: "20px 0 20px",
//               borderBottom: "1px solid #1A237E",
//               paddingBottom: "8px",
//             }}
//           >
//             ગામ ના લાભો
//           </h4>
//           <div
//             style={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: "12px",
//               padding: "10px 0",
//             }}
//           >
//             {head.GrantYojnaDetails.map((item, index) => (
//               <span
//                 key={index}
//                 style={{

//                   padding: "6px 8px",
//                   borderRadius: "8px",
//                   borderLeft: "5px solid #1A237E",

//                   fontSize: "12px",

//                 }}
//               >
//                 <span style={{ color: "#1A237E", fontWeight: "bold", marginRight: "10px" }}>{index + 1}.</span>
//                 <span style={{ fontWeight: "500" }}>{item.YojnaName}</span>
//               </span>
//             ))}
//           </div>
//         </>
//       )} */}

//       {/* Print-only styles */}
//       <style jsx>{`
//         @media print {
//           @page {
//             margin: 1cm;
//           }
//           body {
//             -webkit-print-color-adjust: exact;
//             print-color-adjust: exact;
//           }
//           tr {
//             page-break-inside: avoid !important;
//             break-inside: avoid !important;
//           }
//           table {
//             page-break-after: auto;
//           }
//           .no-print {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// });

// // Reusable styles

// const ORIENTATION = "landscape"; // "portrait" or "landscape"
// const PAGE_WIDTH_MM = ORIENTATION === "landscape" ? 297 : 210; // A4
// const PAGE_HEIGHT_MM = ORIENTATION === "landscape" ? 210 : 297;

// const TOP_MARGIN_MM = 15;
// const BOTTOM_MARGIN_MM = 15;
// const LEFT_MARGIN_MM = 20;
// const RIGHT_MARGIN_MM = 20;

// const PRINTABLE_HEIGHT_MM = PAGE_HEIGHT_MM - TOP_MARGIN_MM - BOTTOM_MARGIN_MM;
// const PRINTABLE_WIDTH_MM = PAGE_WIDTH_MM - LEFT_MARGIN_MM - RIGHT_MARGIN_MM;

// const PX_TO_MM = 96 / 25.4; // 96 dpi → 1 px ≈ 0.2646 mm

// const PrintableAllYojanas = React.forwardRef(({ data }, ref) => {
//   const [pageGroups, setPageGroups] = useState([]);
//   const measureRef = useRef(null);

//   /* -------------------------------------------------
//      1. Measure block height (table + family total)
//      ------------------------------------------------- */
//   useEffect(() => {
//     if (!measureRef.current || !data.length) return;

//     const blocks = measureRef.current.querySelectorAll(".print-block");
//     const heightsPx = Array.from(blocks).map((b) => b.offsetHeight);
//     const printablePx = PRINTABLE_HEIGHT_MM * PX_TO_MM;

//     const groups = [];
//     let curGroup = [];
//     let curHeight = 0;

//     data.forEach((item, i) => {
//       const blockHeight = heightsPx[i];
//       const gap = i === 0 ? 0 : 30; // space between blocks

//       if (curHeight + gap + blockHeight > printablePx && curGroup.length) {
//         groups.push(curGroup);
//         curGroup = [item];
//         curHeight = blockHeight;
//       } else {
//         curGroup.push(item);
//         curHeight += gap + blockHeight;
//       }
//     });
//     if (curGroup.length) groups.push(curGroup);

//     setPageGroups(groups);
//   }, [data]);

//   /* -------------------------------------------------
//      2. Render
//      ------------------------------------------------- */
//   return (
//     <div ref={ref} style={{ background: "white", fontFamily: "Arial, sans-serif" }}>
//       {/* ---------- HIDDEN MEASUREMENT AREA ---------- */}
//       <div
//         ref={measureRef}
//         style={{
//           padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//           visibility: "hidden",
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: `${PRINTABLE_WIDTH_MM}mm`,
//         }}
//       >
//         {data.map((item, idx) => (
//           <PrintBlock key={idx} item={item} />
//         ))}
//       </div>

//       {/* ---------- VISIBLE PRINTABLE PAGES ---------- */}
//       {pageGroups.map((group, pageIdx) => (
//         <div
//           key={pageIdx}
//           className="print-page"
//           style={{
//             width: `${PAGE_WIDTH_MM}mm`,
//             minHeight: `${PAGE_HEIGHT_MM}mm`,
//             padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//             pageBreakAfter: pageIdx < pageGroups.length - 1 ? "always" : "auto",
//             boxSizing: "border-box",
//           }}
//         >
//           {/* Title – only on first page */}
//           {/* {pageIdx === 0 && (
//             <h1
//               style={{
//                 textAlign: "center",
//                 color: "#1A237E",
//                 fontSize: "32px",
//                 marginBottom: "20px",
//               }}
//             >
//               સરકાર દ્વારા મળેલ લાભો
//             </h1>
//           )} */}

//           {group.map((item, idx) => (
//             <PrintBlock key={idx} item={item} isLastInGroup={idx === group.length - 1} />
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// });

// /* -------------------------------------------------
//    Re‑usable block (used both for measurement & printing)
//    ------------------------------------------------- */
// const PrintBlock = React.memo(({ item, isLastInGroup }) => {
//   const { head, yojanas } = item;

//   return (
//     <div
//       className="print-block"
//       style={{
//         marginBottom: isLastInGroup ? "0" : "30px",
//         breakInside: "avoid",
//       }}
//     >
//       <h1
//         style={{
//           textAlign: "center",
//           color: "#1A237E",
//           fontSize: "32px",
//           marginBottom: "-15px",
//         }}
//       >
//         સરકાર દ્વારા મળેલ લાભો
//       </h1>
//       <h3
//         style={{
//           textAlign: "center",
//           color: "#1A237E",
//           fontSize: "20px",

//           marginBottom: "-15px",
//         }}
//       >
//         ૧૫૫ - ઓલપાડ વિધાનસભા
//       </h3>
//       <h4
//         style={{
//           textAlign: "center",
//           color: "#1A237E",
//           fontSize: "-15px",
//         }}
//       >
//         લાભાર્થી પરિવાર : {head.FullNameEnglish}
//       </h4>
//       {/* <h3
//           style={{
//             color: "#1A237E",
//             borderBottom: "3px solid #4CAF50",
//             paddingBottom: "10px",
//             fontSize: "22px",
//           }}
//         >
//           {head.FullNameEnglish}
//         </h3> */}
//       <p style={{ fontSize: "16px", marginBottom: "15px" }}>
//         <strong>Village:</strong> {head.PartNameEnglish} | <strong>Locality:</strong> {head.LocalityEnglish}
//       </p>

//       {/* ---------- TABLE ---------- */}
//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "14px",
//           tableLayout: "fixed",
//           // breakInside: "avoid",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} /> {/* # */}
//           <col style={{ width: "30%" }} /> {/* Yojana */}
//           <col style={{ width: "45%" }} /> {/* Member & Amount */}
//           <col style={{ width: "20%" }} /> {/* Total Amount */}
//         </colgroup>

//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th style={{ border: "1px solid #333", padding: "10px" }}>No</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Yojana</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Member & Amount</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Total Amount</th>
//           </tr>
//         </thead>

//         <tbody>
//           {yojanas.map((y, i) => {
//             /* Build array of "name + amount" strings */
//             const memberLines = y.MemberDetails?.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               // Use fixed-width spacing for perfect alignment
//               const entryDate = m?.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${name.padEnd(25)} - ${m.IsAmount ? (m?.TimePeriod && m?.TimePeriod != "1" ? amount + " × " + m?.TimePeriod : amount) : m.IsAmountEnterByUser ? amount : "1"
//                 }\n  Entry Date -${entryDate} `;
//             });

//             return (
//               <tr key={i}>
//                 <td
//                   style={{
//                     border: "1px solid #333",
//                     padding: "8px",
//                     textAlign: "center",
//                     verticalAlign: "top",
//                     fontFamily: "monospace",
//                   }}
//                 >
//                   {i + 1}
//                 </td>

//                 <td
//                   style={{
//                     border: "1px solid #333",
//                     padding: "8px",
//                     whiteSpace: "pre-line",
//                     wordBreak: "break-word",
//                     verticalAlign: "top",
//                     fontFamily: "monospace",
//                   }}
//                 >
//                   {y.GramYojnaName}
//                 </td>

//                 <td
//                   style={{
//                     border: "1px solid #333",
//                     padding: "8px",
//                     whiteSpace: "pre-line",
//                     fontFamily: "monospace",
//                     verticalAlign: "top",
//                   }}
//                 >
//                   {memberLines.join("\n")}
//                   <br />
//                   {y?.MemberDetails?.[0]?.TimePeriod == "12" ? " ( દર માસ ) " : y?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>

//                 <td
//                   style={{
//                     border: "1px solid #333",
//                     padding: "8px",
//                     textAlign: "right",
//                     verticalAlign: "top",
//                   }}
//                 >
//                   {y?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(y.Amount)
//                     : y?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(y.Amount)
//                       : `${y?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr>
//             <td
//               colSpan={4}
//               style={{
//                 borderTop: "1px solid #000",
//                 padding: 0,
//               }}
//             ></td>
//           </tr>

//           <tr>
//             <td
//               colSpan={3}
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//                 backgroundColor: "#FFF3E0",
//                 border: "1px solid #000",
//                 borderRight: "none",
//               }}
//             >
//               Total Amount
//             </td>

//             <td
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "15px",
//                 color: "#000",
//                 backgroundColor: "#FFF3E0",
//                 fontFamily: "monospace",
//                 border: "1px solid #000",
//               }}
//             >
//               {toIndianCurrency(head.OverAllFamilyAmount || 0)}
//             </td>
//           </tr>
//         </tfoot>
//       </table>
//       {/* <h3
//           style={{
//             textAlign: "center",
//             color: "#1A237E",
//             fontSize: "22px",
//             margin: "20px 0 20px",
//             borderBottom: "1px solid #1A237E",
//             paddingBottom: "8px",
//           }}
//         >
//           ગામ ના લાભો
//         </h3>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "2" }}>
//           {head?.GrantYojnaDetails?.map((item, index) => (
//             <span
//               key={index}
//               style={{
//                 // backgroundColor: "#E3F2FD",
//                 padding: "5px 5px",
//                 borderRadius: "8px",
//                 borderLeft: "4px solid #1A237E",
//                 // boxShadow: "0 2px 5px rgba(0,0,0,0.08)",
//                 fontSize: "12px",
//                 // display: "inline",
//                 // alignItems: "center",
//               }}
//             >
//               <span style={{ color: "#1A237E", fontWeight: "bold", marginRight: "10px", minWidth: "24px" }}>{index + 1}.</span>
//               <span>{item.YojnaName}</span>
//             </span>
//           ))}
//         </div> */}

//       {/* ---------- FAMILY TOTAL ---------- */}
//       {/* <div
//         style={{
//           marginTop: "20px",
//           fontWeight: "bold",
//           fontSize: "18px",
//           textAlign: "right",
//         }}
//       >
//         Total Amount: {toIndianCurrency(head.OverAllFamilyAmount || 0)}
//       </div> */}

//       <style jsx>{`
//         @media print {
//           tfoot {
//             display: table-row-group;
//           }
//         }
//       `}</style>
//     </div>
//   );
// });

// const ViewMemberList = () => {
//   const { DarkTheme } = useSelector((state) => state.ProjectSlice);
//   const dispatch = useDispatch();

//   const [addNewVoterShow, setAddNewVoterShow] = useState(false);
//   const [changeHeadData, setChangeHeadData] = useState("");
//   const [isChangeHeadOpen, setIsChangeHeadOpen] = useState(false);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [filterData, setFilterData] = useState({});
//   const [familyHeadMasterID, setFamilyHeadMasterID] = useState("");
//   const [headData, setHeadData] = useState({});
//   const [statusType, setStatusType] = useState("");
//   const [deadNonVoterHeadID, setDeadNonVoterHeadID] = useState("");
//   const [selectedVillage, setSelectedVillage] = useState("");
//   const [selectedLocality, setSelectedLocality] = useState("");
//   const [isAddExistingModalOpen, setIsAddExistingModalOpen] = useState(false);
//   const [selectedRecords, setSelectedRecords] = useState({});
//   const [filterStatus, setFilterStatus] = useState(false);
//   const [memberDetails, setMemberDetails] = useState([]);
//   const [yojanaSelectModalOpen, setYojanaSelectModal] = useState(false);
//   const [memberYojanaDetail, setMemberYojanaDetail] = useState([]);
//   const [yojanaDetails, setOpenYojanaDetails] = useState({});
//   const { mutate: addNotVoterDeath, isPending: inserting } = useNotVoterDeath();
//   const [deadNonVoterMemberID, setDeadNonVoterMemberID] = useState("");
//   const [selectedEditGramYojanaID, setSelectedEditGramYojanaID] = useState(null);
//   const [selectedEditMemberDetail, setSelectedEditMemberDetail] = useState({});
//   const [isEditMemberDetailModalOpen, setIsEditMemberDetailModalOpen] = useState(false);
//   // PRINT REFS
//   const singlePrintRefs = useRef({});
//   const allYojanaPrintRef = useRef();
//   const triggerAllPrint = useRef(() => { });
//   const [allYojanaData, setAllYojanaData] = useState([]);
//   const [preparingAllPrint, setPreparingAllPrint] = useState(false);

//   const filterRef = useRef();

//   const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useMemberListDataPagination(rowsPerPage, filterData);
//   const { mutate: deleteMember, isLoading: deleting } = useDeleteMember();
//   const { mutate: addChangeHead, isPending: changeHeadInserting } = useSetChangeHead();
//   const { mutate: exportMemberList, isPending: isExporting } = useMemberListExportExcel();

//   const pages = data?.pages || [];
//   const totalCount = data?.pages[0]?.TotalCount || 0;
//   const start = currentPage * rowsPerPage + 1;
//   const end = Math.min(start + (pages[currentPage]?.data?.length || 0) - 1, totalCount);

//   // PRINT SINGLE FAMILY
//   const printSingleYojana = (head) => {
//     const node = singlePrintRefs.current[head.FamilyHeadMasterID];
//     console.log("sdlfjklsdfjkslfjlskdfjlskdfa", head);
//     if (!node) return;

//     const win = window.open("", "_blank");
//     win.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>${head.FullNameEnglish} - Yojana</title>
//           <style>
//             body { font-family: Arial, sans-serif;  background: white; }
//             table { width: 100%; border-collapse: collapse; font-size: 14px; }
//             th, td { border: 1px solid #333; padding: 10px; text-align: left; }
//             th { background: #E8F5E8; }
//             .indian-currency::before { content: "₹"; }
//           </style>
//         </head>
//         <body>${node.innerHTML}</body>
//       </html>
//     `);
//     win.document.close();
//     win.focus();
//     win.print();
//     setTimeout(() => win.close(), 1000);
//   };

//   // PRINT ALL YOJANAS
//   const handlePrintAllYojanas = () => {
//     toast.dismiss();
//     setPreparingAllPrint(true);

//     exportMemberList(filterData, {
//       onSuccess: (apiData) => {
//         const printData = apiData
//           .filter((head) => head.MemberYojnaDetails?.length > 0)
//           .map((head) => ({
//             head,
//             yojanas: head.MemberYojnaDetails,
//           }));

//         if (printData.length === 0) {
//           notifyError("No Yojana data found");
//           setPreparingAllPrint(false);
//           return;
//         }

//         setAllYojanaData(printData);
//         setTimeout(() => triggerAllPrint.current(), 300);
//       },
//       onError: () => {
//         notifyError("Print failed");
//         setPreparingAllPrint(false);
//       },
//     });
//   };

//   const printAllYojanas = useReactToPrint({
//     contentRef: allYojanaPrintRef,
//     documentTitle: `All_Yojanas_${new Date().toISOString().slice(0, 10)}`,
//     onAfterPrint: () => {
//       setPreparingAllPrint(false);
//       setAllYojanaData([]);
//     },
//   });

//   useEffect(() => {
//     triggerAllPrint.current = printAllYojanas;
//   }, [printAllYojanas]);

//   // ALL YOUR ORIGINAL FUNCTIONS (100% UNCHANGED)
//   const handleRowsChange = async (e) => {
//     const limit = parseInt(e.target?.value);
//     setRowsPerPage(limit);
//     setCurrentPage(0);
//     await refetch();
//   };

//   const goToPage = async (index) => {
//     if (pages[index]) {
//       setCurrentPage(index);
//     } else if (hasNextPage) {
//       await fetchNextPage();
//       setCurrentPage(index);
//     }
//   };

//   const handleAddNewVoterClose = () => setAddNewVoterShow(false);

//   const handleChangeHeadClose = () => {
//     setIsChangeHeadOpen(false);
//     setChangeHeadData("");
//     setFamilyHeadMasterID("");
//     setHeadData({});
//     setStatusType("");
//   };

//   const handleCloseAddExistingModal = () => {
//     setSelectedVillage("");
//     setSelectedLocality("");
//     setSelectedRecords({});
//     setIsAddExistingModalOpen(false);
//     setFamilyHeadMasterID("");
//   };

//   const handleSetNonVoterDeath = (ele, StatusType, Status) => {
//     setDeadNonVoterMemberID(ele.ContactDetailID);
//     setStatusType(StatusType);
//     const payload = {
//       ContactDetailID: ele?.ContactDetailID || "",
//       StatusType: StatusType,
//       Death: StatusType === "Death" ? Status : false,
//       NotVoter: StatusType === "NotVoter" ? Status : false,
//       UpdatedByUserID: "",
//     };

//     Swal.fire({
//       title: "Are you sure?",
//       text: `You are marking this member as "${StatusType}".`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, proceed!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         addNotVoterDeath(payload, {
//           onSuccess: (res) => {
//             if (res?.status === true) {
//               notifySuccess("Successfully Inserted", false);
//               refetch();
//             } else {
//               notifyError(res?.message ? res.message : "Data Not Inserted", false);
//             }
//           },
//           onError: () => notifyError("Something went wrong", false),
//         });
//       } else {
//         setDeadNonVoterMemberID("");
//         setStatusType("");
//       }
//     });
//   };

//   const handleDeleteMember = async (item) => {
//     const result = await deleteConfirmation();
//     if (result?.isConfirmed) {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         ContactDetailID: item?.ContactDetailID || "",
//         FamilyMemberDetailID: item?.FamilyMemberDetailID || "",
//         VoterID: item?.VoterID || "",
//       };
//       deleteMember(payload, {
//         onSuccess: (res) => {
//           if (res?.status === true) {
//             notifySuccess("Deleted Successfully", DarkTheme ? true : false);
//             refetch();
//           } else {
//             notifyError(res?.message || "Not Deleted", DarkTheme ? true : false);
//           }
//         },
//         onError: () => notifyError("Something went wrong", false),
//       });
//     }
//   };

//   const handleDeathNotVoterChange = (head, StatusType) => {
//     setFamilyHeadMasterID(head.FamilyHeadMasterID);
//     setDeadNonVoterHeadID(head?.ContactDetailID);
//     setStatusType(StatusType);

//     if (head?.FamilyMemberDetails?.length > 0) {
//       setChangeHeadData(head);
//       setIsChangeHeadOpen(true);
//       setHeadData({
//         ContactDetailID: head?.ContactDetailID,
//         VoterID: head?.VoterID,
//         IsHead: false,
//         IsHandicap: head?.IsHandicap,
//         IsOutSide: head?.IsOutSide,
//       });
//     } else {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         FamilyHeadMasterID: familyHeadMasterID || "",
//         ContactDetailID: head?.ContactDetailID || "",
//         StatusType: StatusType,
//         Death: StatusType?.toLowerCase() === "death" ? true : false,
//         NotVoter: StatusType?.toLowerCase() === "notvoter" ? true : false,
//         FamilyDetail: [],
//       };

//       Swal.fire({
//         title: "Are you sure?",
//         text: `You are marking this head as "${StatusType}".`,
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, proceed!",
//       }).then((result) => {
//         if (result.isConfirmed) {
//           addChangeHead(payload, {
//             onSuccess: (res) => {
//               if (res?.status === true) {
//                 notifySuccess("Successfully Inserted", false);
//                 setFamilyHeadMasterID("");
//                 setStatusType("");
//                 setDeadNonVoterHeadID("");
//                 refetch();
//               } else {
//                 notifyError(res?.message || "Data Not Inserted", false);
//               }
//             },
//             onError: () => notifyError("Something went wrong", false),
//           });
//         } else {
//           setFamilyHeadMasterID("");
//           setDeadNonVoterHeadID("");
//           setStatusType("");
//         }
//       });
//     }
//   };

//   const handleFilterStatusToggle = () => {
//     setFilterStatus(true);
//     dispatch(toggleOffcanvasStatus(true));
//   };

//   const handleExport = () => {
//     toast.dismiss();

//     exportMemberList(filterData, {
//       onSuccess: (MemberListData) => {
//         debugger;
//         if (!MemberListData?.length) return notifyError("No Data Found");
//         exportToExcelWithYojanaTable(MemberListData);
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   async function exportToExcelWithYojanaTable(data) {
//     const workbook = new ExcelJS.Workbook();
//     const sheet = workbook.addWorksheet("Family Yojana Report", {
//       pageSetup: { paperSize: 9, orientation: "landscape" },
//     });

//     let rowIndex = 1;
//     let familySr = 1;

//     data.forEach((head) => {
//       const members = head.FamilyMemberDetails || [];
//       const headName = head.FullNameEnglish || "";
//       const village = head.PartNameEnglish || "";
//       const locality = head.LocalityEnglish || "";
//       const overAllAmount = head.OverAllFamilyAmount || 0;

//       // ===== 1. Family Header Row =====
//       const headerRow = sheet.getRow(rowIndex++);
//       headerRow.values = [familySr, headName, village, locality, `₹${Number(overAllAmount).toLocaleString("en-IN")}.00`];
//       headerRow.font = { bold: true, size: 12 };
//       headerRow.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "FFE6E6E6" },
//       };
//       // sheet.getRow(rowIndex++).height = 4; // spacer

//       // ===== 2. Member Table Header =====
//       const memberHeader = sheet.getRow(rowIndex++);
//       memberHeader.values = ["", "Member Name", "Mobile", "Gender", "Age", "ID Card No", "SL No"];
//       memberHeader.font = { bold: true };
//       memberHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9EAD3" } };

//       // ===== 3. Member Rows =====
//       members.forEach((member) => {
//         const row = sheet.getRow(rowIndex++);
//         row.values = [
//           "",
//           member.FullNameEnglish || "",
//           member.MobileNo || "",
//           member.Gender === "M" ? "Male" : "Female",
//           member.Age || "",
//           member.IDCardNo || "",
//           member.SLNo || "",
//         ];
//       });

//       // sheet.getRow(rowIndex++).height = 10; // spacer

//       // ===== 4. Yojana Table Header =====
//       const yojanaHeader = sheet.getRow(rowIndex++);
//       if (head?.MemberYojnaDetails?.length) {
//         yojanaHeader.values = ["", "Yojana Name", "Members (with Amount)", "Total Amount"];
//         yojanaHeader.font = { bold: true, color: { argb: "FFFFFFFF" } };
//         yojanaHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4CAF50" } };
//       }

//       // ===== 5. Yojana Rows =====

//       (head.MemberYojnaDetails || []).forEach((yojna) => {
//         const yojnaName = yojna.GramYojnaName || "";
//         const yojnaTotal = yojna.Amount || "0";
//         const details = yojna.MemberDetails || [];

//         // Build numbered list of members with amount
//         const memberList = details
//           .map((d, i) => {
//             const name = d.MemberName || "Unknown";
//             // const amt = d.Amount ? `₹${Number(d.Amount).toLocaleString('en-IN')}.00` : "₹0.00";
//             const amt = d.IsAmount
//               ? d?.TimePeriod && d?.TimePeriod != "1"
//                 ? toIndianCurrency(parseInt(d?.Amount || 0)) + " × " + d?.TimePeriod
//                 : toIndianCurrency(parseInt(d?.Amount || 0))
//               : d.IsAmountEnterByUser
//                 ? toIndianCurrency(parseInt(d?.Amount || 0))
//                 : "1";
//             // return `${i + 1}) ${name} (${amt})  `;
//             // const entryDate = formatUtcToLocalDate(d?.GramYojnaMemberEntryDate);
//             const entryDate = d?.GramYojnaMemberEntryDate;

//             return `${i + 1}) ${name} (${amt})\n   Entry Date: ${entryDate}`;
//           })
//           .join("\n");

//         const firstRow = sheet.getRow(rowIndex++);
//         firstRow.values = [
//           "",
//           yojnaName,
//           // memberList + `${details?.[0]?.TimePeriod == "12" ? "\n ( દર માસ ) " : details?.[0]?.IsAmount ? "\n  ( દર વર્ષે ) " : ""}`,
//           memberList + `${details?.[0]?.TimePeriod == "12" ? "\n ( દર માસ ) " : details?.[0]?.IsAmount ? "\n  ( દર વર્ષે ) " : ""}`,
//           //          {
//           //   richText: buildMemberRichText(details),
//           // },
//           details?.[0]?.IsAmount ? toIndianCurrency(yojnaTotal) : details?.[0]?.IsAmountEnterByUser ? toIndianCurrency(yojnaTotal) : `${details?.length} સંખ્યા`,
//         ];
//         firstRow.getCell(2).alignment = {
//           vertical: "middle",
//           wrapText: true,
//         };
//         firstRow.getCell(3).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(4).alignment = {
//           vertical: "middle",
//         };
//         // Add extra rows if member list is long
//         const lines = memberList.split("\n").length;
//         if (lines > 1) {
//           for (let i = 1; i < lines; i++) {
//             const extraRow = sheet.getRow(rowIndex);
//             extraRow.values = ["", "", "", ""];
//             extraRow.getCell(3).value = { formula: `C${rowIndex - lines}` }; // link
//           }
//         }
//         sheet.getRow(rowIndex++).height = 15; // final spacer
//       });

//       familySr++;
//     });

//     // ===== Column Widths =====
//     sheet.columns = [
//       { width: 8 }, // Sr No
//       { width: 40 }, // Head Name / Yojana
//       { width: 40 }, // Members (wrap)
//       { width: 30 }, // Amount
//       { width: 18 }, // Total
//       { width: 15 }, // Mobile
//       { width: 10 }, // Gender
//       { width: 8 }, // Age
//       { width: 18 }, // ID Card
//       { width: 10 }, // SL No
//     ];

//     // ===== Generate File =====
//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], { type: "application/octet-stream" });
//     saveAs(blob, "Family_Yojana_Report.xlsx");
//   }

//   const handleYojanaExport = () => {
//     toast.dismiss();
//     exportMemberList(filterData, {
//       onSuccess: (YojanaListData) => {
//         if (!YojanaListData?.length) return notifyError("No Data Found");
//         const exportData = [];
//         YojanaListData.forEach((head) => {
//           const yojanaDetails = head?.MemberYojnaDetails || [];
//           if (yojanaDetails.length > 0) {
//             yojanaDetails.forEach((yojana) => {
//               const members = yojana?.MemberDetails || [];
//               members.forEach((member) => {
//                 exportData.push({
//                   "Yojana Name": yojana?.GramYojnaName || "",
//                   "Yojana Amount": member?.Amount || "",
//                   "Member Name": member?.MemberName || "",
//                 });
//               });
//             });
//           }
//         });
//         if (exportData.length === 0) return notifyError("No Member Yojana Details Found");
//         exportToExcel(exportData, "Member_Yojana_List");
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   const handleSelectYojanaChange = (head) => {
//     const headData = {
//       FamilyHeadMasterID: head?.FamilyHeadMasterID || "",
//       FamilyMemberDetailID: "",
//       ContactDetailID: head?.ContactDetailID || "",
//       VoterID: head?.VoterID?.toString() || "",
//       FullNameEnglish: head?.FullNameEnglish || "",
//       FullNameGujarati: head?.FullNameGujarati || "",
//       MobileNo: head?.MobileNo || "",
//       Age: head?.Age || "",
//       Gender: head?.Gender || "",
//     };
//     const memberDetails = [
//       ...(head?.FamilyMemberDetails?.map((ele) => ({
//         FamilyMemberDetailID: ele?.FamilyMemberDetailID,
//         FamilyHeadMasterID: ele?.FamilyHeadMasterID || "",
//         ContactDetailID: ele?.ContactDetailID || "",
//         VoterID: ele?.VoterID?.toString() || "",
//         Type: ele?.Type || "",
//         FullNameEnglish: ele?.FullNameEnglish || "",
//         FullNameGujarati: ele?.FullNameGujarati || "",
//         LocalityEnglish: ele?.LocalityEnglish || "",
//         PartNameEnglish: ele?.PartNameEnglish || "",
//         MobileNo: ele?.MobileNo || "",
//         Age: ele?.Age || "",
//         Gender: ele?.Gender || "",
//         NotVoter: ele?.NotVoter || "",
//         Death: ele?.Death || "",
//         OutSide: ele?.OutSide || "",
//         Handicap: ele?.Handicap || "",
//         IDCardNo: ele?.IDCardNo || "",
//         SLNo: ele?.SLNo || "",
//       })) || []),
//       headData,
//     ];

//     setMemberDetails(memberDetails);
//     setYojanaSelectModal(true);
//     setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//     setMemberYojanaDetail(head?.MemberYojnaDetails);
//   };

//   const handleEditMemberYojanaDetail = (head, idx, GramYojnaMemberID) => {
//     const memberDetail = head?.MemberYojnaDetails?.[idx]?.MemberDetails?.find((ele) => ele?.GramYojnaMemberID?.toString() === GramYojnaMemberID.toString());
//     console.log("checkingTheValueOfMemberDetail", head, memberDetail, idx, GramYojnaMemberID);
//     const updatedMemberDetail = {
//       GramYojnaMemberID: memberDetail?.GramYojnaMemberID,
//       GramYojnaID: head?.MemberYojnaDetails?.[idx]?.GramYojnaID,
//       GramYojnaName: head?.MemberYojnaDetails?.[idx]?.GramYojnaName,
//       GramYojnaAmountDetailID: null,
//       Amount: memberDetail?.Amount.toString(),
//       MemberName: memberDetail?.MemberName,
//       IsAmount: memberDetail?.IsAmount,
//       IsAmountEnterByUser: memberDetail?.IsAmountEnterByUser,
//       TimePeriod: memberDetail?.TimePeriod,
//       IsMultiple: memberDetail?.IsMultiple,
//     };
//     setSelectedEditMemberDetail(updatedMemberDetail);
//     setIsEditMemberDetailModalOpen(true);
//   };

//   const handleYojanaSelectClose = () => {
//     setYojanaSelectModal(false);
//     setMemberDetails([]);
//     setFamilyHeadMasterID("");
//     setMemberYojanaDetail([]);
//     setSelectedEditGramYojanaID(null);
//   };

//   const handleShowHideYojanaDetails = (id) => {
//     setOpenYojanaDetails((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const handleCloseEditMemberDetail = () => {
//     setSelectedEditMemberDetail({});
//     setIsEditMemberDetailModalOpen(false);
//   };

//   console.log("sdfksldfjdkslafjksafjasdf", memberDetails);
//   return (
//     <>
//       <FilterMemberList filterData={filterData} filterRef={filterRef} filterStatus={filterStatus} setFilterStatus={setFilterStatus} setFilterData={setFilterData} />

//       <div className="flex-grow-1 w-100">
//         {isLoading || isError || isFetching ? (
//           <TableShimmer theme={DarkTheme ? "dark" : "light"} />
//         ) : (
//           <div className="flex-grow-1 py-0 px-2 w-100">
//             <div className="row g-6 mb-6">
//               <div className="col-sm-12 col-xl-12">
//                 <div className="card">
//                   <div className="card-datatable">
//                     <div id="DataTables_Table_0_wrapper" className="dt-container dt-bootstrap5 dt-empty-footer">
//                       <div className="justify-content-between dt-layout-table px-4">
//                         <div className="d-md-flex justify-content-between align-items-center dt-layout-full table-responsive">
//                           <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
//                             <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />

//                             {/* TOP: PRINT ALL YOJANAS */}
//                             <button
//                               onClick={handlePrintAllYojanas}
//                               disabled={preparingAllPrint || isExporting}
//                               className="btn btn-danger btn-sm d-flex align-items-center gap-2 ms-3"
//                             >
//                               <Printer size={18} />
//                               {preparingAllPrint ? "Preparing..." : "Print All Yojanas"}
//                             </button>

//                             <div className="dt-buttons btn-group flex-md-row flex-column d-flex gap-3 mb-md-0 mb-4">
//                               <TableFilterButton handleFilterStatusToggle={handleFilterStatusToggle} />
//                               <ExcelButton
//                                 isExportingMain={isExporting}
//                                 isExportingSecondary={isExporting}
//                                 handleExportMain={handleExport}
//                                 primaryExcel="Member Details"
//                                 handleExportSecondary={handleYojanaExport}
//                                 secondaryExcel="Yojana Details"
//                               />
//                             </div>
//                           </div>

//                           <table className="datatables-users Merge-List table dataTable dtr-column" id="DataTables_Table_0">
//                             <thead className="table-header-light border-top">
//                               <tr>
//                                 <th rowSpan={2}>Sr No</th>
//                                 <th rowSpan={2}>Yojana Details</th>
//                                 <th rowSpan={2} style={{ width: "20%", verticalAlign: "middle" }}>
//                                   <Home size={16} className="me-1" />
//                                   Head & Address
//                                 </th>
//                                 <th colSpan={8} className="text-center">
//                                   <Users size={16} className="me-1" />
//                                   Member Details
//                                 </th>
//                                 {/* <th rowSpan={2}>Print Yojana</th> */}
//                               </tr>
//                               <tr>
//                                 <th>Name</th>
//                                 <th>Mobile</th>
//                                 <th>Gender</th>
//                                 <th>Age</th>
//                                 <th>Non Voter</th>
//                                 <th>Death</th>
//                                 <th>Remove</th>
//                                 <th>Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {pages[currentPage]?.data?.map((head, headIndex) => {
//                                 const hasMembers = head.FamilyMemberDetails?.length > 0;
//                                 const absoluteIndex = currentPage * rowsPerPage + headIndex + 1;

//                                 return (
//                                   <React.Fragment key={`head-${headIndex}`}>
//                                     {hasMembers ? (
//                                       <>
//                                         {head.FamilyMemberDetails.map((ele, memberIndex) => (
//                                           <tr key={`${headIndex}-${memberIndex}`}>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {absoluteIndex}
//                                                 </td>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {head.MemberYojnaDetails?.length > 0 && (
//                                                     <i
//                                                       onClick={() => handleShowHideYojanaDetails(head.FamilyHeadMasterID)}
//                                                       className={`icon-base ti tabler-${yojanaDetails[head.FamilyHeadMasterID] ? "chevron-down" : "chevron-right"
//                                                         } icon-md cursor-pointer scaleX-n1-rtl`}
//                                                     />
//                                                   )}
//                                                 </td>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {head.FullNameEnglish}
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Village:</strong> {head.PartNameEnglish}
//                                                   </span>
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Locality:</strong> {head.LocalityEnglish}
//                                                   </span>
//                                                   <br />
//                                                   <br />
//                                                   <div className="d-flex gap-2">
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Death</span>
//                                                       </strong>
//                                                     </label>
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Non Voter</span>
//                                                       </strong>
//                                                     </label>
//                                                   </div>
//                                                   <br />
//                                                   {head?.OverAllFamilyAmount && (
//                                                     <div>
//                                                       <strong>OverAll Yojana Amount: </strong>
//                                                       <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                                     </div>
//                                                   )}
//                                                   <br />
//                                                   {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                                 </td>
//                                               </>
//                                             )}
//                                             <td>
//                                               {ele.FullNameEnglish}
//                                               <br />
//                                               <br />
//                                               {`${ele?.IsHandicap === "true" ? "Handicap" : ""}${ele?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                             </td>
//                                             <td>{ele.MobileNo ? `+91 ${ele.MobileNo}` : ""}</td>
//                                             <td>
//                                               {ele.Gender?.toLowerCase() === "f" ? (
//                                                 <span className="gender-badge female">Female</span>
//                                               ) : ele.Gender?.toLowerCase() === "m" ? (
//                                                 <span className="gender-badge male">Male</span>
//                                               ) : (
//                                                 <span className="gender-badge unknown">N/A</span>
//                                               )}
//                                             </td>
//                                             <td>{ele.Age}</td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "NotVoter", !ele?.NotVoter)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "Death", !ele?.Death)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <Trash2 size={20} color="purple" style={{ cursor: "pointer" }} onClick={() => handleDeleteMember(ele)} />
//                                             </td>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="text-center align-top p-2">
//                                                   <div className="d-flex flex-column gap-2">
//                                                     <button
//                                                       className="btn btn-sm btn-outline-primary fw-semibold"
//                                                       onClick={() => {
//                                                         setAddNewVoterShow(true);
//                                                         setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                       }}
//                                                     >
//                                                       + Add New Voter
//                                                     </button>
//                                                     <button
//                                                       className="btn btn-sm btn-outline-success fw-semibold"
//                                                       onClick={() => {
//                                                         setSelectedVillage(head?.PartNameEnglish);
//                                                         setSelectedLocality(head?.LocalityEnglish);
//                                                         setIsAddExistingModalOpen(true);
//                                                         setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                       }}
//                                                     >
//                                                       Add Existing Voter
//                                                     </button>
//                                                     <button
//                                                       className="btn btn-sm btn-outline-warning fw-semibold"
//                                                       onClick={() => {
//                                                         setChangeHeadData(head);
//                                                         setIsChangeHeadOpen(true);
//                                                         setFamilyHeadMasterID(head.FamilyHeadMasterID);
//                                                         setHeadData({
//                                                           ContactDetailID: head?.ContactDetailID,
//                                                           VoterID: head?.VoterID,
//                                                           IsHead: false,
//                                                           IsHandicap: head?.IsHandicap,
//                                                           IsOutSide: head?.IsOutSide,
//                                                         });
//                                                       }}
//                                                     >
//                                                       Change Head
//                                                     </button>
//                                                     <button
//                                                       className="btn btn-sm btn-outline-danger fw-semibold d-flex align-items-center gap-1"
//                                                       onClick={() => handleSelectYojanaChange(head)}
//                                                     >
//                                                       <List size={16} /> Yojana
//                                                     </button>
//                                                     {head.MemberYojnaDetails?.length > 0 && (
//                                                       <button onClick={() => printSingleYojana(head)} className="btn btn-sm btn-success d-flex align-items-center gap-1">
//                                                         <Printer size={14} /> Print
//                                                       </button>
//                                                     )}
//                                                   </div>
//                                                 </td>
//                                                 {/* PER FAMILY PRINT BUTTON */}
//                                                 {/* <td rowSpan={head.FamilyMemberDetails.length} className="text-center align-top p-2">
//                                                   {head.MemberYojnaDetails?.length > 0 && (
//                                                     <button
//                                                       onClick={() => printSingleYojana(head)}
//                                                       className="btn btn-sm btn-success d-flex align-items-center gap-1"
//                                                     >
//                                                       <Printer size={14} /> Print
//                                                     </button>
//                                                   )}
//                                                 </td> */}
//                                               </>
//                                             )}
//                                           </tr>
//                                         ))}
//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.FamilyHeadMasterID] && (
//                                             <motion.tr
//                                               initial={{ opacity: 0, height: 0 }}
//                                               animate={{ opacity: 1, height: "auto" }}
//                                               exit={{ opacity: 0, height: 0 }}
//                                               style={{ background: "#f7f7f7" }}
//                                             >
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana?.GramYojnaName}</td>
//                                                             {/* <td style={{ whiteSpace: "pre-line" }}>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <>
//                                                                   <span>
//                                                                     {inx + 1}
//                                                                     {") "}
//                                                                     {ele?.MemberName}{" "}
//                                                                   </span>
//                                                                   <br />
//                                                                 </>
//                                                               ))}
//                                                             </td> */}
//                                                             {/* <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "2px 0",
//                                                                   }}
//                                                                 >
//                                                                   <span>
//                                                                     {inx + 1}) {ele?.MemberName}
//                                                                   </span>

//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => {
//                                                                         handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID);
//                                                                         // setSelectedEditGramYojanaID(yojana?.GramYojnaID);
//                                                                       }}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td> */}
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   {/* Left side */}
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName}
//                                                                     </span>
//                                                                     {/* <small style={{ color: "#6c757d" }}>
//                                                                       <strong>Entry Date:</strong>
//                                                                       {ele?.GramYojnaMemberEntryDate ? new Date(ele.GramYojnaMemberEntryDate).toLocaleDateString() : "-"}
//                                                                     </small> */}
//                                                                     {/* <small className="entry-date">
//                                                                       <strong>Entry Date:</strong> {ele?.GramYojnaMemberEntryDate ? ele.GramYojnaMemberEntryDate : "-"}
//                                                                     </small> */}
//                                                                   </div>

//                                                                   {/* Right side */}
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>

//                                                             {/* <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <>
//                                                                   <span>
//                                                                     <span className="custom-font indian-currency">
//                                                                       {ele.IsAmount
//                                                                         ? ele?.TimePeriod && ele?.TimePeriod != "1"
//                                                                           ? toIndianCurrency(parseInt(ele?.Amount || 0)) + " × " + ele?.TimePeriod
//                                                                           : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                     </span>{" "}
//                                                                   </span>
//                                                                   <br />
//                                                                 </>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod == "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                 ? " ( દર વર્ષે ) "
//                                                                 : ""}
//                                                             </td> */}
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div key={inx} className="member-row amount-row">
//                                                                   <span className="custom-font indian-currency">
//                                                                     {ele.IsAmount
//                                                                       ? ele?.TimePeriod && ele?.TimePeriod !== "1"
//                                                                         ? `${toIndianCurrency(parseInt(ele?.Amount || 0))} × ${ele?.TimePeriod}`
//                                                                         : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                       : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                   </span>
//                                                                 </div>
//                                                               ))}

//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod === "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : ""}
//                                                             </td>

//                                                             <td>
//                                                               <span className="custom-font indian-currency">
//                                                                 {yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? toIndianCurrency(yojana.Amount)
//                                                                   : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                                                                     ? toIndianCurrency(yojana.Amount)
//                                                                     : `${yojana?.MemberDetails.length} સંખ્યા`}
//                                                               </span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     ) : (
//                                       /* NO MEMBERS CASE */
//                                       <>
//                                         <tr>
//                                           <td>{absoluteIndex}</td>
//                                           <td>
//                                             {head.MemberYojnaDetails?.length > 0 && (
//                                               <i
//                                                 onClick={() => handleShowHideYojanaDetails(head.FamilyHeadMasterID)}
//                                                 className={`icon-base ti tabler-${yojanaDetails[head.FamilyHeadMasterID] ? "chevron-down" : "chevron-right"
//                                                   } icon-md cursor-pointer scaleX-n1-rtl`}
//                                               />
//                                             )}
//                                           </td>
//                                           <td>
//                                             {head.FullNameEnglish}
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Village:</strong> {head.PartNameEnglish}
//                                             </span>
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Locality:</strong> {head.LocalityEnglish}
//                                             </span>
//                                             <br />
//                                             <br />
//                                             <div className="d-flex gap-2">
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Death</span>
//                                                 </strong>
//                                               </label>
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Non Voter</span>
//                                                 </strong>
//                                               </label>
//                                             </div>
//                                             <br />
//                                             {head?.OverAllFamilyAmount && (
//                                               <div>
//                                                 <strong>OverAll Yojana Amount: </strong>
//                                                 <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                               </div>
//                                             )}
//                                             <br />
//                                             {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                           </td>
//                                           <td colSpan={7} style={{ textAlign: "center", color: "#999" }}>
//                                             No members found
//                                           </td>
//                                           <td className="text-center align-top p-2">
//                                             <div className="d-flex flex-column gap-2">
//                                               <button
//                                                 className="btn btn-sm btn-outline-primary fw-semibold"
//                                                 onClick={() => {
//                                                   setAddNewVoterShow(true);
//                                                   setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                 }}
//                                               >
//                                                 + Add New Voter
//                                               </button>
//                                               <button
//                                                 className="btn btn-sm btn-outline-success fw-semibold"
//                                                 onClick={() => {
//                                                   setSelectedVillage(head?.PartNameEnglish);
//                                                   setSelectedLocality(head?.LocalityEnglish);
//                                                   setIsAddExistingModalOpen(true);
//                                                   setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                 }}
//                                               >
//                                                 Add Existing Voter
//                                               </button>
//                                               <button
//                                                 className="btn btn-sm btn-outline-danger fw-semibold d-flex align-items-center gap-1"
//                                                 onClick={() => handleSelectYojanaChange(head)}
//                                               >
//                                                 <List size={16} /> Yojana
//                                               </button>
//                                               {head.MemberYojnaDetails?.length > 0 && (
//                                                 <button onClick={() => printSingleYojana(head)} className="btn btn-sm btn-success d-flex align-items-center gap-1">
//                                                   <Printer size={14} /> Print
//                                                 </button>
//                                               )}
//                                             </div>
//                                           </td>
//                                           {/* PRINT BUTTON FOR NO-MEMBER FAMILY */}
//                                           {/* <td className="text-center align-top p-2">
//                                             {head.MemberYojnaDetails?.length > 0 && (
//                                               <button
//                                                 onClick={() => printSingleYojana(head)}
//                                                 className="btn btn-sm btn-success d-flex align-items-center gap-1"
//                                               >
//                                                 <Printer size={14} /> Print
//                                               </button>
//                                             )}
//                                           </td> */}
//                                         </tr>
//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.FamilyHeadMasterID] && (
//                                             <motion.tr style={{ background: "#f7f7f7" }}>
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana.GramYojnaName}</td>
//                                                             {/* <td style={{ whiteSpace: "pre-line" }}>
//                                                               {yojana.MemberNames?.split(",")
//                                                                 .map((m, i) => `${i + 1}) ${m.trim()}`)
//                                                                 .join("\n")}
//                                                             </td> */}
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   {/* Left side */}
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName}
//                                                                     </span>
//                                                                     {/* <small style={{ color: "#6c757d" }}>
//                                                                       <strong>Entry Date:</strong>
//                                                                       {ele?.GramYojnaMemberEntryDate ? new Date(ele.GramYojnaMemberEntryDate).toLocaleDateString() : "-"}
//                                                                     </small> */}
//                                                                     <small className="entry-date">
//                                                                       <strong>Entry Date:</strong> {ele?.GramYojnaMemberEntryDate ? ele?.GramYojnaMemberEntryDate : "-"}
//                                                                     </small>
//                                                                   </div>

//                                                                   {/* Right side */}
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <>
//                                                                   <span>
//                                                                     <span className="custom-font indian-currency">
//                                                                       {ele.IsAmount
//                                                                         ? ele?.TimePeriod && ele?.TimePeriod != "1"
//                                                                           ? toIndianCurrency(parseInt(ele?.Amount || 0)) + " × " + ele?.TimePeriod
//                                                                           : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : ele.IsAmountEnterByUser
//                                                                           ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                           : "1"}
//                                                                     </span>{" "}
//                                                                   </span>
//                                                                   <br />
//                                                                 </>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod == "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : ""}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">{toIndianCurrency(yojana.Amount)}</span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     )}

//                                     {/* HIDDEN SINGLE PRINT */}
//                                     {head.MemberYojnaDetails?.length > 0 && (
//                                       <div style={{ display: "none" }}>
//                                         <PrintableSingleYojana ref={(el) => (singlePrintRefs.current[head.FamilyHeadMasterID] = el)} head={head} />
//                                       </div>
//                                     )}
//                                   </React.Fragment>
//                                 );
//                               })}
//                             </tbody>
//                           </table>

//                           <div className="row mx-3 justify-content-between">
//                             <PageEntries start={start} end={end} totalCount={totalCount} />
//                             <PaginationButtons
//                               currentPage={currentPage}
//                               setCurrentPage={setCurrentPage}
//                               goToPage={goToPage}
//                               pages={pages}
//                               hasNextPage={hasNextPage}
//                               fetchNextPage={fetchNextPage}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* HIDDEN ALL YOJANA PRINT */}
//       <div style={{ display: "none" }}>
//         <PrintableAllYojanas ref={allYojanaPrintRef} data={allYojanaData} />
//       </div>

//       {/* MODALS */}
//       <AddNewVoter show={addNewVoterShow} onClose={handleAddNewVoterClose} refetch={refetch} familyHeadMasterID={familyHeadMasterID} />
//       <ChangeHeadModal
//         show={isChangeHeadOpen}
//         data={changeHeadData}
//         handleClose={handleChangeHeadClose}
//         familyHeadMasterID={familyHeadMasterID}
//         refetch={refetch}
//         headData={headData}
//         statusType={statusType}
//         deadNonVoterHeadID={deadNonVoterHeadID}
//       />
//       <AddExistingVoter
//         show={isAddExistingModalOpen}
//         selectedVillage={selectedVillage}
//         selectedLocality={selectedLocality}
//         handleClose={handleCloseAddExistingModal}
//         selectedRecords={selectedRecords}
//         setSelectedRecords={setSelectedRecords}
//         refetchMemberList={refetch}
//         familyHeadMasterID={familyHeadMasterID}
//       />
//       <YojanaSelect
//         selectedEditGramYojanaID={selectedEditGramYojanaID}
//         memberDetails={memberDetails}
//         show={yojanaSelectModalOpen}
//         handleClose={handleYojanaSelectClose}
//         familyHeadMasterID={familyHeadMasterID}
//         memberYojanaDetail={memberYojanaDetail}
//         refetchMemberList={refetch}
//       />

//       <EditYojanaMemberDetail
//         selectedEditMemberDetail={selectedEditMemberDetail}
//         open={isEditMemberDetailModalOpen}
//         onClose={handleCloseEditMemberDetail}
//         refetchMemberList={refetch}
//       />

//       {(inserting || deleting || changeHeadInserting || preparingAllPrint || isExporting) && <Loader />}
//     </>
//   );
// };

// export default ViewMemberList;

// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { AnimatePresence, motion } from "framer-motion";
// import Cookies from "js-cookie";
// import { Home, List, Printer, Trash2, User, UserCheck, Users } from "lucide-react";
// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";
// import { toast } from "react-toastify";
// import Swal from "sweetalert2";
// import { useDeleteMember } from "../../API_Master/DeleteMutateAPI";
// import { useMemberListExportExcel } from "../../API_Master/ExcelAPI";
// import { useMemberListDataPagination } from "../../API_Master/FetchAPI";
// import { useNotVoterDeath, useSetChangeHead } from "../../API_Master/MutateAPI";
// import ExcelButton from "../../CommonComponents/ExcelButton";
// import Loader from "../../CommonComponents/Loader";
// import PageCountSelect from "../../CommonComponents/PageCountSelect";
// import PageEntries from "../../CommonComponents/PageEntries";
// import PaginationButtons from "../../CommonComponents/PaginationButtons";
// import TableFilterButton from "../../CommonComponents/TableFilterButton";
// import TableShimmer from "../../Components/TableShimmer";
// import { deleteConfirmation, exportToExcel, notifyError, notifySuccess, toIndianCurrency } from "../../MethodMaster/JSXComponentMothod";
// import { toggleOffcanvasStatus } from "../../Redux/Slices/ProjectSlice";
// import AddExistingVoter from "../AddExistingVoter/inde";
// import AddNewVoter from "../AddNewVoter";
// import ChangeHeadModal from "../ChangeHeadModal";
// import EditYojanaMemberDetail from "../EditYojanaMemberDetail";
// import YojanaSelect from "../YojanaSelect";
// import FilterMemberList from "./FilterMemberList";

// /* ============================================================
//    BEAUTIFUL TAB STYLES
//    ============================================================ */
// const TabStyles = () => (
//   <style>{`
//     .member-list-tabs {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 8px;
//       padding: 6px;
//       margin: 16px 16px 0;
//       background: #f1f3f9;
//       border-radius: 14px;
//       box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
//       list-style: none;
//       flex-wrap: wrap;
//     }
//     .member-list-tabs .tab-btn {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 10px;
//       border: none;
//       outline: none;
//       cursor: pointer;
//       padding: 10px 20px;
//       border-radius: 10px;
//       font-weight: 600;
//       font-size: 14px;
//       letter-spacing: 0.2px;
//       color: #5a6478;
//       background: transparent;
//       transition: color 0.25s ease, transform 0.2s ease, background 0.25s ease;
//     }
//     .member-list-tabs .tab-btn:hover:not(.active) {
//       color: #3b5bdb;
//       background: rgba(99, 132, 255, 0.08);
//     }
//     .member-list-tabs .tab-btn.active {
//       color: #ffffff;
//       background: linear-gradient(135deg, #5b8def 0%, #3b5bdb 100%);
//       box-shadow: 0 8px 18px -6px rgba(59, 91, 219, 0.55),
//                   0 2px 6px -1px rgba(59, 91, 219, 0.35);
//       transform: translateY(-1px);
//     }
//     .member-list-tabs .tab-btn.active.alt {
//       background: linear-gradient(135deg, #f59f4b 0%, #e8590c 100%);
//       box-shadow: 0 8px 18px -6px rgba(232, 89, 12, 0.55),
//                   0 2px 6px -1px rgba(232, 89, 12, 0.35);
//     }
//     .member-list-tabs .tab-icon {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       width: 26px;
//       height: 26px;
//       border-radius: 50%;
//       background: rgba(59, 91, 219, 0.12);
//       color: #3b5bdb;
//       transition: all 0.25s ease;
//     }
//     .member-list-tabs .tab-btn.active .tab-icon {
//       background: rgba(255, 255, 255, 0.25);
//       color: #ffffff;
//     }
//     .member-list-tabs .tab-badge {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       min-width: 24px;
//       height: 22px;
//       padding: 0 8px;
//       border-radius: 11px;
//       font-size: 12px;
//       font-weight: 700;
//       background: #ffffff;
//       color: #3b5bdb;
//       box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
//     }
//     .member-list-tabs .tab-btn.active .tab-badge {
//       background: rgba(255, 255, 255, 0.95);
//       color: #3b5bdb;
//     }
//     .member-list-tabs .tab-btn.active.alt .tab-badge {
//       color: #e8590c;
//     }
//     .member-list-tabs .tab-btn:disabled {
//       opacity: 0.55;
//       cursor: not-allowed;
//     }
//     .theme-dark .member-list-tabs {
//       background: #2a2f3a;
//       box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
//     }
//     .theme-dark .member-list-tabs .tab-btn { color: #b8c0d0; }
//     .theme-dark .member-list-tabs .tab-btn:hover:not(.active) {
//       color: #8da9ff;
//       background: rgba(141, 169, 255, 0.1);
//     }
//     .theme-dark .member-list-tabs .tab-icon {
//       background: rgba(141, 169, 255, 0.15);
//       color: #8da9ff;
//     }
//   `}</style>
// );

// /* ============================================================
//    PRINT COMPONENTS (unchanged)
//    ============================================================ */
// const PrintableSingleYojana = React.forwardRef(({ head }, ref) => {
//   return (
//     <div
//       ref={ref}
//       style={{
//         padding: "30px 50px",
//         fontFamily: "Arial, sans-serif",
//         background: "white",
//         color: "#000",
//       }}
//     >
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h3>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>૧૫૫ - ઓલપાડ વિધાનસભા</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ textAlign: "center", color: "#555", fontSize: "16px", marginBottom: "20px" }}>
//         Village: {head.PartNameEnglish} | Locality: {head.LocalityEnglish}
//       </p>

//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "15px",
//           tableLayout: "fixed",
//           marginBottom: "40px",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "43%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>
//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th>No</th>
//             <th>Yojana Name</th>
//             <th>Member & Amount</th>
//             <th>Total Amount</th>
//           </tr>
//         </thead>
//         <tbody>
//           {head.MemberYojnaDetails?.map((yojana, i) => {
//             const memberDetails = yojana.MemberDetails ?? [];
//             const maxNameLen = Math.max(...memberDetails.map((m) => m?.MemberName?.trim().length || 0));
//             const memberList = memberDetails.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const paddedName = name.padEnd(maxNameLen + 2);
//               const amtText = m.IsAmount
//                 ? m?.TimePeriod && m.TimePeriod !== "1"
//                   ? `${amount} × ${m.TimePeriod}`
//                   : amount
//                 : m.IsAmountEnterByUser
//                   ? toIndianCurrency(parseInt(m?.Amount || 0))
//                   : "1";
//               const entryDate = m.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${paddedName} ${amtText}\n   Entry Date: ${entryDate}`;
//             });
//             return (
//               <tr key={i} style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
//                 <td>{i + 1}</td>
//                 <td style={{ fontFamily: "monospace" }}>{yojana.GramYojnaName}</td>
//                 <td
//                   style={{
//                     border: "1px solid #333",
//                     padding: "8px",
//                     whiteSpace: "pre-line",
//                     fontFamily: "monospace",
//                     verticalAlign: "top",
//                   }}
//                 >
//                   {memberList.join("\n")}
//                   <br />
//                   {yojana?.MemberDetails?.[0]?.TimePeriod === "12" ? " ( દર માસ ) " : yojana?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ textAlign: "right", fontFamily: "monospace" }}>
//                   {yojana?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(yojana.Amount)
//                     : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(yojana.Amount)
//                       : `${yojana?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr style={{ backgroundColor: "#FFF3E0", fontWeight: "bold" }}>
//             <td colSpan={3} style={{ textAlign: "right" }}>
//               Total Amount
//             </td>
//             <td style={{ textAlign: "right" }}>{toIndianCurrency(head.OverAllFamilyAmount || 0)}</td>
//           </tr>
//         </tfoot>
//       </table>

//       <style jsx>{`
//         @media print {
//           @page {
//             margin: 1cm;
//           }
//           body {
//             -webkit-print-color-adjust: exact;
//             print-color-adjust: exact;
//           }
//           tr {
//             page-break-inside: avoid !important;
//             break-inside: avoid !important;
//           }
//           table {
//             page-break-after: auto;
//           }
//           .no-print {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// });

// const ORIENTATION = "landscape";
// const PAGE_WIDTH_MM = ORIENTATION === "landscape" ? 297 : 210;
// const PAGE_HEIGHT_MM = ORIENTATION === "landscape" ? 210 : 297;
// const TOP_MARGIN_MM = 15;
// const BOTTOM_MARGIN_MM = 15;
// const LEFT_MARGIN_MM = 20;
// const RIGHT_MARGIN_MM = 20;
// const PRINTABLE_HEIGHT_MM = PAGE_HEIGHT_MM - TOP_MARGIN_MM - BOTTOM_MARGIN_MM;
// const PRINTABLE_WIDTH_MM = PAGE_WIDTH_MM - LEFT_MARGIN_MM - RIGHT_MARGIN_MM;
// const PX_TO_MM = 96 / 25.4;

// const PrintableAllYojanas = React.forwardRef(({ data }, ref) => {
//   const [pageGroups, setPageGroups] = useState([]);
//   const measureRef = useRef(null);

//   useEffect(() => {
//     if (!measureRef.current || !data.length) return;
//     const blocks = measureRef.current.querySelectorAll(".print-block");
//     const heightsPx = Array.from(blocks).map((b) => b.offsetHeight);
//     const printablePx = PRINTABLE_HEIGHT_MM * PX_TO_MM;

//     const groups = [];
//     let curGroup = [];
//     let curHeight = 0;

//     data.forEach((item, i) => {
//       const blockHeight = heightsPx[i];
//       const gap = i === 0 ? 0 : 30;
//       if (curHeight + gap + blockHeight > printablePx && curGroup.length) {
//         groups.push(curGroup);
//         curGroup = [item];
//         curHeight = blockHeight;
//       } else {
//         curGroup.push(item);
//         curHeight += gap + blockHeight;
//       }
//     });
//     if (curGroup.length) groups.push(curGroup);
//     setPageGroups(groups);
//   }, [data]);

//   return (
//     <div ref={ref} style={{ background: "white", fontFamily: "Arial, sans-serif" }}>
//       <div
//         ref={measureRef}
//         style={{
//           padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//           visibility: "hidden",
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: `${PRINTABLE_WIDTH_MM}mm`,
//         }}
//       >
//         {data.map((item, idx) => (
//           <PrintBlock key={idx} item={item} />
//         ))}
//       </div>

//       {pageGroups.map((group, pageIdx) => (
//         <div
//           key={pageIdx}
//           className="print-page"
//           style={{
//             width: `${PAGE_WIDTH_MM}mm`,
//             minHeight: `${PAGE_HEIGHT_MM}mm`,
//             padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//             pageBreakAfter: pageIdx < pageGroups.length - 1 ? "always" : "auto",
//             boxSizing: "border-box",
//           }}
//         >
//           {group.map((item, idx) => (
//             <PrintBlock key={idx} item={item} isLastInGroup={idx === group.length - 1} />
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// });

// const PrintBlock = React.memo(({ item, isLastInGroup }) => {
//   const { head, yojanas } = item;

//   return (
//     <div className="print-block" style={{ marginBottom: isLastInGroup ? "0" : "30px", breakInside: "avoid" }}>
//       <h1 style={{ textAlign: "center", color: "#1A237E", fontSize: "32px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h1>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>૧૫૫ - ઓલપાડ વિધાનસભા</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ fontSize: "16px", marginBottom: "15px" }}>
//         <strong>Village:</strong> {head.PartNameEnglish} | <strong>Locality:</strong> {head.LocalityEnglish}
//       </p>

//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "14px",
//           tableLayout: "fixed",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "45%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>

//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th style={{ border: "1px solid #333", padding: "10px" }}>No</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Yojana</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Member & Amount</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Total Amount</th>
//           </tr>
//         </thead>

//         <tbody>
//           {yojanas.map((y, i) => {
//             const memberLines = y.MemberDetails?.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const entryDate = m?.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${name.padEnd(25)} - ${
//                 m.IsAmount ? (m?.TimePeriod && m?.TimePeriod != "1" ? amount + " × " + m?.TimePeriod : amount) : m.IsAmountEnterByUser ? amount : "1"
//               }\n  Entry Date -${entryDate} `;
//             });

//             return (
//               <tr key={i}>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "center", verticalAlign: "top", fontFamily: "monospace" }}>{i + 1}</td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", wordBreak: "break-word", verticalAlign: "top", fontFamily: "monospace" }}>
//                   {y.GramYojnaName}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
//                   {memberLines.join("\n")}
//                   <br />
//                   {y?.MemberDetails?.[0]?.TimePeriod == "12" ? " ( દર માસ ) " : y?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "right", verticalAlign: "top" }}>
//                   {y?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(y.Amount)
//                     : y?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(y.Amount)
//                       : `${y?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr>
//             <td colSpan={4} style={{ borderTop: "1px solid #000", padding: 0 }}></td>
//           </tr>
//           <tr>
//             <td
//               colSpan={3}
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//                 backgroundColor: "#FFF3E0",
//                 border: "1px solid #000",
//                 borderRight: "none",
//               }}
//             >
//               Total Amount
//             </td>
//             <td
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "15px",
//                 color: "#000",
//                 backgroundColor: "#FFF3E0",
//                 fontFamily: "monospace",
//                 border: "1px solid #000",
//               }}
//             >
//               {toIndianCurrency(head.OverAllFamilyAmount || 0)}
//             </td>
//           </tr>
//         </tfoot>
//       </table>

//       <style jsx>{`
//         @media print {
//           tfoot {
//             display: table-row-group;
//           }
//         }
//       `}</style>
//     </div>
//   );
// });

// /* ============================================================
//    MAIN COMPONENT
//    ============================================================ */
// const ViewMemberList = () => {
//   const { DarkTheme } = useSelector((state) => state.ProjectSlice);
//   const dispatch = useDispatch();

//   const [addNewVoterShow, setAddNewVoterShow] = useState(false);
//   const [changeHeadData, setChangeHeadData] = useState("");
//   const [isChangeHeadOpen, setIsChangeHeadOpen] = useState(false);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [filterData, setFilterData] = useState({});
//   const [familyHeadMasterID, setFamilyHeadMasterID] = useState("");
//   const [headData, setHeadData] = useState({});
//   const [statusType, setStatusType] = useState("");
//   const [deadNonVoterHeadID, setDeadNonVoterHeadID] = useState("");
//   const [selectedVillage, setSelectedVillage] = useState("");
//   const [selectedLocality, setSelectedLocality] = useState("");
//   const [isAddExistingModalOpen, setIsAddExistingModalOpen] = useState(false);
//   const [selectedRecords, setSelectedRecords] = useState({});
//   const [filterStatus, setFilterStatus] = useState(false);
//   const [memberDetails, setMemberDetails] = useState([]);
//   const [yojanaSelectModalOpen, setYojanaSelectModal] = useState(false);
//   const [memberYojanaDetail, setMemberYojanaDetail] = useState([]);
//   const [yojanaDetails, setOpenYojanaDetails] = useState({});
//   const { mutate: addNotVoterDeath, isPending: inserting } = useNotVoterDeath();
//   const [deadNonVoterMemberID, setDeadNonVoterMemberID] = useState("");
//   const [selectedEditGramYojanaID, setSelectedEditGramYojanaID] = useState(null);
//   const [selectedEditMemberDetail, setSelectedEditMemberDetail] = useState({});
//   const [isEditMemberDetailModalOpen, setIsEditMemberDetailModalOpen] = useState(false);

//   // Tab state - default "With Family"
//   const [isAssignFamily, setIsAssignFamily] = useState(true);

//   // PRINT REFS
//   const singlePrintRefs = useRef({});
//   const allYojanaPrintRef = useRef();
//   const triggerAllPrint = useRef(() => {});
//   const [allYojanaData, setAllYojanaData] = useState([]);
//   const [preparingAllPrint, setPreparingAllPrint] = useState(false);

//   const filterRef = useRef();

//   const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useMemberListDataPagination(rowsPerPage, filterData, isAssignFamily);
//   const { mutate: deleteMember, isLoading: deleting } = useDeleteMember();
//   const { mutate: addChangeHead, isPending: changeHeadInserting } = useSetChangeHead();
//   const { mutate: exportMemberList, isPending: isExporting } = useMemberListExportExcel();

//   const pages = data?.pages || [];
//   const totalCount = data?.pages[0]?.TotalCount || 0;
//   const start = currentPage * rowsPerPage + 1;
//   const end = Math.min(start + (pages[currentPage]?.data?.length || 0) - 1, totalCount);

//   // Merge tab into filter payload for exports / prints
//   const effectiveFilterData = { ...filterData, IsAssignFamily: isAssignFamily };

//   // Tab change handler
//   const handleTabChange = (value) => {
//     if (value === isAssignFamily) return;
//     setIsAssignFamily(value);
//     setCurrentPage(0);
//     setOpenYojanaDetails({});
//   };

//   // PRINT SINGLE FAMILY
//   const printSingleYojana = (head) => {
//     const node = singlePrintRefs.current[head.FamilyHeadMasterID];
//     if (!node) return;

//     const win = window.open("", "_blank");
//     win.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>${head.FullNameEnglish} - Yojana</title>
//           <style>
//             body { font-family: Arial, sans-serif; background: white; }
//             table { width: 100%; border-collapse: collapse; font-size: 14px; }
//             th, td { border: 1px solid #333; padding: 10px; text-align: left; }
//             th { background: #E8F5E8; }
//             .indian-currency::before { content: "₹"; }
//           </style>
//         </head>
//         <body>${node.innerHTML}</body>
//       </html>
//     `);
//     win.document.close();
//     win.focus();
//     win.print();
//     setTimeout(() => win.close(), 1000);
//   };

//   // PRINT ALL YOJANAS
//   const handlePrintAllYojanas = () => {
//     toast.dismiss();
//     setPreparingAllPrint(true);

//     exportMemberList(effectiveFilterData, {
//       onSuccess: (apiData) => {
//         const printData = apiData.filter((head) => head.MemberYojnaDetails?.length > 0).map((head) => ({ head, yojanas: head.MemberYojnaDetails }));

//         if (printData.length === 0) {
//           notifyError("No Yojana data found");
//           setPreparingAllPrint(false);
//           return;
//         }

//         setAllYojanaData(printData);
//         setTimeout(() => triggerAllPrint.current(), 300);
//       },
//       onError: () => {
//         notifyError("Print failed");
//         setPreparingAllPrint(false);
//       },
//     });
//   };

//   const printAllYojanas = useReactToPrint({
//     contentRef: allYojanaPrintRef,
//     documentTitle: `All_Yojanas_${new Date().toISOString().slice(0, 10)}`,
//     onAfterPrint: () => {
//       setPreparingAllPrint(false);
//       setAllYojanaData([]);
//     },
//   });

//   useEffect(() => {
//     triggerAllPrint.current = printAllYojanas;
//   }, [printAllYojanas]);

//   const handleRowsChange = async (e) => {
//     const limit = parseInt(e.target?.value);
//     setRowsPerPage(limit);
//     setCurrentPage(0);
//     await refetch();
//   };

//   const goToPage = async (index) => {
//     if (pages[index]) {
//       setCurrentPage(index);
//     } else if (hasNextPage) {
//       await fetchNextPage();
//       setCurrentPage(index);
//     }
//   };

//   const handleAddNewVoterClose = () => setAddNewVoterShow(false);

//   const handleChangeHeadClose = () => {
//     setIsChangeHeadOpen(false);
//     setChangeHeadData("");
//     setFamilyHeadMasterID("");
//     setHeadData({});
//     setStatusType("");
//   };

//   const handleCloseAddExistingModal = () => {
//     setSelectedVillage("");
//     setSelectedLocality("");
//     setSelectedRecords({});
//     setIsAddExistingModalOpen(false);
//     setFamilyHeadMasterID("");
//   };

//   const handleSetNonVoterDeath = (ele, StatusType, Status) => {
//     setDeadNonVoterMemberID(ele.ContactDetailID);
//     setStatusType(StatusType);
//     const payload = {
//       ContactDetailID: ele?.ContactDetailID || "",
//       StatusType: StatusType,
//       Death: StatusType === "Death" ? Status : false,
//       NotVoter: StatusType === "NotVoter" ? Status : false,
//       UpdatedByUserID: "",
//     };

//     Swal.fire({
//       title: "Are you sure?",
//       text: `You are marking this member as "${StatusType}".`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, proceed!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         addNotVoterDeath(payload, {
//           onSuccess: (res) => {
//             if (res?.status === true) {
//               notifySuccess("Successfully Inserted", false);
//               refetch();
//             } else {
//               notifyError(res?.message ? res.message : "Data Not Inserted", false);
//             }
//           },
//           onError: () => notifyError("Something went wrong", false),
//         });
//       } else {
//         setDeadNonVoterMemberID("");
//         setStatusType("");
//       }
//     });
//   };

//   const handleDeleteMember = async (item) => {
//     const result = await deleteConfirmation();
//     if (result?.isConfirmed) {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         ContactDetailID: item?.ContactDetailID || "",
//         FamilyMemberDetailID: item?.FamilyMemberDetailID || "",
//         VoterID: item?.VoterID || "",
//       };
//       deleteMember(payload, {
//         onSuccess: (res) => {
//           if (res?.status === true) {
//             notifySuccess("Deleted Successfully", DarkTheme ? true : false);
//             refetch();
//           } else {
//             notifyError(res?.message || "Not Deleted", DarkTheme ? true : false);
//           }
//         },
//         onError: () => notifyError("Something went wrong", false),
//       });
//     }
//   };

//   const handleDeathNotVoterChange = (head, StatusType) => {
//     setFamilyHeadMasterID(head.FamilyHeadMasterID);
//     setDeadNonVoterHeadID(head?.ContactDetailID);
//     setStatusType(StatusType);

//     if (head?.FamilyMemberDetails?.length > 0) {
//       setChangeHeadData(head);
//       setIsChangeHeadOpen(true);
//       setHeadData({
//         ContactDetailID: head?.ContactDetailID,
//         VoterID: head?.VoterID,
//         IsHead: false,
//         IsHandicap: head?.IsHandicap,
//         IsOutSide: head?.IsOutSide,
//       });
//     } else {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         FamilyHeadMasterID: familyHeadMasterID || "",
//         ContactDetailID: head?.ContactDetailID || "",
//         StatusType: StatusType,
//         Death: StatusType?.toLowerCase() === "death" ? true : false,
//         NotVoter: StatusType?.toLowerCase() === "notvoter" ? true : false,
//         FamilyDetail: [],
//       };

//       Swal.fire({
//         title: "Are you sure?",
//         text: `You are marking this head as "${StatusType}".`,
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, proceed!",
//       }).then((result) => {
//         if (result.isConfirmed) {
//           addChangeHead(payload, {
//             onSuccess: (res) => {
//               if (res?.status === true) {
//                 notifySuccess("Successfully Inserted", false);
//                 setFamilyHeadMasterID("");
//                 setStatusType("");
//                 setDeadNonVoterHeadID("");
//                 refetch();
//               } else {
//                 notifyError(res?.message || "Data Not Inserted", false);
//               }
//             },
//             onError: () => notifyError("Something went wrong", false),
//           });
//         } else {
//           setFamilyHeadMasterID("");
//           setDeadNonVoterHeadID("");
//           setStatusType("");
//         }
//       });
//     }
//   };

//   const handleFilterStatusToggle = () => {
//     setFilterStatus(true);
//     dispatch(toggleOffcanvasStatus(true));
//   };

//   const handleExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (MemberListData) => {
//         if (!MemberListData?.length) return notifyError("No Data Found");
//         exportToExcelWithYojanaTable(MemberListData);
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   async function exportToExcelWithYojanaTable(data) {
//     const workbook = new ExcelJS.Workbook();
//     const sheet = workbook.addWorksheet("Family Yojana Report", {
//       pageSetup: { paperSize: 9, orientation: "landscape" },
//     });

//     let rowIndex = 1;
//     let familySr = 1;

//     data.forEach((head) => {
//       const members = head.FamilyMemberDetails || [];
//       const headName = head.FullNameEnglish || "";
//       const village = head.PartNameEnglish || "";
//       const locality = head.LocalityEnglish || "";
//       const overAllAmount = head.OverAllFamilyAmount || 0;

//       const headerRow = sheet.getRow(rowIndex++);
//       headerRow.values = [familySr, headName, village, locality, `₹${Number(overAllAmount).toLocaleString("en-IN")}.00`];
//       headerRow.font = { bold: true, size: 12 };
//       headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6E6E6" } };

//       const memberHeader = sheet.getRow(rowIndex++);
//       memberHeader.values = ["", "Member Name", "Mobile", "Gender", "Age", "ID Card No", "SL No"];
//       memberHeader.font = { bold: true };
//       memberHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9EAD3" } };

//       members.forEach((member) => {
//         const row = sheet.getRow(rowIndex++);
//         row.values = [
//           "",
//           member.FullNameEnglish || "",
//           member.MobileNo || "",
//           member.Gender === "M" ? "Male" : "Female",
//           member.Age || "",
//           member.IDCardNo || "",
//           member.SLNo || "",
//         ];
//       });

//       const yojanaHeader = sheet.getRow(rowIndex++);
//       if (head?.MemberYojnaDetails?.length) {
//         yojanaHeader.values = ["", "Yojana Name", "Members (with Amount)", "Total Amount"];
//         yojanaHeader.font = { bold: true, color: { argb: "FFFFFFFF" } };
//         yojanaHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4CAF50" } };
//       }

//       (head.MemberYojnaDetails || []).forEach((yojna) => {
//         const yojnaName = yojna.GramYojnaName || "";
//         const yojnaTotal = yojna.Amount || "0";
//         const details = yojna.MemberDetails || [];

//         const memberList = details
//           .map((d, i) => {
//             const name = d.MemberName || "Unknown";
//             const amt = d.IsAmount
//               ? d?.TimePeriod && d?.TimePeriod != "1"
//                 ? toIndianCurrency(parseInt(d?.Amount || 0)) + " × " + d?.TimePeriod
//                 : toIndianCurrency(parseInt(d?.Amount || 0))
//               : d.IsAmountEnterByUser
//                 ? toIndianCurrency(parseInt(d?.Amount || 0))
//                 : "1";
//             const entryDate = d?.GramYojnaMemberEntryDate;
//             return `${i + 1}) ${name} (${amt})\n   Entry Date: ${entryDate}`;
//           })
//           .join("\n");

//         const firstRow = sheet.getRow(rowIndex++);
//         firstRow.values = [
//           "",
//           yojnaName,
//           memberList + `${details?.[0]?.TimePeriod == "12" ? "\n ( દર માસ ) " : details?.[0]?.IsAmount ? "\n  ( દર વર્ષે ) " : ""}`,
//           details?.[0]?.IsAmount ? toIndianCurrency(yojnaTotal) : details?.[0]?.IsAmountEnterByUser ? toIndianCurrency(yojnaTotal) : `${details?.length} સંખ્યા`,
//         ];
//         firstRow.getCell(2).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(3).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(4).alignment = { vertical: "middle" };
//         const lines = memberList.split("\n").length;
//         if (lines > 1) {
//           for (let i = 1; i < lines; i++) {
//             const extraRow = sheet.getRow(rowIndex);
//             extraRow.values = ["", "", "", ""];
//             extraRow.getCell(3).value = { formula: `C${rowIndex - lines}` };
//           }
//         }
//         sheet.getRow(rowIndex++).height = 15;
//       });

//       familySr++;
//     });

//     sheet.columns = [{ width: 8 }, { width: 40 }, { width: 40 }, { width: 30 }, { width: 18 }, { width: 15 }, { width: 10 }, { width: 8 }, { width: 18 }, { width: 10 }];

//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], { type: "application/octet-stream" });
//     saveAs(blob, "Family_Yojana_Report.xlsx");
//   }

//   const handleYojanaExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (YojanaListData) => {
//         if (!YojanaListData?.length) return notifyError("No Data Found");
//         const exportData = [];
//         YojanaListData.forEach((head) => {
//           const yojanaDetails = head?.MemberYojnaDetails || [];
//           if (yojanaDetails.length > 0) {
//             yojanaDetails.forEach((yojana) => {
//               const members = yojana?.MemberDetails || [];
//               members.forEach((member) => {
//                 exportData.push({
//                   "Yojana Name": yojana?.GramYojnaName || "",
//                   "Yojana Amount": member?.Amount || "",
//                   "Member Name": member?.MemberName || "",
//                 });
//               });
//             });
//           }
//         });
//         if (exportData.length === 0) return notifyError("No Member Yojana Details Found");
//         exportToExcel(exportData, "Member_Yojana_List");
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   const handleSelectYojanaChange = (head) => {
//     const headData = {
//       FamilyHeadMasterID: head?.FamilyHeadMasterID || "",
//       FamilyMemberDetailID: "",
//       ContactDetailID: head?.ContactDetailID || "",
//       VoterID: head?.VoterID?.toString() || "",
//       FullNameEnglish: head?.FullNameEnglish || "",
//       FullNameGujarati: head?.FullNameGujarati || "",
//       MobileNo: head?.MobileNo || "",
//       Age: head?.Age || "",
//       Gender: head?.Gender || "",
//     };
//     const memberDetails = [
//       ...(head?.FamilyMemberDetails?.map((ele) => ({
//         FamilyMemberDetailID: ele?.FamilyMemberDetailID,
//         FamilyHeadMasterID: ele?.FamilyHeadMasterID || "",
//         ContactDetailID: ele?.ContactDetailID || "",
//         VoterID: ele?.VoterID?.toString() || "",
//         Type: ele?.Type || "",
//         FullNameEnglish: ele?.FullNameEnglish || "",
//         FullNameGujarati: ele?.FullNameGujarati || "",
//         LocalityEnglish: ele?.LocalityEnglish || "",
//         PartNameEnglish: ele?.PartNameEnglish || "",
//         MobileNo: ele?.MobileNo || "",
//         Age: ele?.Age || "",
//         Gender: ele?.Gender || "",
//         NotVoter: ele?.NotVoter || "",
//         Death: ele?.Death || "",
//         OutSide: ele?.OutSide || "",
//         Handicap: ele?.Handicap || "",
//         IDCardNo: ele?.IDCardNo || "",
//         SLNo: ele?.SLNo || "",
//       })) || []),
//       headData,
//     ];

//     setMemberDetails(memberDetails);
//     setYojanaSelectModal(true);
//     setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//     setMemberYojanaDetail(head?.MemberYojnaDetails);
//   };

//   const handleEditMemberYojanaDetail = (head, idx, GramYojnaMemberID) => {
//     const memberDetail = head?.MemberYojnaDetails?.[idx]?.MemberDetails?.find((ele) => ele?.GramYojnaMemberID?.toString() === GramYojnaMemberID.toString());
//     const updatedMemberDetail = {
//       GramYojnaMemberID: memberDetail?.GramYojnaMemberID,
//       GramYojnaID: head?.MemberYojnaDetails?.[idx]?.GramYojnaID,
//       GramYojnaName: head?.MemberYojnaDetails?.[idx]?.GramYojnaName,
//       GramYojnaAmountDetailID: null,
//       Amount: memberDetail?.Amount.toString(),
//       MemberName: memberDetail?.MemberName,
//       IsAmount: memberDetail?.IsAmount,
//       IsAmountEnterByUser: memberDetail?.IsAmountEnterByUser,
//       TimePeriod: memberDetail?.TimePeriod,
//       IsMultiple: memberDetail?.IsMultiple,
//     };
//     setSelectedEditMemberDetail(updatedMemberDetail);
//     setIsEditMemberDetailModalOpen(true);
//   };

//   const handleYojanaSelectClose = () => {
//     setYojanaSelectModal(false);
//     setMemberDetails([]);
//     setFamilyHeadMasterID("");
//     setMemberYojanaDetail([]);
//     setSelectedEditGramYojanaID(null);
//   };

//   const handleShowHideYojanaDetails = (id) => {
//     setOpenYojanaDetails((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const handleCloseEditMemberDetail = () => {
//     setSelectedEditMemberDetail({});
//     setIsEditMemberDetailModalOpen(false);
//   };

//   return (
//     <>
//       <TabStyles />

//       <FilterMemberList filterData={filterData} filterRef={filterRef} filterStatus={filterStatus} setFilterStatus={setFilterStatus} setFilterData={setFilterData} />

//       <div className="flex-grow-1 w-100">
//         {/* ============== BEAUTIFUL TABS ============== */}
//         <ul className="member-list-tabs" role="tablist">
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={isAssignFamily} className={`tab-btn ${isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(true)}>
//               <span className="tab-icon">
//                 <UserCheck size={15} />
//               </span>
//               <span>Members With Family</span>
//               {isAssignFamily && <span className="tab-badge">{totalCount}</span>}
//             </button>
//           </li>
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={!isAssignFamily} className={`tab-btn alt ${!isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(false)}>
//               <span className="tab-icon">
//                 <User size={15} />
//               </span>
//               <span>Members Without Family</span>
//               {!isAssignFamily && <span className="tab-badge">{totalCount}</span>}
//             </button>
//           </li>
//         </ul>

//         {isLoading || isError || isFetching ? (
//           <TableShimmer theme={DarkTheme ? "dark" : "light"} />
//         ) : (
//           <div className="flex-grow-1 py-0 px-2 w-100">
//             <div className="row g-6 mb-6">
//               <div className="col-sm-12 col-xl-12">
//                 <div className="card">
//                   <div className="card-datatable">
//                     <div id="DataTables_Table_0_wrapper" className="dt-container dt-bootstrap5 dt-empty-footer">
//                       <div className="justify-content-between dt-layout-table px-4">
//                         <div className="d-md-flex justify-content-between align-items-center dt-layout-full table-responsive">
//                           <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
//                             <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />

//                             <button
//                               onClick={handlePrintAllYojanas}
//                               disabled={preparingAllPrint || isExporting}
//                               className="btn btn-danger btn-sm d-flex align-items-center gap-2 ms-3"
//                             >
//                               <Printer size={18} />
//                               {preparingAllPrint ? "Preparing..." : "Print All Yojanas"}
//                             </button>

//                             <div className="dt-buttons btn-group flex-md-row flex-column d-flex gap-3 mb-md-0 mb-4">
//                               <TableFilterButton handleFilterStatusToggle={handleFilterStatusToggle} />
//                               <ExcelButton
//                                 isExportingMain={isExporting}
//                                 isExportingSecondary={isExporting}
//                                 handleExportMain={handleExport}
//                                 primaryExcel="Member Details"
//                                 handleExportSecondary={handleYojanaExport}
//                                 secondaryExcel="Yojana Details"
//                               />
//                             </div>
//                           </div>

//                           <table className="datatables-users Merge-List table dataTable dtr-column" id="DataTables_Table_0">
//                             <thead className="table-header-light border-top">
//                               <tr>
//                                 <th rowSpan={2}>Sr No</th>
//                                 <th rowSpan={2}>Yojana Details</th>
//                                 <th rowSpan={2} style={{ width: "20%", verticalAlign: "middle" }}>
//                                   <Home size={16} className="me-1" />
//                                   Head & Address
//                                 </th>
//                                 <th colSpan={8} className="text-center">
//                                   <Users size={16} className="me-1" />
//                                   Member Details
//                                 </th>
//                               </tr>
//                               <tr>
//                                 <th>Name</th>
//                                 <th>Mobile</th>
//                                 <th>Gender</th>
//                                 <th>Age</th>
//                                 <th>Non Voter</th>
//                                 <th>Death</th>
//                                 <th>Remove</th>
//                                 <th>Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {pages[currentPage]?.data?.map((head, headIndex) => {
//                                 const hasMembers = head.FamilyMemberDetails?.length > 0;
//                                 const absoluteIndex = currentPage * rowsPerPage + headIndex + 1;

//                                 return (
//                                   <React.Fragment key={`head-${headIndex}`}>
//                                     {hasMembers ? (
//                                       <>
//                                         {head.FamilyMemberDetails.map((ele, memberIndex) => (
//                                           <tr key={`${headIndex}-${memberIndex}`}>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {absoluteIndex}
//                                                 </td>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {head.MemberYojnaDetails?.length > 0 && (
//                                                     <i
//                                                       onClick={() => handleShowHideYojanaDetails(head.FamilyHeadMasterID)}
//                                                       className={`icon-base ti tabler-${
//                                                         yojanaDetails[head.FamilyHeadMasterID] ? "chevron-down" : "chevron-right"
//                                                       } icon-md cursor-pointer scaleX-n1-rtl`}
//                                                     />
//                                                   )}
//                                                 </td>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {head.FullNameEnglish}
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Village:</strong> {head.PartNameEnglish}
//                                                   </span>
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Locality:</strong> {head.LocalityEnglish}
//                                                   </span>
//                                                   <br />
//                                                   <br />
//                                                   <div className="d-flex gap-2">
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Death</span>
//                                                       </strong>
//                                                     </label>
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Non Voter</span>
//                                                       </strong>
//                                                     </label>
//                                                   </div>
//                                                   <br />
//                                                   {head?.OverAllFamilyAmount && (
//                                                     <div>
//                                                       <strong>OverAll Yojana Amount: </strong>
//                                                       <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                                     </div>
//                                                   )}
//                                                   <br />
//                                                   {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                                 </td>
//                                               </>
//                                             )}
//                                             <td>
//                                               {ele.FullNameEnglish}
//                                               <br />
//                                               <br />
//                                               {`${ele?.IsHandicap === "true" ? "Handicap" : ""}${ele?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                             </td>
//                                             <td>{ele.MobileNo ? `+91 ${ele.MobileNo}` : ""}</td>
//                                             <td>
//                                               {ele.Gender?.toLowerCase() === "f" ? (
//                                                 <span className="gender-badge female">Female</span>
//                                               ) : ele.Gender?.toLowerCase() === "m" ? (
//                                                 <span className="gender-badge male">Male</span>
//                                               ) : (
//                                                 <span className="gender-badge unknown">N/A</span>
//                                               )}
//                                             </td>
//                                             <td>{ele.Age}</td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "NotVoter", !ele?.NotVoter)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "Death", !ele?.Death)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <Trash2 size={20} color="purple" style={{ cursor: "pointer" }} onClick={() => handleDeleteMember(ele)} />
//                                             </td>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="text-center align-top p-2">
//                                                   <div className="d-flex flex-column gap-2">
//                                                     <button
//                                                       className="btn btn-sm btn-outline-primary fw-semibold"
//                                                       onClick={() => {
//                                                         setAddNewVoterShow(true);
//                                                         setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                       }}
//                                                     >
//                                                       + Add New Voter
//                                                     </button>
//                                                     <button
//                                                       className="btn btn-sm btn-outline-success fw-semibold"
//                                                       onClick={() => {
//                                                         setSelectedVillage(head?.PartNameEnglish);
//                                                         setSelectedLocality(head?.LocalityEnglish);
//                                                         setIsAddExistingModalOpen(true);
//                                                         setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                       }}
//                                                     >
//                                                       Add Existing Voter
//                                                     </button>
//                                                     <button
//                                                       className="btn btn-sm btn-outline-warning fw-semibold"
//                                                       onClick={() => {
//                                                         setChangeHeadData(head);
//                                                         setIsChangeHeadOpen(true);
//                                                         setFamilyHeadMasterID(head.FamilyHeadMasterID);
//                                                         setHeadData({
//                                                           ContactDetailID: head?.ContactDetailID,
//                                                           VoterID: head?.VoterID,
//                                                           IsHead: false,
//                                                           IsHandicap: head?.IsHandicap,
//                                                           IsOutSide: head?.IsOutSide,
//                                                         });
//                                                       }}
//                                                     >
//                                                       Change Head
//                                                     </button>
//                                                     <button
//                                                       className="btn btn-sm btn-outline-danger fw-semibold d-flex align-items-center gap-1"
//                                                       onClick={() => handleSelectYojanaChange(head)}
//                                                     >
//                                                       <List size={16} /> Yojana
//                                                     </button>
//                                                     {head.MemberYojnaDetails?.length > 0 && (
//                                                       <button onClick={() => printSingleYojana(head)} className="btn btn-sm btn-success d-flex align-items-center gap-1">
//                                                         <Printer size={14} /> Print
//                                                       </button>
//                                                     )}
//                                                   </div>
//                                                 </td>
//                                               </>
//                                             )}
//                                           </tr>
//                                         ))}
//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.FamilyHeadMasterID] && (
//                                             <motion.tr
//                                               initial={{ opacity: 0, height: 0 }}
//                                               animate={{ opacity: 1, height: "auto" }}
//                                               exit={{ opacity: 0, height: 0 }}
//                                               style={{ background: "#f7f7f7" }}
//                                             >
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana?.GramYojnaName}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName}
//                                                                     </span>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div key={inx} className="member-row amount-row">
//                                                                   <span className="custom-font indian-currency">
//                                                                     {ele.IsAmount
//                                                                       ? ele?.TimePeriod && ele?.TimePeriod !== "1"
//                                                                         ? `${toIndianCurrency(parseInt(ele?.Amount || 0))} × ${ele?.TimePeriod}`
//                                                                         : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                       : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                   </span>
//                                                                 </div>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod === "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : ""}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">
//                                                                 {yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? toIndianCurrency(yojana.Amount)
//                                                                   : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                                                                     ? toIndianCurrency(yojana.Amount)
//                                                                     : `${yojana?.MemberDetails.length} સંખ્યા`}
//                                                               </span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     ) : (
//                                       /* NO MEMBERS CASE */
//                                       <>
//                                         <tr>
//                                           <td>{absoluteIndex}</td>
//                                           <td>
//                                             {head.MemberYojnaDetails?.length > 0 && (
//                                               <i
//                                                 onClick={() => handleShowHideYojanaDetails(head.FamilyHeadMasterID)}
//                                                 className={`icon-base ti tabler-${
//                                                   yojanaDetails[head.FamilyHeadMasterID] ? "chevron-down" : "chevron-right"
//                                                 } icon-md cursor-pointer scaleX-n1-rtl`}
//                                               />
//                                             )}
//                                           </td>
//                                           <td>
//                                             {head.FullNameEnglish}
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Village:</strong> {head.PartNameEnglish}
//                                             </span>
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Locality:</strong> {head.LocalityEnglish}
//                                             </span>
//                                             <br />
//                                             <br />
//                                             <div className="d-flex gap-2">
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Death</span>
//                                                 </strong>
//                                               </label>
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Non Voter</span>
//                                                 </strong>
//                                               </label>
//                                             </div>
//                                             <br />
//                                             {head?.OverAllFamilyAmount && (
//                                               <div>
//                                                 <strong>OverAll Yojana Amount: </strong>
//                                                 <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                               </div>
//                                             )}
//                                             <br />
//                                             {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                           </td>
//                                           <td colSpan={7} style={{ textAlign: "center", color: "#999" }}>
//                                             No members found
//                                           </td>
//                                           <td className="text-center align-top p-2">
//                                             <div className="d-flex flex-column gap-2">
//                                               <button
//                                                 className="btn btn-sm btn-outline-primary fw-semibold"
//                                                 onClick={() => {
//                                                   setAddNewVoterShow(true);
//                                                   setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                 }}
//                                               >
//                                                 + Add New Voter
//                                               </button>
//                                               <button
//                                                 className="btn btn-sm btn-outline-success fw-semibold"
//                                                 onClick={() => {
//                                                   setSelectedVillage(head?.PartNameEnglish);
//                                                   setSelectedLocality(head?.LocalityEnglish);
//                                                   setIsAddExistingModalOpen(true);
//                                                   setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                 }}
//                                               >
//                                                 Add Existing Voter
//                                               </button>
//                                               <button
//                                                 className="btn btn-sm btn-outline-danger fw-semibold d-flex align-items-center gap-1"
//                                                 onClick={() => handleSelectYojanaChange(head)}
//                                               >
//                                                 <List size={16} /> Yojana
//                                               </button>
//                                               {head.MemberYojnaDetails?.length > 0 && (
//                                                 <button onClick={() => printSingleYojana(head)} className="btn btn-sm btn-success d-flex align-items-center gap-1">
//                                                   <Printer size={14} /> Print
//                                                 </button>
//                                               )}
//                                             </div>
//                                           </td>
//                                         </tr>
//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.FamilyHeadMasterID] && (
//                                             <motion.tr style={{ background: "#f7f7f7" }}>
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana.GramYojnaName}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName}
//                                                                     </span>
//                                                                     <small className="entry-date">
//                                                                       <strong>Entry Date:</strong> {ele?.GramYojnaMemberEntryDate ? ele?.GramYojnaMemberEntryDate : "-"}
//                                                                     </small>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <>
//                                                                   <span>
//                                                                     <span className="custom-font indian-currency">
//                                                                       {ele.IsAmount
//                                                                         ? ele?.TimePeriod && ele?.TimePeriod != "1"
//                                                                           ? toIndianCurrency(parseInt(ele?.Amount || 0)) + " × " + ele?.TimePeriod
//                                                                           : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : ele.IsAmountEnterByUser
//                                                                           ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                           : "1"}
//                                                                     </span>{" "}
//                                                                   </span>
//                                                                   <br />
//                                                                 </>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod == "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : ""}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">{toIndianCurrency(yojana.Amount)}</span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     )}

//                                     {/* HIDDEN SINGLE PRINT */}
//                                     {head.MemberYojnaDetails?.length > 0 && (
//                                       <div style={{ display: "none" }}>
//                                         <PrintableSingleYojana ref={(el) => (singlePrintRefs.current[head.FamilyHeadMasterID] = el)} head={head} />
//                                       </div>
//                                     )}
//                                   </React.Fragment>
//                                 );
//                               })}
//                             </tbody>
//                           </table>

//                           <div className="row mx-3 justify-content-between">
//                             <PageEntries start={start} end={end} totalCount={totalCount} />
//                             <PaginationButtons
//                               currentPage={currentPage}
//                               setCurrentPage={setCurrentPage}
//                               goToPage={goToPage}
//                               pages={pages}
//                               hasNextPage={hasNextPage}
//                               fetchNextPage={fetchNextPage}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* HIDDEN ALL YOJANA PRINT */}
//       <div style={{ display: "none" }}>
//         <PrintableAllYojanas ref={allYojanaPrintRef} data={allYojanaData} />
//       </div>

//       {/* MODALS */}
//       <AddNewVoter show={addNewVoterShow} onClose={handleAddNewVoterClose} refetch={refetch} familyHeadMasterID={familyHeadMasterID} />
//       <ChangeHeadModal
//         show={isChangeHeadOpen}
//         data={changeHeadData}
//         handleClose={handleChangeHeadClose}
//         familyHeadMasterID={familyHeadMasterID}
//         refetch={refetch}
//         headData={headData}
//         statusType={statusType}
//         deadNonVoterHeadID={deadNonVoterHeadID}
//       />
//       <AddExistingVoter
//         show={isAddExistingModalOpen}
//         selectedVillage={selectedVillage}
//         selectedLocality={selectedLocality}
//         handleClose={handleCloseAddExistingModal}
//         selectedRecords={selectedRecords}
//         setSelectedRecords={setSelectedRecords}
//         refetchMemberList={refetch}
//         familyHeadMasterID={familyHeadMasterID}
//       />
//       <YojanaSelect
//         selectedEditGramYojanaID={selectedEditGramYojanaID}
//         memberDetails={memberDetails}
//         show={yojanaSelectModalOpen}
//         handleClose={handleYojanaSelectClose}
//         familyHeadMasterID={familyHeadMasterID}
//         memberYojanaDetail={memberYojanaDetail}
//         refetchMemberList={refetch}
//       />

//       <EditYojanaMemberDetail
//         selectedEditMemberDetail={selectedEditMemberDetail}
//         open={isEditMemberDetailModalOpen}
//         onClose={handleCloseEditMemberDetail}
//         refetchMemberList={refetch}
//       />

//       {(inserting || deleting || changeHeadInserting || preparingAllPrint || isExporting) && <Loader />}
//     </>
//   );
// };

// export default ViewMemberList;

// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { AnimatePresence, motion } from "framer-motion";
// import Cookies from "js-cookie";
// import { Home, List, Printer, Trash2, User, UserCheck, Users } from "lucide-react";
// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";
// import { toast } from "react-toastify";
// import Swal from "sweetalert2";
// import { useDeleteMember } from "../../API_Master/DeleteMutateAPI";
// import { useMemberListExportExcel } from "../../API_Master/ExcelAPI";
// import { useMemberListDataPagination } from "../../API_Master/FetchAPI";
// import { useNotVoterDeath, useSetChangeHead } from "../../API_Master/MutateAPI";
// import ExcelButton from "../../CommonComponents/ExcelButton";
// import Loader from "../../CommonComponents/Loader";
// import PageCountSelect from "../../CommonComponents/PageCountSelect";
// import PageEntries from "../../CommonComponents/PageEntries";
// import PaginationButtons from "../../CommonComponents/PaginationButtons";
// import TableFilterButton from "../../CommonComponents/TableFilterButton";
// import TableShimmer from "../../Components/TableShimmer";
// import { deleteConfirmation, exportToExcel, notifyError, notifySuccess, toIndianCurrency } from "../../MethodMaster/JSXComponentMothod";
// import { toggleOffcanvasStatus } from "../../Redux/Slices/ProjectSlice";
// import AddExistingVoter from "../AddExistingVoter/inde";
// import AddNewVoter from "../AddNewVoter";
// import ChangeHeadModal from "../ChangeHeadModal";
// import EditYojanaMemberDetail from "../EditYojanaMemberDetail";
// import YojanaSelect from "../YojanaSelect";
// import FilterMemberList from "./FilterMemberList";
// import { Narendra_Modi_Election_API_URL } from "../../Process";

// /* ============================================================
//    BEAUTIFUL TAB STYLES
//    ============================================================ */
// const TabStyles = () => (
//   <style>{`
//     .member-list-tabs {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 8px;
//       padding: 6px;
//       margin: 16px 16px 0;
//       background: #f1f3f9;
//       border-radius: 14px;
//       box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
//       list-style: none;
//       flex-wrap: wrap;
//     }
//     .member-list-tabs .tab-btn {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 10px;
//       border: none;
//       outline: none;
//       cursor: pointer;
//       padding: 10px 20px;
//       border-radius: 10px;
//       font-weight: 600;
//       font-size: 14px;
//       letter-spacing: 0.2px;
//       color: #5a6478;
//       background: transparent;
//       transition: color 0.25s ease, transform 0.2s ease, background 0.25s ease;
//     }
//     .member-list-tabs .tab-btn:hover:not(.active) {
//       color: #3b5bdb;
//       background: rgba(99, 132, 255, 0.08);
//     }
//     .member-list-tabs .tab-btn.active {
//       color: #ffffff;
//       background: linear-gradient(135deg, #5b8def 0%, #3b5bdb 100%);
//       box-shadow: 0 8px 18px -6px rgba(59, 91, 219, 0.55),
//                   0 2px 6px -1px rgba(59, 91, 219, 0.35);
//       transform: translateY(-1px);
//     }
//     .member-list-tabs .tab-btn.active.alt {
//       background: linear-gradient(135deg, #f59f4b 0%, #e8590c 100%);
//       box-shadow: 0 8px 18px -6px rgba(232, 89, 12, 0.55),
//                   0 2px 6px -1px rgba(232, 89, 12, 0.35);
//     }
//     .member-list-tabs .tab-icon {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       width: 26px;
//       height: 26px;
//       border-radius: 50%;
//       background: rgba(59, 91, 219, 0.12);
//       color: #3b5bdb;
//       transition: all 0.25s ease;
//     }
//     .member-list-tabs .tab-btn.active .tab-icon {
//       background: rgba(255, 255, 255, 0.25);
//       color: #ffffff;
//     }
//     .member-list-tabs .tab-badge {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       min-width: 24px;
//       height: 22px;
//       padding: 0 10px;
//       border-radius: 11px;
//       font-size: 12px;
//       font-weight: 700;
//       background: #ffffff;
//       color: #3b5bdb;
//       box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
//       letter-spacing: 0.3px;
//     }
//     .member-list-tabs .tab-btn.active .tab-badge {
//       background: rgba(255, 255, 255, 0.95);
//       color: #3b5bdb;
//     }
//     .member-list-tabs .tab-btn.active.alt .tab-badge {
//       color: #e8590c;
//     }
//     .member-list-tabs .tab-btn:disabled {
//       opacity: 0.55;
//       cursor: not-allowed;
//     }
//     .theme-dark .member-list-tabs {
//       background: #2a2f3a;
//       box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
//     }
//     .theme-dark .member-list-tabs .tab-btn { color: #b8c0d0; }
//     .theme-dark .member-list-tabs .tab-btn:hover:not(.active) {
//       color: #8da9ff;
//       background: rgba(141, 169, 255, 0.1);
//     }
//     .theme-dark .member-list-tabs .tab-icon {
//       background: rgba(141, 169, 255, 0.15);
//       color: #8da9ff;
//     }
//   `}</style>
// );

// /* ============================================================
//    PRINT COMPONENTS (unchanged)
//    ============================================================ */
// const PrintableSingleYojana = React.forwardRef(({ head }, ref) => {
//   return (
//     <div
//       ref={ref}
//       style={{
//         padding: "30px 50px",
//         fontFamily: "Arial, sans-serif",
//         background: "white",
//         color: "#000",
//       }}
//     >
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h3>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>૧૫૫ - ઓલપાડ વિધાનસભા</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ textAlign: "center", color: "#555", fontSize: "16px", marginBottom: "20px" }}>
//         Village: {head.PartNameEnglish} | Locality: {head.LocalityEnglish}
//       </p>

//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "15px",
//           tableLayout: "fixed",
//           marginBottom: "40px",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "43%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>
//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th>No</th>
//             <th>Yojana Name</th>
//             <th>Member & Amount</th>
//             <th>Total Amount</th>
//           </tr>
//         </thead>
//         <tbody>
//           {head.MemberYojnaDetails?.map((yojana, i) => {
//             const memberDetails = yojana.MemberDetails ?? [];
//             const maxNameLen = Math.max(...memberDetails.map((m) => m?.MemberName?.trim().length || 0));
//             const memberList = memberDetails.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const paddedName = name.padEnd(maxNameLen + 2);
//               const amtText = m.IsAmount
//                 ? m?.TimePeriod && m.TimePeriod !== "1"
//                   ? `${amount} × ${m.TimePeriod}`
//                   : amount
//                 : m.IsAmountEnterByUser
//                   ? toIndianCurrency(parseInt(m?.Amount || 0))
//                   : "1";
//               const entryDate = m.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${paddedName} ${amtText}\n   Entry Date: ${entryDate}`;
//             });
//             return (
//               <tr key={i} style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
//                 <td>{i + 1}</td>
//                 <td style={{ fontFamily: "monospace" }}>{yojana.GramYojnaName}</td>
//                 <td
//                   style={{
//                     border: "1px solid #333",
//                     padding: "8px",
//                     whiteSpace: "pre-line",
//                     fontFamily: "monospace",
//                     verticalAlign: "top",
//                   }}
//                 >
//                   {memberList.join("\n")}
//                   <br />
//                   {yojana?.MemberDetails?.[0]?.TimePeriod === "12" ? " ( દર માસ ) " : yojana?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ textAlign: "right", fontFamily: "monospace" }}>
//                   {yojana?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(yojana.Amount)
//                     : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(yojana.Amount)
//                       : `${yojana?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr style={{ backgroundColor: "#FFF3E0", fontWeight: "bold" }}>
//             <td colSpan={3} style={{ textAlign: "right" }}>
//               Total Amount
//             </td>
//             <td style={{ textAlign: "right" }}>{toIndianCurrency(head.OverAllFamilyAmount || 0)}</td>
//           </tr>
//         </tfoot>
//       </table>

//       <style jsx>{`
//         @media print {
//           @page {
//             margin: 1cm;
//           }
//           body {
//             -webkit-print-color-adjust: exact;
//             print-color-adjust: exact;
//           }
//           tr {
//             page-break-inside: avoid !important;
//             break-inside: avoid !important;
//           }
//           table {
//             page-break-after: auto;
//           }
//           .no-print {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// });

// const ORIENTATION = "landscape";
// const PAGE_WIDTH_MM = ORIENTATION === "landscape" ? 297 : 210;
// const PAGE_HEIGHT_MM = ORIENTATION === "landscape" ? 210 : 297;
// const TOP_MARGIN_MM = 15;
// const BOTTOM_MARGIN_MM = 15;
// const LEFT_MARGIN_MM = 20;
// const RIGHT_MARGIN_MM = 20;
// const PRINTABLE_HEIGHT_MM = PAGE_HEIGHT_MM - TOP_MARGIN_MM - BOTTOM_MARGIN_MM;
// const PRINTABLE_WIDTH_MM = PAGE_WIDTH_MM - LEFT_MARGIN_MM - RIGHT_MARGIN_MM;
// const PX_TO_MM = 96 / 25.4;

// const PrintableAllYojanas = React.forwardRef(({ data }, ref) => {
//   const [pageGroups, setPageGroups] = useState([]);
//   const measureRef = useRef(null);

//   useEffect(() => {
//     if (!measureRef.current || !data.length) return;
//     const blocks = measureRef.current.querySelectorAll(".print-block");
//     const heightsPx = Array.from(blocks).map((b) => b.offsetHeight);
//     const printablePx = PRINTABLE_HEIGHT_MM * PX_TO_MM;

//     const groups = [];
//     let curGroup = [];
//     let curHeight = 0;

//     data.forEach((item, i) => {
//       const blockHeight = heightsPx[i];
//       const gap = i === 0 ? 0 : 30;
//       if (curHeight + gap + blockHeight > printablePx && curGroup.length) {
//         groups.push(curGroup);
//         curGroup = [item];
//         curHeight = blockHeight;
//       } else {
//         curGroup.push(item);
//         curHeight += gap + blockHeight;
//       }
//     });
//     if (curGroup.length) groups.push(curGroup);
//     setPageGroups(groups);
//   }, [data]);

//   return (
//     <div ref={ref} style={{ background: "white", fontFamily: "Arial, sans-serif" }}>
//       <div
//         ref={measureRef}
//         style={{
//           padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//           visibility: "hidden",
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: `${PRINTABLE_WIDTH_MM}mm`,
//         }}
//       >
//         {data.map((item, idx) => (
//           <PrintBlock key={idx} item={item} />
//         ))}
//       </div>

//       {pageGroups.map((group, pageIdx) => (
//         <div
//           key={pageIdx}
//           className="print-page"
//           style={{
//             width: `${PAGE_WIDTH_MM}mm`,
//             minHeight: `${PAGE_HEIGHT_MM}mm`,
//             padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//             pageBreakAfter: pageIdx < pageGroups.length - 1 ? "always" : "auto",
//             boxSizing: "border-box",
//           }}
//         >
//           {group.map((item, idx) => (
//             <PrintBlock key={idx} item={item} isLastInGroup={idx === group.length - 1} />
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// });

// const PrintBlock = React.memo(({ item, isLastInGroup }) => {
//   const { head, yojanas } = item;

//   return (
//     <div className="print-block" style={{ marginBottom: isLastInGroup ? "0" : "30px", breakInside: "avoid" }}>
//       <h1 style={{ textAlign: "center", color: "#1A237E", fontSize: "32px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h1>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>૧૫૫ - ઓલપાડ વિધાનસભા</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ fontSize: "16px", marginBottom: "15px" }}>
//         <strong>Village:</strong> {head.PartNameEnglish} | <strong>Locality:</strong> {head.LocalityEnglish}
//       </p>

//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "14px",
//           tableLayout: "fixed",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "45%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>

//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th style={{ border: "1px solid #333", padding: "10px" }}>No</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Yojana</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Member & Amount</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Total Amount</th>
//           </tr>
//         </thead>

//         <tbody>
//           {yojanas.map((y, i) => {
//             const memberLines = y.MemberDetails?.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const entryDate = m?.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${name.padEnd(25)} - ${
//                 m.IsAmount ? (m?.TimePeriod && m?.TimePeriod != "1" ? amount + " × " + m?.TimePeriod : amount) : m.IsAmountEnterByUser ? amount : "1"
//               }\n  Entry Date -${entryDate} `;
//             });

//             return (
//               <tr key={i}>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "center", verticalAlign: "top", fontFamily: "monospace" }}>{i + 1}</td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", wordBreak: "break-word", verticalAlign: "top", fontFamily: "monospace" }}>
//                   {y.GramYojnaName}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
//                   {memberLines.join("\n")}
//                   <br />
//                   {y?.MemberDetails?.[0]?.TimePeriod == "12" ? " ( દર માસ ) " : y?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "right", verticalAlign: "top" }}>
//                   {y?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(y.Amount)
//                     : y?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(y.Amount)
//                       : `${y?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr>
//             <td colSpan={4} style={{ borderTop: "1px solid #000", padding: 0 }}></td>
//           </tr>
//           <tr>
//             <td
//               colSpan={3}
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//                 backgroundColor: "#FFF3E0",
//                 border: "1px solid #000",
//                 borderRight: "none",
//               }}
//             >
//               Total Amount
//             </td>
//             <td
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "15px",
//                 color: "#000",
//                 backgroundColor: "#FFF3E0",
//                 fontFamily: "monospace",
//                 border: "1px solid #000",
//               }}
//             >
//               {toIndianCurrency(head.OverAllFamilyAmount || 0)}
//             </td>
//           </tr>
//         </tfoot>
//       </table>

//       <style jsx>{`
//         @media print {
//           tfoot {
//             display: table-row-group;
//           }
//         }
//       `}</style>
//     </div>
//   );
// });

// /* ============================================================
//    MAIN COMPONENT
//    ============================================================ */
// const ViewMemberList = () => {
//   const { DarkTheme } = useSelector((state) => state.ProjectSlice);
//   const dispatch = useDispatch();

//   const [addNewVoterShow, setAddNewVoterShow] = useState(false);
//   const [changeHeadData, setChangeHeadData] = useState("");
//   const [isChangeHeadOpen, setIsChangeHeadOpen] = useState(false);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [filterData, setFilterData] = useState({});
//   const [familyHeadMasterID, setFamilyHeadMasterID] = useState("");
//   const [headData, setHeadData] = useState({});
//   const [statusType, setStatusType] = useState("");
//   const [deadNonVoterHeadID, setDeadNonVoterHeadID] = useState("");
//   const [selectedVillage, setSelectedVillage] = useState("");
//   const [selectedLocality, setSelectedLocality] = useState("");
//   const [isAddExistingModalOpen, setIsAddExistingModalOpen] = useState(false);
//   const [selectedRecords, setSelectedRecords] = useState({});
//   const [filterStatus, setFilterStatus] = useState(false);
//   const [memberDetails, setMemberDetails] = useState([]);
//   const [yojanaSelectModalOpen, setYojanaSelectModal] = useState(false);
//   const [memberYojanaDetail, setMemberYojanaDetail] = useState([]);
//   const [yojanaDetails, setOpenYojanaDetails] = useState({});
//   const { mutate: addNotVoterDeath, isPending: inserting } = useNotVoterDeath();
//   const [deadNonVoterMemberID, setDeadNonVoterMemberID] = useState("");
//   const [selectedEditGramYojanaID, setSelectedEditGramYojanaID] = useState(null);
//   const [selectedEditMemberDetail, setSelectedEditMemberDetail] = useState({});
//   const [isEditMemberDetailModalOpen, setIsEditMemberDetailModalOpen] = useState(false);

//   // Tab state - default "With Family"
//   const [isAssignFamily, setIsAssignFamily] = useState(true);

//   // NEW: Tab counts (fetched once on mount from getMemberCountWithFamilyAndWithoutFamilly)
//   const [tabCounts, setTabCounts] = useState({
//     FamilyCount: 0,
//     WithoutFamilyCount: 0,
//   });

//   // PRINT REFS
//   const singlePrintRefs = useRef({});
//   const allYojanaPrintRef = useRef();
//   const triggerAllPrint = useRef(() => {});
//   const [allYojanaData, setAllYojanaData] = useState([]);
//   const [preparingAllPrint, setPreparingAllPrint] = useState(false);

//   const filterRef = useRef();

//   const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useMemberListDataPagination(rowsPerPage, filterData, isAssignFamily);
//   const { mutate: deleteMember, isLoading: deleting } = useDeleteMember();
//   const { mutate: addChangeHead, isPending: changeHeadInserting } = useSetChangeHead();
//   const { mutate: exportMemberList, isPending: isExporting } = useMemberListExportExcel();

//   const pages = data?.pages || [];
//   const totalCount = data?.pages[0]?.TotalCount || 0;
//   const start = currentPage * rowsPerPage + 1;
//   const end = Math.min(start + (pages[currentPage]?.data?.length || 0) - 1, totalCount);

//   console.log("datadatadata", data, hasNextPage);

//   // Merge tab into filter payload for exports / prints
//   const effectiveFilterData = { ...filterData, IsAssignFamily: isAssignFamily };

//   // ────────────────────────────────────────────────────────────
//   // Fetch global counts for both tabs on mount
//   // ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     let isMounted = true;

//     const fetchTabCounts = async () => {
//       try {
//         const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberCountWithFamilyAndWithoutFamilly`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           // Add a body here if your API expects one, e.g.:
//           // body: JSON.stringify({
//           //   VillageName: Cookies.get("Narendra_Modi_Village_ID") || "",
//           // }),
//         });

//         if (!response.ok) return;

//         const result = await response.json();
//         if (isMounted && result?.status && result?.data) {
//           setTabCounts({
//             FamilyCount: Number(result.data.FamilyCount) || 0,
//             WithoutFamilyCount: Number(result.data.WithoutFamilyCount) || 0,
//           });
//         }
//       } catch (err) {
//         console.error("Failed to fetch member counts:", err);
//       }
//     };

//     fetchTabCounts();

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   // Tab change handler
//   const handleTabChange = (value) => {
//     if (value === isAssignFamily) return;
//     setIsAssignFamily(value);
//     setCurrentPage(0);
//     setOpenYojanaDetails({});
//   };

//   // PRINT SINGLE FAMILY
//   const printSingleYojana = (head) => {
//     const node = singlePrintRefs.current[head.FamilyHeadMasterID];
//     if (!node) return;

//     const win = window.open("", "_blank");
//     win.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>${head.FullNameEnglish} - Yojana</title>
//           <style>
//             body { font-family: Arial, sans-serif; background: white; }
//             table { width: 100%; border-collapse: collapse; font-size: 14px; }
//             th, td { border: 1px solid #333; padding: 10px; text-align: left; }
//             th { background: #E8F5E8; }
//             .indian-currency::before { content: "₹"; }
//           </style>
//         </head>
//         <body>${node.innerHTML}</body>
//       </html>
//     `);
//     win.document.close();
//     win.focus();
//     win.print();
//     setTimeout(() => win.close(), 1000);
//   };

//   // PRINT ALL YOJANAS
//   const handlePrintAllYojanas = () => {
//     toast.dismiss();
//     setPreparingAllPrint(true);

//     exportMemberList(effectiveFilterData, {
//       onSuccess: (apiData) => {
//         const printData = apiData.filter((head) => head.MemberYojnaDetails?.length > 0).map((head) => ({ head, yojanas: head.MemberYojnaDetails }));

//         if (printData.length === 0) {
//           notifyError("No Yojana data found");
//           setPreparingAllPrint(false);
//           return;
//         }

//         setAllYojanaData(printData);
//         setTimeout(() => triggerAllPrint.current(), 300);
//       },
//       onError: () => {
//         notifyError("Print failed");
//         setPreparingAllPrint(false);
//       },
//     });
//   };

//   const printAllYojanas = useReactToPrint({
//     contentRef: allYojanaPrintRef,
//     documentTitle: `All_Yojanas_${new Date().toISOString().slice(0, 10)}`,
//     onAfterPrint: () => {
//       setPreparingAllPrint(false);
//       setAllYojanaData([]);
//     },
//   });

//   useEffect(() => {
//     triggerAllPrint.current = printAllYojanas;
//   }, [printAllYojanas]);

//   const handleRowsChange = async (e) => {
//     const limit = parseInt(e.target?.value);
//     setRowsPerPage(limit);
//     setCurrentPage(0);
//     await refetch();
//   };

//   const goToPage = async (index) => {
//     if (pages[index]) {
//       setCurrentPage(index);
//     } else if (hasNextPage) {
//       await fetchNextPage();
//       setCurrentPage(index);
//     }
//   };

//   const handleAddNewVoterClose = () => setAddNewVoterShow(false);

//   const handleChangeHeadClose = () => {
//     setIsChangeHeadOpen(false);
//     setChangeHeadData("");
//     setFamilyHeadMasterID("");
//     setHeadData({});
//     setStatusType("");
//   };

//   const handleCloseAddExistingModal = () => {
//     setSelectedVillage("");
//     setSelectedLocality("");
//     setSelectedRecords({});
//     setIsAddExistingModalOpen(false);
//     setFamilyHeadMasterID("");
//   };

//   const handleSetNonVoterDeath = (ele, StatusType, Status) => {
//     setDeadNonVoterMemberID(ele.ContactDetailID);
//     setStatusType(StatusType);
//     const payload = {
//       ContactDetailID: ele?.ContactDetailID || "",
//       StatusType: StatusType,
//       Death: StatusType === "Death" ? Status : false,
//       NotVoter: StatusType === "NotVoter" ? Status : false,
//       UpdatedByUserID: "",
//     };

//     Swal.fire({
//       title: "Are you sure?",
//       text: `You are marking this member as "${StatusType}".`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, proceed!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         addNotVoterDeath(payload, {
//           onSuccess: (res) => {
//             if (res?.status === true) {
//               notifySuccess("Successfully Inserted", false);
//               refetch();
//             } else {
//               notifyError(res?.message ? res.message : "Data Not Inserted", false);
//             }
//           },
//           onError: () => notifyError("Something went wrong", false),
//         });
//       } else {
//         setDeadNonVoterMemberID("");
//         setStatusType("");
//       }
//     });
//   };

//   const handleDeleteMember = async (item) => {
//     const result = await deleteConfirmation();
//     if (result?.isConfirmed) {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         ContactDetailID: item?.ContactDetailID || "",
//         FamilyMemberDetailID: item?.FamilyMemberDetailID || "",
//         VoterID: item?.VoterID || "",
//       };
//       deleteMember(payload, {
//         onSuccess: (res) => {
//           if (res?.status === true) {
//             notifySuccess("Deleted Successfully", DarkTheme ? true : false);
//             refetch();
//           } else {
//             notifyError(res?.message || "Not Deleted", DarkTheme ? true : false);
//           }
//         },
//         onError: () => notifyError("Something went wrong", false),
//       });
//     }
//   };

//   const handleDeathNotVoterChange = (head, StatusType) => {
//     setFamilyHeadMasterID(head.FamilyHeadMasterID);
//     setDeadNonVoterHeadID(head?.ContactDetailID);
//     setStatusType(StatusType);

//     if (head?.FamilyMemberDetails?.length > 0) {
//       setChangeHeadData(head);
//       setIsChangeHeadOpen(true);
//       setHeadData({
//         ContactDetailID: head?.ContactDetailID,
//         VoterID: head?.VoterID,
//         IsHead: false,
//         IsHandicap: head?.IsHandicap,
//         IsOutSide: head?.IsOutSide,
//       });
//     } else {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         FamilyHeadMasterID: familyHeadMasterID || "",
//         ContactDetailID: head?.ContactDetailID || "",
//         StatusType: StatusType,
//         Death: StatusType?.toLowerCase() === "death" ? true : false,
//         NotVoter: StatusType?.toLowerCase() === "notvoter" ? true : false,
//         FamilyDetail: [],
//       };

//       Swal.fire({
//         title: "Are you sure?",
//         text: `You are marking this head as "${StatusType}".`,
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, proceed!",
//       }).then((result) => {
//         if (result.isConfirmed) {
//           addChangeHead(payload, {
//             onSuccess: (res) => {
//               if (res?.status === true) {
//                 notifySuccess("Successfully Inserted", false);
//                 setFamilyHeadMasterID("");
//                 setStatusType("");
//                 setDeadNonVoterHeadID("");
//                 refetch();
//               } else {
//                 notifyError(res?.message || "Data Not Inserted", false);
//               }
//             },
//             onError: () => notifyError("Something went wrong", false),
//           });
//         } else {
//           setFamilyHeadMasterID("");
//           setDeadNonVoterHeadID("");
//           setStatusType("");
//         }
//       });
//     }
//   };

//   const handleFilterStatusToggle = () => {
//     setFilterStatus(true);
//     dispatch(toggleOffcanvasStatus(true));
//   };

//   const handleExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (MemberListData) => {
//         if (!MemberListData?.length) return notifyError("No Data Found");
//         exportToExcelWithYojanaTable(MemberListData);
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   async function exportToExcelWithYojanaTable(data) {
//     const workbook = new ExcelJS.Workbook();
//     const sheet = workbook.addWorksheet("Family Yojana Report", {
//       pageSetup: { paperSize: 9, orientation: "landscape" },
//     });

//     let rowIndex = 1;
//     let familySr = 1;

//     data.forEach((head) => {
//       const members = head.FamilyMemberDetails || [];
//       const headName = head.FullNameEnglish || "";
//       const village = head.PartNameEnglish || "";
//       const locality = head.LocalityEnglish || "";
//       const overAllAmount = head.OverAllFamilyAmount || 0;

//       const headerRow = sheet.getRow(rowIndex++);
//       headerRow.values = [familySr, headName, village, locality, `₹${Number(overAllAmount).toLocaleString("en-IN")}.00`];
//       headerRow.font = { bold: true, size: 12 };
//       headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6E6E6" } };

//       const memberHeader = sheet.getRow(rowIndex++);
//       memberHeader.values = ["", "Member Name", "Mobile", "Gender", "Age", "ID Card No", "SL No"];
//       memberHeader.font = { bold: true };
//       memberHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9EAD3" } };

//       members.forEach((member) => {
//         const row = sheet.getRow(rowIndex++);
//         row.values = [
//           "",
//           member.FullNameEnglish || "",
//           member.MobileNo || "",
//           member.Gender === "M" ? "Male" : "Female",
//           member.Age || "",
//           member.IDCardNo || "",
//           member.SLNo || "",
//         ];
//       });

//       const yojanaHeader = sheet.getRow(rowIndex++);
//       if (head?.MemberYojnaDetails?.length) {
//         yojanaHeader.values = ["", "Yojana Name", "Members (with Amount)", "Total Amount"];
//         yojanaHeader.font = { bold: true, color: { argb: "FFFFFFFF" } };
//         yojanaHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4CAF50" } };
//       }

//       (head.MemberYojnaDetails || []).forEach((yojna) => {
//         const yojnaName = yojna.GramYojnaName || "";
//         const yojnaTotal = yojna.Amount || "0";
//         const details = yojna.MemberDetails || [];

//         const memberList = details
//           .map((d, i) => {
//             const name = d.MemberName || "Unknown";
//             const amt = d.IsAmount
//               ? d?.TimePeriod && d?.TimePeriod != "1"
//                 ? toIndianCurrency(parseInt(d?.Amount || 0)) + " × " + d?.TimePeriod
//                 : toIndianCurrency(parseInt(d?.Amount || 0))
//               : d.IsAmountEnterByUser
//                 ? toIndianCurrency(parseInt(d?.Amount || 0))
//                 : "1";
//             const entryDate = d?.GramYojnaMemberEntryDate;
//             return `${i + 1}) ${name} (${amt})\n   Entry Date: ${entryDate}`;
//           })
//           .join("\n");

//         const firstRow = sheet.getRow(rowIndex++);
//         firstRow.values = [
//           "",
//           yojnaName,
//           memberList + `${details?.[0]?.TimePeriod == "12" ? "\n ( દર માસ ) " : details?.[0]?.IsAmount ? "\n  ( દર વર્ષે ) " : ""}`,
//           details?.[0]?.IsAmount ? toIndianCurrency(yojnaTotal) : details?.[0]?.IsAmountEnterByUser ? toIndianCurrency(yojnaTotal) : `${details?.length} સંખ્યા`,
//         ];
//         firstRow.getCell(2).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(3).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(4).alignment = { vertical: "middle" };
//         const lines = memberList.split("\n").length;
//         if (lines > 1) {
//           for (let i = 1; i < lines; i++) {
//             const extraRow = sheet.getRow(rowIndex);
//             extraRow.values = ["", "", "", ""];
//             extraRow.getCell(3).value = { formula: `C${rowIndex - lines}` };
//           }
//         }
//         sheet.getRow(rowIndex++).height = 15;
//       });

//       familySr++;
//     });

//     sheet.columns = [{ width: 8 }, { width: 40 }, { width: 40 }, { width: 30 }, { width: 18 }, { width: 15 }, { width: 10 }, { width: 8 }, { width: 18 }, { width: 10 }];

//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], { type: "application/octet-stream" });
//     saveAs(blob, "Family_Yojana_Report.xlsx");
//   }

//   const handleYojanaExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (YojanaListData) => {
//         if (!YojanaListData?.length) return notifyError("No Data Found");
//         const exportData = [];
//         YojanaListData.forEach((head) => {
//           const yojanaDetails = head?.MemberYojnaDetails || [];
//           if (yojanaDetails.length > 0) {
//             yojanaDetails.forEach((yojana) => {
//               const members = yojana?.MemberDetails || [];
//               members.forEach((member) => {
//                 exportData.push({
//                   "Yojana Name": yojana?.GramYojnaName || "",
//                   "Yojana Amount": member?.Amount || "",
//                   "Member Name": member?.MemberName || "",
//                 });
//               });
//             });
//           }
//         });
//         if (exportData.length === 0) return notifyError("No Member Yojana Details Found");
//         exportToExcel(exportData, "Member_Yojana_List");
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   const handleSelectYojanaChange = (head) => {
//     const headData = {
//       FamilyHeadMasterID: head?.FamilyHeadMasterID || "",
//       FamilyMemberDetailID: "",
//       ContactDetailID: head?.ContactDetailID || "",
//       VoterID: head?.VoterID?.toString() || "",
//       FullNameEnglish: head?.FullNameEnglish || "",
//       FullNameGujarati: head?.FullNameGujarati || "",
//       MobileNo: head?.MobileNo || "",
//       Age: head?.Age || "",
//       Gender: head?.Gender || "",
//     };
//     const memberDetails = [
//       ...(head?.FamilyMemberDetails?.map((ele) => ({
//         FamilyMemberDetailID: ele?.FamilyMemberDetailID,
//         FamilyHeadMasterID: ele?.FamilyHeadMasterID || "",
//         ContactDetailID: ele?.ContactDetailID || "",
//         VoterID: ele?.VoterID?.toString() || "",
//         Type: ele?.Type || "",
//         FullNameEnglish: ele?.FullNameEnglish || "",
//         FullNameGujarati: ele?.FullNameGujarati || "",
//         LocalityEnglish: ele?.LocalityEnglish || "",
//         PartNameEnglish: ele?.PartNameEnglish || "",
//         MobileNo: ele?.MobileNo || "",
//         Age: ele?.Age || "",
//         Gender: ele?.Gender || "",
//         NotVoter: ele?.NotVoter || "",
//         Death: ele?.Death || "",
//         OutSide: ele?.OutSide || "",
//         Handicap: ele?.Handicap || "",
//         IDCardNo: ele?.IDCardNo || "",
//         SLNo: ele?.SLNo || "",
//       })) || []),
//       headData,
//     ];

//     setMemberDetails(memberDetails);
//     setYojanaSelectModal(true);
//     setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//     setMemberYojanaDetail(head?.MemberYojnaDetails);
//   };

//   const handleEditMemberYojanaDetail = (head, idx, GramYojnaMemberID) => {
//     const memberDetail = head?.MemberYojnaDetails?.[idx]?.MemberDetails?.find((ele) => ele?.GramYojnaMemberID?.toString() === GramYojnaMemberID.toString());
//     const updatedMemberDetail = {
//       GramYojnaMemberID: memberDetail?.GramYojnaMemberID,
//       GramYojnaID: head?.MemberYojnaDetails?.[idx]?.GramYojnaID,
//       GramYojnaName: head?.MemberYojnaDetails?.[idx]?.GramYojnaName,
//       GramYojnaAmountDetailID: null,
//       Amount: memberDetail?.Amount.toString(),
//       MemberName: memberDetail?.MemberName,
//       IsAmount: memberDetail?.IsAmount,
//       IsAmountEnterByUser: memberDetail?.IsAmountEnterByUser,
//       TimePeriod: memberDetail?.TimePeriod,
//       IsMultiple: memberDetail?.IsMultiple,
//     };
//     setSelectedEditMemberDetail(updatedMemberDetail);
//     setIsEditMemberDetailModalOpen(true);
//   };

//   const handleYojanaSelectClose = () => {
//     setYojanaSelectModal(false);
//     setMemberDetails([]);
//     setFamilyHeadMasterID("");
//     setMemberYojanaDetail([]);
//     setSelectedEditGramYojanaID(null);
//   };

//   const handleShowHideYojanaDetails = (id) => {
//     setOpenYojanaDetails((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const handleCloseEditMemberDetail = () => {
//     setSelectedEditMemberDetail({});
//     setIsEditMemberDetailModalOpen(false);
//   };

//   return (
//     <>
//       <TabStyles />

//       <FilterMemberList filterData={filterData} filterRef={filterRef} filterStatus={filterStatus} setFilterStatus={setFilterStatus} setFilterData={setFilterData} />

//       <div className="flex-grow-1 w-100">
//         {/* ============== BEAUTIFUL TABS ============== */}
//         <ul className="member-list-tabs" role="tablist">
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={isAssignFamily} className={`tab-btn ${isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(true)}>
//               <span className="tab-icon">
//                 <UserCheck size={15} />
//               </span>
//               <span>Members With Family</span>
//               <span className="tab-badge">{tabCounts.FamilyCount.toLocaleString("en-IN")}</span>
//             </button>
//           </li>
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={!isAssignFamily} className={`tab-btn alt ${!isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(false)}>
//               <span className="tab-icon">
//                 <User size={15} />
//               </span>
//               <span>Members Without Family</span>
//               <span className="tab-badge">{tabCounts.WithoutFamilyCount.toLocaleString("en-IN")}</span>
//             </button>
//           </li>
//         </ul>

//         {isLoading || isError || isFetching ? (
//           <TableShimmer theme={DarkTheme ? "dark" : "light"} />
//         ) : (
//           <div className="flex-grow-1 py-0 px-2 w-100">
//             <div className="row g-6 mb-6">
//               <div className="col-sm-12 col-xl-12">
//                 <div className="card">
//                   <div className="card-datatable">
//                     <div id="DataTables_Table_0_wrapper" className="dt-container dt-bootstrap5 dt-empty-footer">
//                       <div className="justify-content-between dt-layout-table px-4">
//                         <div className="d-md-flex justify-content-between align-items-center dt-layout-full table-responsive">
//                           <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
//                             <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />

//                             <button
//                               onClick={handlePrintAllYojanas}
//                               disabled={preparingAllPrint || isExporting}
//                               className="btn btn-danger btn-sm d-flex align-items-center gap-2 ms-3"
//                             >
//                               <Printer size={18} />
//                               {preparingAllPrint ? "Preparing..." : "Print All Yojanas"}
//                             </button>

//                             <div className="dt-buttons btn-group flex-md-row flex-column d-flex gap-3 mb-md-0 mb-4">
//                               <TableFilterButton handleFilterStatusToggle={handleFilterStatusToggle} />
//                               <ExcelButton
//                                 isExportingMain={isExporting}
//                                 isExportingSecondary={isExporting}
//                                 handleExportMain={handleExport}
//                                 primaryExcel="Member Details"
//                                 handleExportSecondary={handleYojanaExport}
//                                 secondaryExcel="Yojana Details"
//                               />
//                             </div>
//                           </div>

//                           <table className="datatables-users Merge-List table dataTable dtr-column" id="DataTables_Table_0">
//                             <thead className="table-header-light border-top">
//                               <tr>
//                                 <th rowSpan={2}>Sr No</th>
//                                 <th rowSpan={2}>Yojana Details</th>
//                                 <th rowSpan={2} style={{ width: "20%", verticalAlign: "middle" }}>
//                                   <Home size={16} className="me-1" />
//                                   Head & Address
//                                 </th>
//                                 <th colSpan={8} className="text-center">
//                                   <Users size={16} className="me-1" />
//                                   Member Details
//                                 </th>
//                               </tr>
//                               <tr>
//                                 <th>Name</th>
//                                 <th>Mobile</th>
//                                 <th>Gender</th>
//                                 <th>Age</th>
//                                 <th>Non Voter</th>
//                                 <th>Death</th>
//                                 <th>Remove</th>
//                                 <th>Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {pages[currentPage]?.data?.map((head, headIndex) => {
//                                 const hasMembers = head.FamilyMemberDetails?.length > 0;
//                                 const absoluteIndex = currentPage * rowsPerPage + headIndex + 1;

//                                 return (
//                                   <React.Fragment key={`head-${headIndex}`}>
//                                     {hasMembers ? (
//                                       <>
//                                         {head.FamilyMemberDetails.map((ele, memberIndex) => (
//                                           <tr key={`${headIndex}-${memberIndex}`}>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {absoluteIndex}
//                                                 </td>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {head.MemberYojnaDetails?.length > 0 && (
//                                                     <i
//                                                       onClick={() => handleShowHideYojanaDetails(head.FamilyHeadMasterID)}
//                                                       className={`icon-base ti tabler-${
//                                                         yojanaDetails[head.FamilyHeadMasterID] ? "chevron-down" : "chevron-right"
//                                                       } icon-md cursor-pointer scaleX-n1-rtl`}
//                                                     />
//                                                   )}
//                                                 </td>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {head.FullNameEnglish}
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Village:</strong> {head.PartNameEnglish}
//                                                   </span>
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Locality:</strong> {head.LocalityEnglish}
//                                                   </span>
//                                                   <br />
//                                                   <br />
//                                                   <div className="d-flex gap-2">
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Death</span>
//                                                       </strong>
//                                                     </label>
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Non Voter</span>
//                                                       </strong>
//                                                     </label>
//                                                   </div>
//                                                   <br />
//                                                   {head?.OverAllFamilyAmount && (
//                                                     <div>
//                                                       <strong>OverAll Yojana Amount: </strong>
//                                                       <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                                     </div>
//                                                   )}
//                                                   <br />
//                                                   {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                                 </td>
//                                               </>
//                                             )}
//                                             <td>
//                                               {ele.FullNameEnglish}
//                                               <br />
//                                               <br />
//                                               {`${ele?.IsHandicap === "true" ? "Handicap" : ""}${ele?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                             </td>
//                                             <td>{ele.MobileNo ? `+91 ${ele.MobileNo}` : ""}</td>
//                                             <td>
//                                               {ele.Gender?.toLowerCase() === "f" ? (
//                                                 <span className="gender-badge female">Female</span>
//                                               ) : ele.Gender?.toLowerCase() === "m" ? (
//                                                 <span className="gender-badge male">Male</span>
//                                               ) : (
//                                                 <span className="gender-badge unknown">N/A</span>
//                                               )}
//                                             </td>
//                                             <td>{ele.Age}</td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "NotVoter", !ele?.NotVoter)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "Death", !ele?.Death)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <Trash2 size={20} color="purple" style={{ cursor: "pointer" }} onClick={() => handleDeleteMember(ele)} />
//                                             </td>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="text-center align-top p-2">
//                                                   <div className="d-flex flex-column gap-2">
//                                                     {/* <button
//                                                       className="btn btn-sm btn-outline-primary fw-semibold"
//                                                       onClick={() => {
//                                                         setAddNewVoterShow(true);
//                                                         setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                       }}
//                                                     >
//                                                       + Add New Voter
//                                                     </button>
//                                                     <button
//                                                       className="btn btn-sm btn-outline-success fw-semibold"
//                                                       onClick={() => {
//                                                         setSelectedVillage(head?.PartNameEnglish);
//                                                         setSelectedLocality(head?.LocalityEnglish);
//                                                         setIsAddExistingModalOpen(true);
//                                                         setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                       }}
//                                                     >
//                                                       Add Existing Voter
//                                                     </button> */}
//                                                     <button
//                                                       className="btn btn-sm btn-outline-warning fw-semibold"
//                                                       onClick={() => {
//                                                         setChangeHeadData(head);
//                                                         setIsChangeHeadOpen(true);
//                                                         setFamilyHeadMasterID(head.FamilyHeadMasterID);
//                                                         setHeadData({
//                                                           ContactDetailID: head?.ContactDetailID,
//                                                           VoterID: head?.VoterID,
//                                                           IsHead: false,
//                                                           IsHandicap: head?.IsHandicap,
//                                                           IsOutSide: head?.IsOutSide,
//                                                         });
//                                                       }}
//                                                     >
//                                                       Change Head
//                                                     </button>
//                                                     {/* <button
//                                                       className="btn btn-sm btn-outline-danger fw-semibold d-flex align-items-center gap-1"
//                                                       onClick={() => handleSelectYojanaChange(head)}
//                                                     >
//                                                       <List size={16} /> Yojana
//                                                     </button> */}
//                                                     {/* {head.MemberYojnaDetails?.length > 0 && (
//                                                       <button onClick={() => printSingleYojana(head)} className="btn btn-sm btn-success d-flex align-items-center gap-1">
//                                                         <Printer size={14} /> Print
//                                                       </button>
//                                                     )} */}
//                                                   </div>
//                                                 </td>
//                                               </>
//                                             )}
//                                           </tr>
//                                         ))}
//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.FamilyHeadMasterID] && (
//                                             <motion.tr
//                                               initial={{ opacity: 0, height: 0 }}
//                                               animate={{ opacity: 1, height: "auto" }}
//                                               exit={{ opacity: 0, height: 0 }}
//                                               style={{ background: "#f7f7f7" }}
//                                             >
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana?.GramYojnaName}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName}
//                                                                     </span>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div key={inx} className="member-row amount-row">
//                                                                   <span className="custom-font indian-currency">
//                                                                     {ele.IsAmount
//                                                                       ? ele?.TimePeriod && ele?.TimePeriod !== "1"
//                                                                         ? `${toIndianCurrency(parseInt(ele?.Amount || 0))} × ${ele?.TimePeriod}`
//                                                                         : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                       : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                   </span>
//                                                                 </div>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod === "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : ""}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">
//                                                                 {yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? toIndianCurrency(yojana.Amount)
//                                                                   : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                                                                     ? toIndianCurrency(yojana.Amount)
//                                                                     : `${yojana?.MemberDetails.length} સંખ્યા`}
//                                                               </span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     ) : (
//                                       /* NO MEMBERS CASE */
//                                       <>
//                                         <tr>
//                                           <td>{absoluteIndex}</td>
//                                           <td>
//                                             {head.MemberYojnaDetails?.length > 0 && (
//                                               <i
//                                                 onClick={() => handleShowHideYojanaDetails(head.FamilyHeadMasterID)}
//                                                 className={`icon-base ti tabler-${
//                                                   yojanaDetails[head.FamilyHeadMasterID] ? "chevron-down" : "chevron-right"
//                                                 } icon-md cursor-pointer scaleX-n1-rtl`}
//                                               />
//                                             )}
//                                           </td>
//                                           <td>
//                                             {head.FullNameEnglish}
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Village:</strong> {head.PartNameEnglish}
//                                             </span>
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Locality:</strong> {head.LocalityEnglish}
//                                             </span>
//                                             <br />
//                                             <br />
//                                             <div className="d-flex gap-2">
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Death</span>
//                                                 </strong>
//                                               </label>
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Non Voter</span>
//                                                 </strong>
//                                               </label>
//                                             </div>
//                                             <br />
//                                             {head?.OverAllFamilyAmount && (
//                                               <div>
//                                                 <strong>OverAll Yojana Amount: </strong>
//                                                 <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                               </div>
//                                             )}
//                                             <br />
//                                             {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}`}
//                                           </td>
//                                           <td colSpan={7} style={{ textAlign: "center", color: "#999" }}>
//                                             No members found
//                                           </td>
//                                           <td className="text-center align-top p-2">
//                                             <div className="d-flex flex-column gap-2">
//                                               {/* <button
//                                                 className="btn btn-sm btn-outline-primary fw-semibold"
//                                                 onClick={() => {
//                                                   setAddNewVoterShow(true);
//                                                   setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                 }}
//                                               >
//                                                 + Add New Voter
//                                               </button>
//                                               <button
//                                                 className="btn btn-sm btn-outline-success fw-semibold"
//                                                 onClick={() => {
//                                                   setSelectedVillage(head?.PartNameEnglish);
//                                                   setSelectedLocality(head?.LocalityEnglish);
//                                                   setIsAddExistingModalOpen(true);
//                                                   setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//                                                 }}
//                                               >
//                                                 Add Existing Voter
//                                               </button>
//                                               <button
//                                                 className="btn btn-sm btn-outline-danger fw-semibold d-flex align-items-center gap-1"
//                                                 onClick={() => handleSelectYojanaChange(head)}
//                                               >
//                                                 <List size={16} /> Yojana
//                                               </button>
//                                               {head.MemberYojnaDetails?.length > 0 && (
//                                                 <button onClick={() => printSingleYojana(head)} className="btn btn-sm btn-success d-flex align-items-center gap-1">
//                                                   <Printer size={14} /> Print
//                                                 </button>
//                                               )} */}
//                                             </div>
//                                           </td>
//                                         </tr>
//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.FamilyHeadMasterID] && (
//                                             <motion.tr style={{ background: "#f7f7f7" }}>
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana.GramYojnaName}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName}
//                                                                     </span>
//                                                                     <small className="entry-date">
//                                                                       <strong>Entry Date:</strong> {ele?.GramYojnaMemberEntryDate ? ele?.GramYojnaMemberEntryDate : "-"}
//                                                                     </small>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <>
//                                                                   <span>
//                                                                     <span className="custom-font indian-currency">
//                                                                       {ele.IsAmount
//                                                                         ? ele?.TimePeriod && ele?.TimePeriod != "1"
//                                                                           ? toIndianCurrency(parseInt(ele?.Amount || 0)) + " × " + ele?.TimePeriod
//                                                                           : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : ele.IsAmountEnterByUser
//                                                                           ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                           : "1"}
//                                                                     </span>{" "}
//                                                                   </span>
//                                                                   <br />
//                                                                 </>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod == "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : ""}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">{toIndianCurrency(yojana.Amount)}</span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     )}

//                                     {/* HIDDEN SINGLE PRINT */}
//                                     {head.MemberYojnaDetails?.length > 0 && (
//                                       <div style={{ display: "none" }}>
//                                         <PrintableSingleYojana ref={(el) => (singlePrintRefs.current[head.FamilyHeadMasterID] = el)} head={head} />
//                                       </div>
//                                     )}
//                                   </React.Fragment>
//                                 );
//                               })}
//                             </tbody>
//                           </table>

//                           <div className="row mx-3 justify-content-between">
//                             <PageEntries start={start} end={end} totalCount={totalCount} />
//                             <PaginationButtons
//                               currentPage={currentPage}
//                               setCurrentPage={setCurrentPage}
//                               goToPage={goToPage}
//                               pages={pages}
//                               hasNextPage={hasNextPage}
//                               fetchNextPage={fetchNextPage}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* HIDDEN ALL YOJANA PRINT */}
//       <div style={{ display: "none" }}>
//         <PrintableAllYojanas ref={allYojanaPrintRef} data={allYojanaData} />
//       </div>

//       {/* MODALS */}
//       <AddNewVoter show={addNewVoterShow} onClose={handleAddNewVoterClose} refetch={refetch} familyHeadMasterID={familyHeadMasterID} />
//       <ChangeHeadModal
//         show={isChangeHeadOpen}
//         data={changeHeadData}
//         handleClose={handleChangeHeadClose}
//         familyHeadMasterID={familyHeadMasterID}
//         refetch={refetch}
//         headData={headData}
//         statusType={statusType}
//         deadNonVoterHeadID={deadNonVoterHeadID}
//       />
//       <AddExistingVoter
//         show={isAddExistingModalOpen}
//         selectedVillage={selectedVillage}
//         selectedLocality={selectedLocality}
//         handleClose={handleCloseAddExistingModal}
//         selectedRecords={selectedRecords}
//         setSelectedRecords={setSelectedRecords}
//         refetchMemberList={refetch}
//         familyHeadMasterID={familyHeadMasterID}
//       />
//       <YojanaSelect
//         selectedEditGramYojanaID={selectedEditGramYojanaID}
//         memberDetails={memberDetails}
//         show={yojanaSelectModalOpen}
//         handleClose={handleYojanaSelectClose}
//         familyHeadMasterID={familyHeadMasterID}
//         memberYojanaDetail={memberYojanaDetail}
//         refetchMemberList={refetch}
//       />

//       <EditYojanaMemberDetail
//         selectedEditMemberDetail={selectedEditMemberDetail}
//         open={isEditMemberDetailModalOpen}
//         onClose={handleCloseEditMemberDetail}
//         refetchMemberList={refetch}
//       />

//       {(inserting || deleting || changeHeadInserting || preparingAllPrint || isExporting) && <Loader />}
//     </>
//   );
// };

// export default ViewMemberList;

// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { AnimatePresence, motion } from "framer-motion";
// import Cookies from "js-cookie";
// import { Home, Printer, User, UserCheck, Users } from "lucide-react";
// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";
// import { toast } from "react-toastify";
// import Swal from "sweetalert2";
// import { useDeleteMember } from "../../API_Master/DeleteMutateAPI";
// import { useMemberListExportExcel } from "../../API_Master/ExcelAPI";
// import { useMemberListDataPagination } from "../../API_Master/FetchAPI";
// import { useNotVoterDeath, useSetChangeHead } from "../../API_Master/MutateAPI";
// import ExcelButton from "../../CommonComponents/ExcelButton";
// import Loader from "../../CommonComponents/Loader";
// import PageCountSelect from "../../CommonComponents/PageCountSelect";
// import PageEntries from "../../CommonComponents/PageEntries";
// import PaginationButtons from "../../CommonComponents/PaginationButtons";
// import TableFilterButton from "../../CommonComponents/TableFilterButton";
// import TableShimmer from "../../Components/TableShimmer";
// import { deleteConfirmation, exportToExcel, notifyError, notifySuccess, toIndianCurrency } from "../../MethodMaster/JSXComponentMothod";
// import { Narendra_Modi_Election_API_URL } from "../../Process";
// import { toggleOffcanvasStatus } from "../../Redux/Slices/ProjectSlice";
// import AddExistingVoter from "../AddExistingVoter/inde";
// import AddNewVoter from "../AddNewVoter";
// import ChangeHeadModal from "../ChangeHeadModal";
// import EditYojanaMemberDetail from "../EditYojanaMemberDetail";
// import YojanaSelect from "../YojanaSelect";
// import FilterMemberList from "./FilterMemberList";

// /* ============================================================
//    VIDHAN SABHA LIST (edit IDs/names here)
//    ============================================================ */
// // const VIDHAN_SABHA_LIST = [
// //   { id: 155, name: "૧૫૫ - ઓલપાડ" },
// //   { id: 156, name: "૧૫૬ - માંડવી" },
// //   { id: 157, name: "૧૫૭ - કામરેજ" },
// //   { id: 158, name: "૧૫૮ - સૂરત ઉત્તર" },
// //   { id: 159, name: "૧૫૯ - સૂરત દક્ષિણ" },
// // ];

// const VIDHAN_SABHA_LIST = [
//   { id: "Sevapuri", name: "Sevapuri" },
//   { id: "Rohaniya", name: "Rohaniya" },
//   { id: "Varanasi North", name: "Varanasi North" },
//   { id: "Varanasi South", name: "Varanasi South" },
//   { id: "Varanasi Cantonment", name: "Varanasi Cantonment" },
// ];

// /* ============================================================
//    BEAUTIFUL TAB STYLES (Vidhan Sabha + Family toggle)
//    ============================================================ */
// const TabStyles = () => (
//   <style>{`
//     /* ---------- Vidhan Sabha pills ---------- */
//     .vidhan-sabha-bar {
//       display: flex;
//       flex-wrap: wrap;
//       gap: 10px;
//       padding: 14px 16px;
//       margin: 16px 16px 0;
//       background: linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%);
//       border-radius: 16px;
//       box-shadow: inset 0 0 0 1px rgba(59, 91, 219, 0.08);
//       list-style: none;
//     }
//     .vidhan-sabha-bar .vs-btn {
//       display: inline-flex;
//       align-items: center;
//       gap: 8px;
//       border: 1px solid rgba(59, 91, 219, 0.15);
//       background: #ffffff;
//       color: #3b4a6b;
//       font-weight: 600;
//       font-size: 13.5px;
//       padding: 8px 16px;
//       border-radius: 999px;
//       cursor: pointer;
//       transition: all 0.22s ease;
//       box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
//     }
//     .vidhan-sabha-bar .vs-btn:hover {
//       border-color: #5b8def;
//       color: #3b5bdb;
//       transform: translateY(-1px);
//       box-shadow: 0 6px 14px -6px rgba(59, 91, 219, 0.4);
//     }
//     .vidhan-sabha-bar .vs-btn.active {
//       color: #ffffff;
//       background: linear-gradient(135deg, #6c8cff 0%, #3b5bdb 100%);
//       border-color: transparent;
//       box-shadow: 0 10px 20px -8px rgba(59, 91, 219, 0.65),
//                   0 2px 6px -1px rgba(59, 91, 219, 0.4);
//       transform: translateY(-2px);
//     }
//     .vidhan-sabha-bar .vs-dot {
//       width: 8px;
//       height: 8px;
//       border-radius: 50%;
//       background: #c7d2fe;
//       transition: background 0.2s ease;
//     }
//     .vidhan-sabha-bar .vs-btn.active .vs-dot {
//       background: #ffffff;
//       box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
//     }

//     .vidhan-sabha-bar .vs-total {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       min-width: 22px;
//       height: 20px;
//       padding: 0 8px;
//       border-radius: 10px;
//       font-size: 11px;
//       font-weight: 700;
//       letter-spacing: 0.3px;
//       background: #eef2ff;
//       color: #3b5bdb;
//       border: 1px solid rgba(59, 91, 219, 0.15);
//     }
//     .vidhan-sabha-bar .vs-btn.active .vs-total {
//       background: rgba(255, 255, 255, 0.25);
//       color: #ffffff;
//       border-color: rgba(255, 255, 255, 0.35);
//     }
//     .theme-dark .vidhan-sabha-bar .vs-total {
//       background: rgba(141, 169, 255, 0.15);
//       color: #8da9ff;
//       border-color: rgba(141, 169, 255, 0.25);
//     }

//     /* ---------- Family / Without Family toggle ---------- */
//     .member-list-tabs {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 8px;
//       padding: 6px;
//       margin: 12px 16px 0;
//       background: #f1f3f9;
//       border-radius: 14px;
//       box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
//       list-style: none;
//       flex-wrap: wrap;
//     }
//     .member-list-tabs .tab-btn {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 10px;
//       border: none;
//       outline: none;
//       cursor: pointer;
//       padding: 10px 20px;
//       border-radius: 10px;
//       font-weight: 600;
//       font-size: 14px;
//       letter-spacing: 0.2px;
//       color: #5a6478;
//       background: transparent;
//       transition: color 0.25s ease, transform 0.2s ease, background 0.25s ease;
//     }
//     .member-list-tabs .tab-btn:hover:not(.active) {
//       color: #3b5bdb;
//       background: rgba(99, 132, 255, 0.08);
//     }
//     .member-list-tabs .tab-btn.active {
//       color: #ffffff;
//       background: linear-gradient(135deg, #5b8def 0%, #3b5bdb 100%);
//       box-shadow: 0 8px 18px -6px rgba(59, 91, 219, 0.55),
//                   0 2px 6px -1px rgba(59, 91, 219, 0.35);
//       transform: translateY(-1px);
//     }
//     .member-list-tabs .tab-btn.active.alt {
//       background: linear-gradient(135deg, #f59f4b 0%, #e8590c 100%);
//       box-shadow: 0 8px 18px -6px rgba(232, 89, 12, 0.55),
//                   0 2px 6px -1px rgba(232, 89, 12, 0.35);
//     }
//     .member-list-tabs .tab-icon {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       width: 26px;
//       height: 26px;
//       border-radius: 50%;
//       background: rgba(59, 91, 219, 0.12);
//       color: #3b5bdb;
//       transition: all 0.25s ease;
//     }
//     .member-list-tabs .tab-btn.active .tab-icon {
//       background: rgba(255, 255, 255, 0.25);
//       color: #ffffff;
//     }
//     .member-list-tabs .tab-badge {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       min-width: 24px;
//       height: 22px;
//       padding: 0 10px;
//       border-radius: 11px;
//       font-size: 12px;
//       font-weight: 700;
//       background: #ffffff;
//       color: #3b5bdb;
//       box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
//       letter-spacing: 0.3px;
//     }
//     .member-list-tabs .tab-btn.active .tab-badge {
//       background: rgba(255, 255, 255, 0.95);
//       color: #3b5bdb;
//     }
//     .member-list-tabs .tab-btn.active.alt .tab-badge {
//       color: #e8590c;
//     }

//     /* ---------- Dark theme ---------- */
//     .theme-dark .vidhan-sabha-bar {
//       background: #1e2230;
//       box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
//     }
//     .theme-dark .vidhan-sabha-bar .vs-btn {
//       background: #2a2f3a;
//       border-color: rgba(255, 255, 255, 0.08);
//       color: #b8c0d0;
//     }
//     .theme-dark .member-list-tabs {
//       background: #2a2f3a;
//       box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
//     }
//     .theme-dark .member-list-tabs .tab-btn { color: #b8c0d0; }
//     .theme-dark .member-list-tabs .tab-icon {
//       background: rgba(141, 169, 255, 0.15);
//       color: #8da9ff;
//     }
//   `}</style>
// );

// /* ============================================================
//    PRINT COMPONENTS (unchanged)
//    ============================================================ */
// const PrintableSingleYojana = React.forwardRef(({ head }, ref) => {
//   return (
//     <div
//       ref={ref}
//       style={{
//         padding: "30px 50px",
//         fontFamily: "Arial, sans-serif",
//         background: "white",
//         color: "#000",
//       }}
//     >
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h3>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>૧૫૫ - ઓલપાડ વિધાનસભા</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ textAlign: "center", color: "#555", fontSize: "16px", marginBottom: "20px" }}>
//         Village: {head.PartNameEnglish} | Locality: {head.LocalityEnglish}
//       </p>

//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "15px",
//           tableLayout: "fixed",
//           marginBottom: "40px",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "43%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>
//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th>No</th>
//             <th>Yojana Name</th>
//             <th>Member & Amount</th>
//             <th>Total Amount</th>
//           </tr>
//         </thead>
//         <tbody>
//           {head.MemberYojnaDetails?.map((yojana, i) => {
//             const memberDetails = yojana.MemberDetails ?? [];
//             const maxNameLen = Math.max(...memberDetails.map((m) => m?.MemberName?.trim().length || 0));
//             const memberList = memberDetails.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const paddedName = name.padEnd(maxNameLen + 2);
//               const amtText = m.IsAmount
//                 ? m?.TimePeriod && m.TimePeriod !== "1"
//                   ? `${amount} × ${m.TimePeriod}`
//                   : amount
//                 : m.IsAmountEnterByUser
//                   ? toIndianCurrency(parseInt(m?.Amount || 0))
//                   : "1";
//               const entryDate = m.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${paddedName} ${amtText}\n   Entry Date: ${entryDate}`;
//             });
//             return (
//               <tr key={i} style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
//                 <td>{i + 1}</td>
//                 <td style={{ fontFamily: "monospace" }}>{yojana.GramYojnaName}</td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
//                   {memberList.join("\n")}
//                   <br />
//                   {yojana?.MemberDetails?.[0]?.TimePeriod === "12" ? " ( દર માસ ) " : yojana?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ textAlign: "right", fontFamily: "monospace" }}>
//                   {yojana?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(yojana.Amount)
//                     : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(yojana.Amount)
//                       : `${yojana?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr style={{ backgroundColor: "#FFF3E0", fontWeight: "bold" }}>
//             <td colSpan={3} style={{ textAlign: "right" }}>
//               Total Amount
//             </td>
//             <td style={{ textAlign: "right" }}>{toIndianCurrency(head.OverAllFamilyAmount || 0)}</td>
//           </tr>
//         </tfoot>
//       </table>
//     </div>
//   );
// });

// const ORIENTATION = "landscape";
// const PAGE_WIDTH_MM = ORIENTATION === "landscape" ? 297 : 210;
// const PAGE_HEIGHT_MM = ORIENTATION === "landscape" ? 210 : 297;
// const TOP_MARGIN_MM = 15;
// const BOTTOM_MARGIN_MM = 15;
// const LEFT_MARGIN_MM = 20;
// const RIGHT_MARGIN_MM = 20;
// const PRINTABLE_HEIGHT_MM = PAGE_HEIGHT_MM - TOP_MARGIN_MM - BOTTOM_MARGIN_MM;
// const PRINTABLE_WIDTH_MM = PAGE_WIDTH_MM - LEFT_MARGIN_MM - RIGHT_MARGIN_MM;
// const PX_TO_MM = 96 / 25.4;

// const PrintableAllYojanas = React.forwardRef(({ data, vidhanSabhaName }, ref) => {
//   const [pageGroups, setPageGroups] = useState([]);
//   const measureRef = useRef(null);

//   useEffect(() => {
//     if (!measureRef.current || !data.length) return;
//     const blocks = measureRef.current.querySelectorAll(".print-block");
//     const heightsPx = Array.from(blocks).map((b) => b.offsetHeight);
//     const printablePx = PRINTABLE_HEIGHT_MM * PX_TO_MM;

//     const groups = [];
//     let curGroup = [];
//     let curHeight = 0;

//     data.forEach((item, i) => {
//       const blockHeight = heightsPx[i];
//       const gap = i === 0 ? 0 : 30;
//       if (curHeight + gap + blockHeight > printablePx && curGroup.length) {
//         groups.push(curGroup);
//         curGroup = [item];
//         curHeight = blockHeight;
//       } else {
//         curGroup.push(item);
//         curHeight += gap + blockHeight;
//       }
//     });
//     if (curGroup.length) groups.push(curGroup);
//     setPageGroups(groups);
//   }, [data]);

//   return (
//     <div ref={ref} style={{ background: "white", fontFamily: "Arial, sans-serif" }}>
//       <div
//         ref={measureRef}
//         style={{
//           padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//           visibility: "hidden",
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: `${PRINTABLE_WIDTH_MM}mm`,
//         }}
//       >
//         {data.map((item, idx) => (
//           <PrintBlock key={idx} item={item} vidhanSabhaName={vidhanSabhaName} />
//         ))}
//       </div>

//       {pageGroups.map((group, pageIdx) => (
//         <div
//           key={pageIdx}
//           className="print-page"
//           style={{
//             width: `${PAGE_WIDTH_MM}mm`,
//             minHeight: `${PAGE_HEIGHT_MM}mm`,
//             padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//             pageBreakAfter: pageIdx < pageGroups.length - 1 ? "always" : "auto",
//             boxSizing: "border-box",
//           }}
//         >
//           {group.map((item, idx) => (
//             <PrintBlock key={idx} item={item} isLastInGroup={idx === group.length - 1} vidhanSabhaName={vidhanSabhaName} />
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// });

// const PrintBlock = React.memo(({ item, isLastInGroup, vidhanSabhaName }) => {
//   const { head, yojanas } = item;

//   return (
//     <div className="print-block" style={{ marginBottom: isLastInGroup ? "0" : "30px", breakInside: "avoid" }}>
//       <h1 style={{ textAlign: "center", color: "#1A237E", fontSize: "32px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h1>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>{vidhanSabhaName || ""}</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ fontSize: "16px", marginBottom: "15px" }}>
//         <strong>Village:</strong> {head.PartNameEnglish} | <strong>Locality:</strong> {head.LocalityEnglish}
//       </p>

//       <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px", tableLayout: "fixed" }}>
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "45%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>

//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th style={{ border: "1px solid #333", padding: "10px" }}>No</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Yojana</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Member & Amount</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Total Amount</th>
//           </tr>
//         </thead>

//         <tbody>
//           {yojanas.map((y, i) => {
//             const memberLines = y.MemberDetails?.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const entryDate = m?.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${name.padEnd(25)} - ${
//                 m.IsAmount ? (m?.TimePeriod && m?.TimePeriod != "1" ? amount + " × " + m?.TimePeriod : amount) : m.IsAmountEnterByUser ? amount : "1"
//               }\n  Entry Date -${entryDate} `;
//             });

//             return (
//               <tr key={i}>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "center", verticalAlign: "top", fontFamily: "monospace" }}>{i + 1}</td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", wordBreak: "break-word", verticalAlign: "top", fontFamily: "monospace" }}>
//                   {y.GramYojnaName}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
//                   {memberLines.join("\n")}
//                   <br />
//                   {y?.MemberDetails?.[0]?.TimePeriod == "12" ? " ( દર માસ ) " : y?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "right", verticalAlign: "top" }}>
//                   {y?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(y.Amount)
//                     : y?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(y.Amount)
//                       : `${y?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr>
//             <td colSpan={4} style={{ borderTop: "1px solid #000", padding: 0 }}></td>
//           </tr>
//           <tr>
//             <td
//               colSpan={3}
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//                 backgroundColor: "#FFF3E0",
//                 border: "1px solid #000",
//                 borderRight: "none",
//               }}
//             >
//               Total Amount
//             </td>
//             <td
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "15px",
//                 color: "#000",
//                 backgroundColor: "#FFF3E0",
//                 fontFamily: "monospace",
//                 border: "1px solid #000",
//               }}
//             >
//               {toIndianCurrency(head.OverAllFamilyAmount || 0)}
//             </td>
//           </tr>
//         </tfoot>
//       </table>
//     </div>
//   );
// });

// /* ============================================================
//    MAIN COMPONENT
//    ============================================================ */
// const ViewMemberList = () => {
//   const { DarkTheme } = useSelector((state) => state.ProjectSlice);
//   const dispatch = useDispatch();

//   const [addNewVoterShow, setAddNewVoterShow] = useState(false);
//   const [changeHeadData, setChangeHeadData] = useState("");
//   const [isChangeHeadOpen, setIsChangeHeadOpen] = useState(false);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [filterData, setFilterData] = useState({});
//   const [familyHeadMasterID, setFamilyHeadMasterID] = useState("");
//   const [headData, setHeadData] = useState({});
//   const [statusType, setStatusType] = useState("");
//   const [deadNonVoterHeadID, setDeadNonVoterHeadID] = useState("");
//   const [selectedVillage, setSelectedVillage] = useState("");
//   const [selectedLocality, setSelectedLocality] = useState("");
//   const [isAddExistingModalOpen, setIsAddExistingModalOpen] = useState(false);
//   const [selectedRecords, setSelectedRecords] = useState({});
//   const [filterStatus, setFilterStatus] = useState(false);
//   const [memberDetails, setMemberDetails] = useState([]);
//   const [yojanaSelectModalOpen, setYojanaSelectModal] = useState(false);
//   const [memberYojanaDetail, setMemberYojanaDetail] = useState([]);
//   const [yojanaDetails, setOpenYojanaDetails] = useState({});
//   const { mutate: addNotVoterDeath, isPending: inserting } = useNotVoterDeath();
//   const [deadNonVoterMemberID, setDeadNonVoterMemberID] = useState("");
//   const [selectedEditGramYojanaID, setSelectedEditGramYojanaID] = useState(null);
//   const [selectedEditMemberDetail, setSelectedEditMemberDetail] = useState({});
//   const [isEditMemberDetailModalOpen, setIsEditMemberDetailModalOpen] = useState(false);

//   // Tab state - default "With Family"
//   const [isAssignFamily, setIsAssignFamily] = useState(true);

//   // NEW: Selected Vidhan Sabha (default = first)
//   // const [selectedVidhanSabha, setSelectedVidhanSabha] = useState(VIDHAN_SABHA_LIST[0].id);

//   // const location = useLocation();

//   // Resolve the initial Vidhan Sabha from:
//   //   1) router state (card click)
//   //   2) localStorage (page refresh / new tab)
//   //   3) first item in the list (default)
//   const resolveInitialVidhanSabha = () => {
//     const validIds = VIDHAN_SABHA_LIST.map((v) => v.id);

//     // 1. Router state
//     // const fromState = location?.state?.Vidhansabha;
//     // console.log("fromState", fromState);
//     // if (fromState && validIds.includes(fromState)) return fromState;

//     // 2. localStorage
//     try {
//       const stored = localStorage.getItem("selectedVidhanSabha");
//       if (stored && validIds.includes(stored)) return stored;
//     } catch (e) {
//       /* ignore */
//     }

//     // 3. Default
//     return VIDHAN_SABHA_LIST[0].id;
//   };

//   const [selectedVidhanSabha, setSelectedVidhanSabha] = useState(resolveInitialVidhanSabha);

//   console.log("selectedVidhanSabha", selectedVidhanSabha);

//   // NEW: Tab counts
//   const [tabCounts, setTabCounts] = useState({
//     FamilyCount: 0,
//     WithoutFamilyCount: 0,
//   });

//   const [vsTotalCounts, setVsTotalCounts] = useState({});

//   // PRINT REFS
//   const singlePrintRefs = useRef({});
//   const allYojanaPrintRef = useRef();
//   const triggerAllPrint = useRef(() => {});
//   const [allYojanaData, setAllYojanaData] = useState([]);
//   const [preparingAllPrint, setPreparingAllPrint] = useState(false);

//   const filterRef = useRef();

//   // 👇 Pass selected Vidhan Sabha through filterData via a merged object
//   const queryFilterData = { ...filterData, VidhanSabha: selectedVidhanSabha };

//   const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useMemberListDataPagination(rowsPerPage, queryFilterData, isAssignFamily);
//   const { mutate: deleteMember, isLoading: deleting } = useDeleteMember();
//   const { mutate: addChangeHead, isPending: changeHeadInserting } = useSetChangeHead();
//   const { mutate: exportMemberList, isPending: isExporting } = useMemberListExportExcel();

//   const pages = data?.pages || [];
//   const totalCount = data?.pages[0]?.TotalCount || 0;
//   const start = currentPage * rowsPerPage + 1;
//   const end = Math.min(start + (pages[currentPage]?.data?.length || 0) - 1, totalCount);

//   // Merge tab + vidhan sabha into payload for exports / prints
//   const effectiveFilterData = {
//     ...filterData,
//     IsAssignFamily: isAssignFamily,
//     VidhanSabha: selectedVidhanSabha,
//   };

//   // Current Vidhan Sabha display name (for print headers)
//   const activeVidhanSabhaName = VIDHAN_SABHA_LIST.find((v) => v.id === selectedVidhanSabha)?.name || "";

//   // ────────────────────────────────────────────────────────────
//   // Fetch global counts for both family tabs (per Vidhan Sabha)
//   // ────────────────────────────────────────────────────────────
//   // useEffect(() => {
//   //   let isMounted = true;

//   //   const fetchTabCounts = async () => {
//   //     try {
//   //       const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

//   //       const outsideValue = outside?.trim()?.toLowerCase() === "true";
//   //       const handicapValue = handicap?.trim()?.toLowerCase() === "true";

//   //       const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberCountWithFamilyAndWithoutFamilly`, {
//   //         method: "POST",
//   //         headers: { "Content-Type": "application/json" },
//   //         body: JSON.stringify({
//   //           Name: name || "",
//   //           MobileNo: mobileNo || "",
//   //           Gender: gender || "",
//   //           IDCardNo: idCardNo || "",
//   //           OutSide: outsideValue,
//   //           Handicap: handicapValue,
//   //           Address: locality || "",
//   //           VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
//   //           IsActive: "true",
//   //           IsDelete: "false",
//   //           IsAssignFamily: isAssignFamily,
//   //           Vidhansabha: selectedVidhanSabha,
//   //         }),
//   //       });

//   //       if (!response.ok) return;

//   //       const result = await response.json();
//   //       if (isMounted && result?.status && result?.data) {
//   //         setTabCounts({
//   //           FamilyCount: Number(result.data.FamilyCount) || 0,
//   //           WithoutFamilyCount: Number(result.data.WithoutFamilyCount) || 0,
//   //         });
//   //         setVsTotalCounts((prev) => ({
//   //           ...prev,
//   //           // [selectedVidhanSabha]: (Number(result.data.FamilyCount) || 0) + (Number(result.data.WithoutFamilyCount) || 0),
//   //           [selectedVidhanSabha]: Number(result.data.TotalCount) || 0,
//   //         }));
//   //       }
//   //     } catch (err) {
//   //       console.error("Failed to fetch member counts:", err);
//   //     }
//   //   };

//   //   fetchTabCounts();

//   //   return () => {
//   //     isMounted = false;
//   //   };
//   // }, [selectedVidhanSabha, filterData]);

//   useEffect(() => {
//     const fetchTabCounts = async () => {
//       try {
//         const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

//         const outsideValue = outside?.trim()?.toLowerCase() === "true";
//         const handicapValue = handicap?.trim()?.toLowerCase() === "true";

//         const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberCountWithFamilyAndWithoutFamilly`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             Name: name || "",
//             MobileNo: mobileNo || "",
//             Gender: gender || "",
//             IDCardNo: idCardNo || "",
//             OutSide: outsideValue,
//             Handicap: handicapValue,
//             Address: locality || "",
//             VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
//             IsActive: "true",
//             IsDelete: "false",
//             IsAssignFamily: isAssignFamily,
//           }),
//         });

//         if (!response.ok) return;

//         const result = await response.json();
//         if (!result?.status || !result?.data) return;

//         // 1. Per-VS totals for the pills — reset the whole map each time
//         const counts = {};
//         (result.data.VidhansabhaCount || []).forEach((row) => {
//           if (row?.Vidhansabha) {
//             counts[row.Vidhansabha] = Number(row.TotalCount) || 0;
//           }
//         });
//         setVsTotalCounts(counts);

//         // 2. Toggle badges for the currently selected VS — reset each time
//         const currentRow = (result.data.VidhansabhaCount || []).find((row) => row?.Vidhansabha === selectedVidhanSabha);

//         setTabCounts({
//           FamilyCount: Number(currentRow?.WithFamilyCount ?? result.data.FamilyCount) || 0,
//           WithoutFamilyCount: Number(currentRow?.WithoutFamilyCount ?? result.data.WithoutFamilyCount) || 0,
//         });
//       } catch (err) {
//         console.error("Failed to fetch member counts:", err);
//       }
//     };

//     fetchTabCounts();
//   }, [selectedVidhanSabha, filterData, isAssignFamily]);

//   // useEffect(() => {
//   //   // let isMounted = true;

//   //   const fetchCounts = async () => {
//   //     try {
//   //       const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

//   //       const outsideValue = outside?.trim()?.toLowerCase() === "true";
//   //       const handicapValue = handicap?.trim()?.toLowerCase() === "true";

//   //       const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberCountWithFamilyAndWithoutFamilly`, {
//   //         method: "POST",
//   //         headers: { "Content-Type": "application/json" },
//   //         body: JSON.stringify({
//   //           Name: name || "",
//   //           MobileNo: mobileNo || "",
//   //           Gender: gender || "",
//   //           IDCardNo: idCardNo || "",
//   //           OutSide: outsideValue,
//   //           Handicap: handicapValue,
//   //           Address: locality || "",
//   //           VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
//   //           IsActive: "true",
//   //           IsDelete: "false",
//   //           IsAssignFamily: isAssignFamily,
//   //           // Vidhansabha: selectedVidhanSabha,
//   //         }),
//   //       });

//   //       if (!response.ok) return;

//   //       const result = await response.json();
//   //       // if (!isMounted || !result?.status || !result?.data) return;

//   //       // Current tab's own counts (for the With / Without Family toggle badges)
//   //       setTabCounts({
//   //         FamilyCount: Number(result.data.FamilyCount) || 0,
//   //         WithoutFamilyCount: Number(result.data.WithoutFamilyCount) || 0,
//   //       });

//   //       // Per-Vidhan-Sabha totals (for the VS pills)
//   //       const counts = {};
//   //       (result.data.VidhansabhaCount || []).forEach((row) => {
//   //         if (row?.Vidhansabha) {
//   //           counts[row.Vidhansabha] = Number(row.TotalCount) || 0;
//   //         }
//   //       });
//   //       setVsTotalCounts(counts);
//   //     } catch (err) {
//   //       console.error("Failed to fetch member counts:", err);
//   //     }
//   //   };

//   //   fetchCounts();

//   //   // return () => {
//   //   //   isMounted = false;
//   //   // };
//   // }, [filterData, isAssignFamily]);

//   // Vidhan Sabha change handler
//   const handleVidhanSabhaChange = (id) => {
//     if (id === selectedVidhanSabha) return;
//     setSelectedVidhanSabha(id);
//     setCurrentPage(0);
//     setOpenYojanaDetails({});
//     setFilterData({});
//   };

//   // Tab change handler
//   const handleTabChange = (value) => {
//     if (value === isAssignFamily) return;
//     setIsAssignFamily(value);
//     setCurrentPage(0);
//     setOpenYojanaDetails({});
//   };

//   // PRINT SINGLE FAMILY
//   const printSingleYojana = (head) => {
//     const node = singlePrintRefs.current[head.FamilyHeadMasterID];
//     if (!node) return;

//     const win = window.open("", "_blank");
//     win.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>${head.FullNameEnglish} - Yojana</title>
//           <style>
//             body { font-family: Arial, sans-serif; background: white; }
//             table { width: 100%; border-collapse: collapse; font-size: 14px; }
//             th, td { border: 1px solid #333; padding: 10px; text-align: left; }
//             th { background: #E8F5E8; }
//             .indian-currency::before { content: "₹"; }
//           </style>
//         </head>
//         <body>${node.innerHTML}</body>
//       </html>
//     `);
//     win.document.close();
//     win.focus();
//     win.print();
//     setTimeout(() => win.close(), 1000);
//   };

//   // PRINT ALL YOJANAS
//   const handlePrintAllYojanas = () => {
//     toast.dismiss();
//     setPreparingAllPrint(true);

//     exportMemberList(effectiveFilterData, {
//       onSuccess: (apiData) => {
//         const printData = apiData.filter((head) => head.MemberYojnaDetails?.length > 0).map((head) => ({ head, yojanas: head.MemberYojnaDetails }));

//         if (printData.length === 0) {
//           notifyError("No Yojana data found");
//           setPreparingAllPrint(false);
//           return;
//         }

//         setAllYojanaData(printData);
//         setTimeout(() => triggerAllPrint.current(), 300);
//       },
//       onError: () => {
//         notifyError("Print failed");
//         setPreparingAllPrint(false);
//       },
//     });
//   };

//   const printAllYojanas = useReactToPrint({
//     contentRef: allYojanaPrintRef,
//     documentTitle: `All_Yojanas_${new Date().toISOString().slice(0, 10)}`,
//     onAfterPrint: () => {
//       setPreparingAllPrint(false);
//       setAllYojanaData([]);
//     },
//   });

//   useEffect(() => {
//     triggerAllPrint.current = printAllYojanas;
//   }, [printAllYojanas]);

//   const handleRowsChange = async (e) => {
//     const limit = parseInt(e.target?.value);
//     setRowsPerPage(limit);
//     setCurrentPage(0);
//     await refetch();
//   };

//   const goToPage = async (index) => {
//     if (pages[index]) {
//       setCurrentPage(index);
//     } else if (hasNextPage) {
//       await fetchNextPage();
//       setCurrentPage(index);
//     }
//   };

//   const handleAddNewVoterClose = () => setAddNewVoterShow(false);

//   const handleChangeHeadClose = () => {
//     setIsChangeHeadOpen(false);
//     setChangeHeadData("");
//     setFamilyHeadMasterID("");
//     setHeadData({});
//     setStatusType("");
//   };

//   const handleCloseAddExistingModal = () => {
//     setSelectedVillage("");
//     setSelectedLocality("");
//     setSelectedRecords({});
//     setIsAddExistingModalOpen(false);
//     setFamilyHeadMasterID("");
//   };

//   const handleSetNonVoterDeath = (ele, StatusType, Status) => {
//     setDeadNonVoterMemberID(ele.ContactDetailID);
//     setStatusType(StatusType);
//     const payload = {
//       ContactDetailID: ele?.ContactDetailID || "",
//       StatusType: StatusType,
//       Death: StatusType === "Death" ? Status : false,
//       NotVoter: StatusType === "NotVoter" ? Status : false,
//       UpdatedByUserID: "",
//     };

//     Swal.fire({
//       title: "Are you sure?",
//       text: `You are marking this member as "${StatusType}".`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, proceed!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         addNotVoterDeath(payload, {
//           onSuccess: (res) => {
//             if (res?.status === true) {
//               notifySuccess("Successfully Inserted", false);
//               refetch();
//             } else {
//               notifyError(res?.message ? res.message : "Data Not Inserted", false);
//             }
//           },
//           onError: () => notifyError("Something went wrong", false),
//         });
//       } else {
//         setDeadNonVoterMemberID("");
//         setStatusType("");
//       }
//     });
//   };

//   const handleDeleteMember = async (item) => {
//     const result = await deleteConfirmation();
//     if (result?.isConfirmed) {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         ContactDetailID: item?.ContactDetailID || "",
//         FamilyMemberDetailID: item?.FamilyMemberDetailID || "",
//         VoterID: item?.VoterID || "",
//       };
//       deleteMember(payload, {
//         onSuccess: (res) => {
//           if (res?.status === true) {
//             notifySuccess("Deleted Successfully", DarkTheme ? true : false);
//             refetch();
//           } else {
//             notifyError(res?.message || "Not Deleted", DarkTheme ? true : false);
//           }
//         },
//         onError: () => notifyError("Something went wrong", false),
//       });
//     }
//   };

//   const handleDeathNotVoterChange = (head, StatusType) => {
//     setFamilyHeadMasterID(head.FamilyHeadMasterID);
//     setDeadNonVoterHeadID(head?.ContactDetailID);
//     setStatusType(StatusType);

//     if (head?.FamilyMemberDetails?.length > 0) {
//       setChangeHeadData(head);
//       setIsChangeHeadOpen(true);
//       setHeadData({
//         ContactDetailID: head?.ContactDetailID,
//         VoterID: head?.VoterID,
//         IsHead: false,
//         IsHandicap: head?.IsHandicap,
//         IsOutSide: head?.IsOutSide,
//       });
//     } else {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         FamilyHeadMasterID: familyHeadMasterID || "",
//         ContactDetailID: head?.ContactDetailID || "",
//         StatusType: StatusType,
//         Death: StatusType?.toLowerCase() === "death" ? true : false,
//         NotVoter: StatusType?.toLowerCase() === "notvoter" ? true : false,
//         FamilyDetail: [],
//       };

//       Swal.fire({
//         title: "Are you sure?",
//         text: `You are marking this head as "${StatusType}".`,
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, proceed!",
//       }).then((result) => {
//         if (result.isConfirmed) {
//           addChangeHead(payload, {
//             onSuccess: (res) => {
//               if (res?.status === true) {
//                 notifySuccess("Successfully Inserted", false);
//                 setFamilyHeadMasterID("");
//                 setStatusType("");
//                 setDeadNonVoterHeadID("");
//                 refetch();
//               } else {
//                 notifyError(res?.message || "Data Not Inserted", false);
//               }
//             },
//             onError: () => notifyError("Something went wrong", false),
//           });
//         } else {
//           setFamilyHeadMasterID("");
//           setDeadNonVoterHeadID("");
//           setStatusType("");
//         }
//       });
//     }
//   };

//   const handleFilterStatusToggle = () => {
//     setFilterStatus(true);
//     dispatch(toggleOffcanvasStatus(true));
//   };

//   const handleExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (MemberListData) => {
//         if (!MemberListData?.length) return notifyError("No Data Found");
//         exportToExcelWithYojanaTable(MemberListData);
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   async function exportToExcelWithYojanaTable(data) {
//     const workbook = new ExcelJS.Workbook();
//     const sheet = workbook.addWorksheet("Family Yojana Report", {
//       pageSetup: { paperSize: 9, orientation: "landscape" },
//     });

//     let rowIndex = 1;
//     let familySr = 1;

//     data.forEach((head) => {
//       const members = head.FamilyMemberDetails || [];
//       const headName = head.FullNameEnglish || "";
//       const village = head.PartNameEnglish || "";
//       const locality = head.LocalityEnglish || "";
//       const overAllAmount = head.OverAllFamilyAmount || 0;

//       const headerRow = sheet.getRow(rowIndex++);
//       headerRow.values = [familySr, headName, village, locality, `₹${Number(overAllAmount).toLocaleString("en-IN")}.00`];
//       headerRow.font = { bold: true, size: 12 };
//       headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6E6E6" } };

//       const memberHeader = sheet.getRow(rowIndex++);
//       memberHeader.values = ["", "Member Name", "Mobile", "Gender", "Age", "ID Card No", "SL No"];
//       memberHeader.font = { bold: true };
//       memberHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9EAD3" } };

//       members.forEach((member) => {
//         const row = sheet.getRow(rowIndex++);
//         row.values = [
//           "",
//           member.FullNameEnglish || "",
//           member.MobileNo || "",
//           member.Gender === "M" ? "Male" : "Female",
//           member.Age || "",
//           member.IDCardNo || "",
//           member.SLNo || "",
//         ];
//       });

//       const yojanaHeader = sheet.getRow(rowIndex++);
//       if (head?.MemberYojnaDetails?.length) {
//         yojanaHeader.values = ["", "Yojana Name", "Members (with Amount)", "Total Amount"];
//         yojanaHeader.font = { bold: true, color: { argb: "FFFFFFFF" } };
//         yojanaHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4CAF50" } };
//       }

//       (head.MemberYojnaDetails || []).forEach((yojna) => {
//         const yojnaName = yojna.GramYojnaName || "";
//         const yojnaTotal = yojna.Amount || "0";
//         const details = yojna.MemberDetails || [];

//         const memberList = details
//           .map((d, i) => {
//             const name = d.MemberName || "Unknown";
//             const amt = d.IsAmount
//               ? d?.TimePeriod && d?.TimePeriod != "1"
//                 ? toIndianCurrency(parseInt(d?.Amount || 0)) + " × " + d?.TimePeriod
//                 : toIndianCurrency(parseInt(d?.Amount || 0))
//               : d.IsAmountEnterByUser
//                 ? toIndianCurrency(parseInt(d?.Amount || 0))
//                 : "1";
//             const entryDate = d?.GramYojnaMemberEntryDate;
//             return `${i + 1}) ${name} (${amt})\n   Entry Date: ${entryDate}`;
//           })
//           .join("\n");

//         const firstRow = sheet.getRow(rowIndex++);
//         firstRow.values = [
//           "",
//           yojnaName,
//           memberList + `${details?.[0]?.TimePeriod == "12" ? "\n ( દર માસ ) " : details?.[0]?.IsAmount ? "\n  ( દર વર્ષે ) " : ""}`,
//           details?.[0]?.IsAmount ? toIndianCurrency(yojnaTotal) : details?.[0]?.IsAmountEnterByUser ? toIndianCurrency(yojnaTotal) : `${details?.length} સંખ્યા`,
//         ];
//         firstRow.getCell(2).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(3).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(4).alignment = { vertical: "middle" };
//         const lines = memberList.split("\n").length;
//         if (lines > 1) {
//           for (let i = 1; i < lines; i++) {
//             const extraRow = sheet.getRow(rowIndex);
//             extraRow.values = ["", "", "", ""];
//             extraRow.getCell(3).value = { formula: `C${rowIndex - lines}` };
//           }
//         }
//         sheet.getRow(rowIndex++).height = 15;
//       });

//       familySr++;
//     });

//     sheet.columns = [{ width: 8 }, { width: 40 }, { width: 40 }, { width: 30 }, { width: 18 }, { width: 15 }, { width: 10 }, { width: 8 }, { width: 18 }, { width: 10 }];

//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], { type: "application/octet-stream" });
//     saveAs(blob, "Family_Yojana_Report.xlsx");
//   }

//   const handleYojanaExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (YojanaListData) => {
//         if (!YojanaListData?.length) return notifyError("No Data Found");
//         const exportData = [];
//         YojanaListData.forEach((head) => {
//           const yojanaDetails = head?.MemberYojnaDetails || [];
//           if (yojanaDetails.length > 0) {
//             yojanaDetails.forEach((yojana) => {
//               const members = yojana?.MemberDetails || [];
//               members.forEach((member) => {
//                 exportData.push({
//                   "Yojana Name": yojana?.GramYojnaName || "",
//                   "Yojana Amount": member?.Amount || "",
//                   "Member Name": member?.MemberName || "",
//                 });
//               });
//             });
//           }
//         });
//         if (exportData.length === 0) return notifyError("No Member Yojana Details Found");
//         exportToExcel(exportData, "Member_Yojana_List");
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   const handleSelectYojanaChange = (head) => {
//     const headData = {
//       FamilyHeadMasterID: head?.FamilyHeadMasterID || "",
//       FamilyMemberDetailID: "",
//       ContactDetailID: head?.ContactDetailID || "",
//       VoterID: head?.VoterID?.toString() || "",
//       FullNameEnglish: head?.FullNameEnglish || "",
//       FullNameGujarati: head?.FullNameGujarati || "",
//       MobileNo: head?.MobileNo || "",
//       Age: head?.Age || "",
//       Gender: head?.Gender || "",
//     };
//     const memberDetails = [
//       ...(head?.FamilyMemberDetails?.map((ele) => ({
//         FamilyMemberDetailID: ele?.FamilyMemberDetailID,
//         FamilyHeadMasterID: ele?.FamilyHeadMasterID || "",
//         ContactDetailID: ele?.ContactDetailID || "",
//         VoterID: ele?.VoterID?.toString() || "",
//         Type: ele?.Type || "",
//         FullNameEnglish: ele?.FullNameEnglish || "",
//         FullNameGujarati: ele?.FullNameGujarati || "",
//         LocalityEnglish: ele?.LocalityEnglish || "",
//         PartNameEnglish: ele?.PartNameEnglish || "",
//         MobileNo: ele?.MobileNo || "",
//         Age: ele?.Age || "",
//         Gender: ele?.Gender || "",
//         NotVoter: ele?.NotVoter || "",
//         Death: ele?.Death || "",
//         OutSide: ele?.OutSide || "",
//         Handicap: ele?.Handicap || "",
//         IDCardNo: ele?.IDCardNo || "",
//         SLNo: ele?.SLNo || "",
//       })) || []),
//       headData,
//     ];

//     setMemberDetails(memberDetails);
//     setYojanaSelectModal(true);
//     setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//     setMemberYojanaDetail(head?.MemberYojnaDetails);
//   };

//   const handleEditMemberYojanaDetail = (head, idx, GramYojnaMemberID) => {
//     const memberDetail = head?.MemberYojnaDetails?.[idx]?.MemberDetails?.find((ele) => ele?.GramYojnaMemberID?.toString() === GramYojnaMemberID.toString());
//     const updatedMemberDetail = {
//       GramYojnaMemberID: memberDetail?.GramYojnaMemberID,
//       GramYojnaID: head?.MemberYojnaDetails?.[idx]?.GramYojnaID,
//       GramYojnaName: head?.MemberYojnaDetails?.[idx]?.GramYojnaName,
//       GramYojnaAmountDetailID: null,
//       Amount: memberDetail?.Amount.toString(),
//       MemberName: memberDetail?.MemberName,
//       IsAmount: memberDetail?.IsAmount,
//       IsAmountEnterByUser: memberDetail?.IsAmountEnterByUser,
//       TimePeriod: memberDetail?.TimePeriod,
//       IsMultiple: memberDetail?.IsMultiple,
//     };
//     setSelectedEditMemberDetail(updatedMemberDetail);
//     setIsEditMemberDetailModalOpen(true);
//   };

//   const handleYojanaSelectClose = () => {
//     setYojanaSelectModal(false);
//     setMemberDetails([]);
//     setFamilyHeadMasterID("");
//     setMemberYojanaDetail([]);
//     setSelectedEditGramYojanaID(null);
//   };

//   const handleShowHideYojanaDetails = (id) => {
//     setOpenYojanaDetails((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const handleCloseEditMemberDetail = () => {
//     setSelectedEditMemberDetail({});
//     setIsEditMemberDetailModalOpen(false);
//   };

//   return (
//     <>
//       <TabStyles />

//       <FilterMemberList
//         filterData={filterData}
//         filterRef={filterRef}
//         filterStatus={filterStatus}
//         setFilterStatus={setFilterStatus}
//         setFilterData={setFilterData}
//         selectedVidhanSabha={selectedVidhanSabha}
//       />

//       <div className="flex-grow-1 w-100">
//         {/* ============== VIDHAN SABHA SELECTOR ============== */}
//         <ul className="vidhan-sabha-bar" role="tablist" aria-label="Vidhan Sabha">
//           {VIDHAN_SABHA_LIST.map((vs) => (
//             <li key={vs.id} role="presentation">
//               <button
//                 type="button"
//                 role="tab"
//                 aria-selected={selectedVidhanSabha === vs.id}
//                 className={`vs-btn ${selectedVidhanSabha === vs.id ? "active" : ""}`}
//                 onClick={() => handleVidhanSabhaChange(vs.id)}
//               >
//                 <span className="vs-dot" />
//                 <span>{vs.name}</span>
//                 {/* <span className="vs-total">{(vsTotalCounts[vs.id] || 0).toLocaleString("en-IN")}</span> */}
//                 <span className="vs-total">{(vsTotalCounts[vs.id] || 0).toLocaleString("en-IN")}</span>
//               </button>
//             </li>
//           ))}
//         </ul>

//         {/* ============== WITH / WITHOUT FAMILY TOGGLE ============== */}
//         <ul className="member-list-tabs" role="tablist">
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={isAssignFamily} className={`tab-btn ${isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(true)}>
//               <span className="tab-icon">
//                 <UserCheck size={15} />
//               </span>
//               <span>Members With Family</span>
//               <span className="tab-badge">{tabCounts.FamilyCount.toLocaleString("en-IN")}</span>
//             </button>
//           </li>
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={!isAssignFamily} className={`tab-btn alt ${!isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(false)}>
//               <span className="tab-icon">
//                 <User size={15} />
//               </span>
//               <span>Members Without Family</span>
//               <span className="tab-badge">{tabCounts.WithoutFamilyCount.toLocaleString("en-IN")}</span>
//             </button>
//           </li>
//         </ul>

//         {isLoading || isError || isFetching ? (
//           <TableShimmer theme={DarkTheme ? "dark" : "light"} />
//         ) : (
//           <div className="flex-grow-1 py-0 px-2 w-100">
//             <div className="row g-6 mb-6">
//               <div className="col-sm-12 col-xl-12">
//                 <div className="card">
//                   <div className="card-datatable">
//                     <div id="DataTables_Table_0_wrapper" className="dt-container dt-bootstrap5 dt-empty-footer">
//                       <div className="justify-content-between dt-layout-table px-4">
//                         <div className="d-md-flex justify-content-between align-items-center dt-layout-full table-responsive">
//                           <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
//                             <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />

//                             <button
//                               onClick={handlePrintAllYojanas}
//                               disabled={preparingAllPrint || isExporting}
//                               className="btn btn-danger btn-sm d-flex align-items-center gap-2 ms-3"
//                             >
//                               <Printer size={18} />
//                               {preparingAllPrint ? "Preparing..." : "Print All Yojanas"}
//                             </button>

//                             <div className="dt-buttons btn-group flex-md-row flex-column d-flex gap-3 mb-md-0 mb-4">
//                               <TableFilterButton handleFilterStatusToggle={handleFilterStatusToggle} />
//                               <ExcelButton
//                                 isExportingMain={isExporting}
//                                 isExportingSecondary={isExporting}
//                                 handleExportMain={handleExport}
//                                 primaryExcel="Member Details"
//                                 handleExportSecondary={handleYojanaExport}
//                                 secondaryExcel="Yojana Details"
//                               />
//                             </div>
//                           </div>

//                           <table className="datatables-users Merge-List table dataTable dtr-column" id="DataTables_Table_0">
//                             <thead className="table-header-light border-top">
//                               <tr>
//                                 <th rowSpan={2}>Sr No</th>
//                                 <th rowSpan={2}>Yojana Details</th>
//                                 <th rowSpan={2} style={{ width: "20%", verticalAlign: "middle" }}>
//                                   <Home size={16} className="me-1" />
//                                   Head &amp; Address
//                                 </th>
//                                 <th colSpan={8} className="text-center">
//                                   <Users size={16} className="me-1" />
//                                   Member Details
//                                 </th>
//                               </tr>
//                               <tr>
//                                 <th>Family Member</th>
//                                 <th>Mobile</th>
//                                 <th>Gender</th>
//                                 <th>Age</th>
//                                 <th>Non Voter</th>
//                                 <th>Death</th>
//                                 {/* <th>Remove</th> */}
//                                 <th>Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {pages[currentPage]?.data?.map((head, headIndex) => {
//                                 const hasMembers = head.FamilyMemberDetails?.length > 0;
//                                 const absoluteIndex = currentPage * rowsPerPage + headIndex + 1;

//                                 return (
//                                   <React.Fragment key={`head-${headIndex}`}>
//                                     {hasMembers ? (
//                                       <>
//                                         {head.FamilyMemberDetails.map((ele, memberIndex) => (
//                                           <tr key={`${headIndex}-${memberIndex}`}>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 {/* <td rowSpan={head.FamilyMemberDetails.length} className="align-top"> */}
//                                                 <td rowSpan={head.MemberYojnaDetails.length} className="align-top">
//                                                   {absoluteIndex}
//                                                 </td>
//                                                 {/* <td rowSpan={head.FamilyMemberDetails.length} className="align-top"> */}
//                                                 <td rowSpan={head.MemberYojnaDetails.length} className="align-top">
//                                                   {head.MemberYojnaDetails?.length > 0 && (
//                                                     <i
//                                                       // onClick={() => handleShowHideYojanaDetails(head.FamilyHeadMasterID)}
//                                                       onClick={() => handleShowHideYojanaDetails(head.VoterID)}
//                                                       className={`icon-base ti tabler-${
//                                                         yojanaDetails[head.VoterID] ? "chevron-down" : "chevron-right"
//                                                       } icon-md cursor-pointer scaleX-n1-rtl`}
//                                                     />
//                                                   )}
//                                                 </td>
//                                                 <td rowSpan={head.FamilyMemberDetails.length} className="align-top">
//                                                   {head.FullNameEnglish || "-"}
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Village / Area:</strong> {head.PartNameEnglish || "-"}
//                                                   </span>
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Locality:</strong> {head.LocalityEnglish || "-"}
//                                                   </span>
//                                                   <br />
//                                                   <br />
//                                                   <div className="d-flex gap-2">
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Death</span>
//                                                       </strong>
//                                                     </label>
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Non Voter</span>
//                                                       </strong>
//                                                     </label>
//                                                   </div>
//                                                   <br />
//                                                   {head?.OverAllFamilyAmount ? (
//                                                     <div>
//                                                       <strong>OverAll Yojana Amount: </strong>
//                                                       <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                                     </div>
//                                                   ) : (
//                                                     <div>
//                                                       <strong>OverAll Yojana Amount: </strong>
//                                                       <span>-</span>
//                                                     </div>
//                                                   )}
//                                                   <br />
//                                                   {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                                 </td>
//                                               </>
//                                             )}
//                                             <td>
//                                               {ele.FullNameEnglish || "-"}
//                                               <br />
//                                               <br />
//                                               {`${ele?.IsHandicap === "true" ? "Handicap" : ""}${ele?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                             </td>
//                                             <td>{ele.MobileNo ? `+91 ${ele.MobileNo}` : "-"}</td>
//                                             <td>
//                                               {ele.Gender?.toLowerCase() === "f" ? (
//                                                 <span className="gender-badge female">Female</span>
//                                               ) : ele.Gender?.toLowerCase() === "m" ? (
//                                                 <span className="gender-badge male">Male</span>
//                                               ) : ele.Gender?.toLowerCase() === "other" ? (
//                                                 <span className="gender-badge unknown">Other</span>
//                                               ) : (
//                                                 <span className="gender-badge unknown">-</span>
//                                               )}
//                                             </td>
//                                             <td>{ele.Age || "-"}</td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "NotVoter", !ele?.NotVoter)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "Death", !ele?.Death)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             {/* <td>
//                                               <Trash2 size={20} color="purple" style={{ cursor: "pointer" }} onClick={() => handleDeleteMember(ele)} />
//                                             </td> */}
//                                             {memberIndex === 0 && (
//                                               <td rowSpan={head.FamilyMemberDetails.length} className="text-center align-top p-2">
//                                                 <div className="d-flex flex-column gap-2">
//                                                   <button
//                                                     className="btn btn-sm btn-outline-warning fw-semibold"
//                                                     onClick={() => {
//                                                       setChangeHeadData(head);
//                                                       setIsChangeHeadOpen(true);
//                                                       setFamilyHeadMasterID(head.FamilyHeadMasterID);
//                                                       setHeadData({
//                                                         ContactDetailID: head?.ContactDetailID,
//                                                         VoterID: head?.VoterID,
//                                                         IsHead: false,
//                                                         IsHandicap: head?.IsHandicap,
//                                                         IsOutSide: head?.IsOutSide,
//                                                       });
//                                                     }}
//                                                   >
//                                                     Change Head
//                                                   </button>
//                                                 </div>
//                                               </td>
//                                             )}
//                                           </tr>
//                                         ))}

//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.VoterID] && (
//                                             <motion.tr
//                                               initial={{ opacity: 0, height: 0 }}
//                                               animate={{ opacity: 1, height: "auto" }}
//                                               exit={{ opacity: 0, height: 0 }}
//                                               style={{ background: "#f7f7f7" }}
//                                             >
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana?.GramYojnaName || "-"}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName || "-"}
//                                                                     </span>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div key={inx} className="member-row amount-row">
//                                                                   <span className="custom-font indian-currency">
//                                                                     {ele.IsAmount
//                                                                       ? ele?.TimePeriod && ele?.TimePeriod !== "1"
//                                                                         ? `${toIndianCurrency(parseInt(ele?.Amount || 0))} × ${ele?.TimePeriod}`
//                                                                         : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                       : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                   </span>
//                                                                 </div>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod === "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : "-"}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">
//                                                                 {yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? toIndianCurrency(yojana.Amount)
//                                                                   : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                                                                     ? toIndianCurrency(yojana.Amount)
//                                                                     : yojana?.MemberDetails?.length
//                                                                       ? `${yojana.MemberDetails.length} સંખ્યા`
//                                                                       : "-"}
//                                                               </span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     ) : (
//                                       <>
//                                         <tr>
//                                           {/* Sr No */}
//                                           <td>{absoluteIndex}</td>

//                                           {/* Yojana Details expander */}
//                                           <td>
//                                             {head.MemberYojnaDetails?.length > 0 && (
//                                               <i
//                                                 onClick={() => handleShowHideYojanaDetails(head.VoterID)}
//                                                 className={`icon-base ti tabler-${
//                                                   yojanaDetails[head.VoterID] ? "chevron-down" : "chevron-right"
//                                                 } icon-md cursor-pointer scaleX-n1-rtl`}
//                                               />
//                                             )}
//                                           </td>

//                                           {/* Head & Address */}
//                                           <td>
//                                             {head.FullNameEnglish || "-"}
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Village / Area:</strong> {head.PartNameEnglish || "-"}
//                                             </span>
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Locality:</strong> {head.LocalityEnglish || "-"}
//                                             </span>
//                                             <br />
//                                             <br />

//                                             <div className="d-flex gap-2">
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Death</span>
//                                                 </strong>
//                                               </label>
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Non Voter</span>
//                                                 </strong>
//                                               </label>
//                                             </div>

//                                             <br />
//                                             {head?.OverAllFamilyAmount ? (
//                                               <div>
//                                                 <strong>OverAll Yojana Amount: </strong>
//                                                 <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                               </div>
//                                             ) : (
//                                               <div>
//                                                 <strong>OverAll Yojana Amount: </strong>
//                                                 <span>-</span>
//                                               </div>
//                                             )}
//                                             <br />
//                                             {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                           </td>

//                                           {/* Name */}
//                                           <td>
//                                             {head.FullNameEnglish || "-"}
//                                             <div
//                                               style={{
//                                                 marginTop: "4px",
//                                                 fontSize: "11px",
//                                                 fontStyle: "italic",
//                                                 color: "#9aa4b2",
//                                                 lineHeight: 1.2,
//                                               }}
//                                             >
//                                               (Head — no family members linked)
//                                             </div>
//                                             <br />
//                                             {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                           </td>

//                                           {/* Mobile */}
//                                           <td>{head.MobileNo ? `+91 ${head.MobileNo}` : "-"}</td>

//                                           {/* Gender */}
//                                           <td>
//                                             {head.Gender?.toLowerCase() === "f" ? (
//                                               <span className="gender-badge female">Female</span>
//                                             ) : head.Gender?.toLowerCase() === "m" ? (
//                                               <span className="gender-badge male">Male</span>
//                                             ) : (
//                                               <span className="gender-badge unknown">-</span>
//                                             )}
//                                           </td>

//                                           {/* Age */}
//                                           <td>{head.Age || "-"}</td>

//                                           {/* Non Voter */}
//                                           <td>
//                                             <input
//                                               type="checkbox"
//                                               checked={head?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
//                                               onChange={() => handleSetNonVoterDeath(head, "NotVoter", !head?.NotVoter)}
//                                               style={{ width: "18px", height: "18px" }}
//                                             />
//                                           </td>

//                                           {/* Death */}
//                                           <td>
//                                             <input
//                                               type="checkbox"
//                                               checked={head?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
//                                               onChange={() => handleSetNonVoterDeath(head, "Death", !head?.Death)}
//                                               style={{ width: "18px", height: "18px" }}
//                                             />
//                                           </td>

//                                           {/* Remove */}
//                                           {/* <td>
//                                             <Trash2 size={20} color="purple" style={{ cursor: "pointer" }} onClick={() => handleDeleteMember(head)} />
//                                           </td> */}

//                                           {/* Actions */}
//                                           <td className="text-center align-top p-2">
//                                             <div className="d-flex flex-column gap-2">
//                                               <button
//                                                 className="btn btn-sm btn-outline-warning fw-semibold"
//                                                 onClick={() => {
//                                                   setChangeHeadData(head);
//                                                   setIsChangeHeadOpen(true);
//                                                   setFamilyHeadMasterID(head.FamilyHeadMasterID);
//                                                   setHeadData({
//                                                     ContactDetailID: head?.ContactDetailID,
//                                                     VoterID: head?.VoterID,
//                                                     IsHead: false,
//                                                     IsHandicap: head?.IsHandicap,
//                                                     IsOutSide: head?.IsOutSide,
//                                                   });
//                                                 }}
//                                               >
//                                                 Change Head
//                                               </button>
//                                             </div>
//                                           </td>
//                                         </tr>
//                                         <AnimatePresence>
//                                           {yojanaDetails[head?.VoterID] && (
//                                             <motion.tr
//                                               initial={{ opacity: 0, height: 0 }}
//                                               animate={{ opacity: 1, height: "auto" }}
//                                               exit={{ opacity: 0, height: 0 }}
//                                               style={{ background: "#f7f7f7" }}
//                                             >
//                                               <td colSpan={12} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana?.GramYojnaName || "-"}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName || "-"}
//                                                                     </span>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div key={inx} className="member-row amount-row">
//                                                                   <span className="custom-font indian-currency">
//                                                                     {ele.IsAmount
//                                                                       ? ele?.TimePeriod && ele?.TimePeriod !== "1"
//                                                                         ? `${toIndianCurrency(parseInt(ele?.Amount || 0))} × ${ele?.TimePeriod}`
//                                                                         : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                       : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                   </span>
//                                                                 </div>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod === "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : "-"}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">
//                                                                 {yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? toIndianCurrency(yojana.Amount)
//                                                                   : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                                                                     ? toIndianCurrency(yojana.Amount)
//                                                                     : yojana?.MemberDetails?.length
//                                                                       ? `${yojana.MemberDetails.length} સંખ્યા`
//                                                                       : "-"}
//                                                               </span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     )}

//                                     {head.MemberYojnaDetails?.length > 0 && (
//                                       <div style={{ display: "none" }}>
//                                         <PrintableSingleYojana ref={(el) => (singlePrintRefs.current[head.FamilyHeadMasterID] = el)} head={head} />
//                                       </div>
//                                     )}
//                                   </React.Fragment>
//                                 );
//                               })}
//                             </tbody>
//                           </table>

//                           <div className="row mx-3 justify-content-between">
//                             <PageEntries start={start} end={end} totalCount={totalCount} />
//                             <PaginationButtons
//                               currentPage={currentPage}
//                               setCurrentPage={setCurrentPage}
//                               goToPage={goToPage}
//                               pages={pages}
//                               hasNextPage={hasNextPage}
//                               fetchNextPage={fetchNextPage}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* HIDDEN ALL YOJANA PRINT */}
//       <div style={{ display: "none" }}>
//         <PrintableAllYojanas ref={allYojanaPrintRef} data={allYojanaData} vidhanSabhaName={activeVidhanSabhaName} />
//       </div>

//       {/* MODALS */}
//       <AddNewVoter show={addNewVoterShow} onClose={handleAddNewVoterClose} refetch={refetch} familyHeadMasterID={familyHeadMasterID} />
//       <ChangeHeadModal
//         show={isChangeHeadOpen}
//         data={changeHeadData}
//         handleClose={handleChangeHeadClose}
//         familyHeadMasterID={familyHeadMasterID}
//         refetch={refetch}
//         headData={headData}
//         statusType={statusType}
//         deadNonVoterHeadID={deadNonVoterHeadID}
//       />
//       <AddExistingVoter
//         show={isAddExistingModalOpen}
//         selectedVillage={selectedVillage}
//         selectedLocality={selectedLocality}
//         handleClose={handleCloseAddExistingModal}
//         selectedRecords={selectedRecords}
//         setSelectedRecords={setSelectedRecords}
//         refetchMemberList={refetch}
//         familyHeadMasterID={familyHeadMasterID}
//       />
//       <YojanaSelect
//         selectedEditGramYojanaID={selectedEditGramYojanaID}
//         memberDetails={memberDetails}
//         show={yojanaSelectModalOpen}
//         handleClose={handleYojanaSelectClose}
//         familyHeadMasterID={familyHeadMasterID}
//         memberYojanaDetail={memberYojanaDetail}
//         refetchMemberList={refetch}
//       />

//       <EditYojanaMemberDetail
//         selectedEditMemberDetail={selectedEditMemberDetail}
//         open={isEditMemberDetailModalOpen}
//         onClose={handleCloseEditMemberDetail}
//         refetchMemberList={refetch}
//       />

//       {(inserting || deleting || changeHeadInserting || preparingAllPrint || isExporting) && <Loader />}
//     </>
//   );
// };

// export default ViewMemberList;

// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { AnimatePresence, motion } from "framer-motion";
// import Cookies from "js-cookie";
// import { Home, Printer, User, UserCheck, Users } from "lucide-react";
// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";
// import { toast } from "react-toastify";
// import Swal from "sweetalert2";
// import { useDeleteMember } from "../../API_Master/DeleteMutateAPI";
// import { useMemberListExportExcel } from "../../API_Master/ExcelAPI";
// import { useMemberListDataPagination } from "../../API_Master/FetchAPI";
// import { useNotVoterDeath, useSetChangeHead } from "../../API_Master/MutateAPI";
// import ExcelButton from "../../CommonComponents/ExcelButton";
// import Loader from "../../CommonComponents/Loader";
// import PageCountSelect from "../../CommonComponents/PageCountSelect";
// import PageEntries from "../../CommonComponents/PageEntries";
// import PaginationButtons from "../../CommonComponents/PaginationButtons";
// import TableFilterButton from "../../CommonComponents/TableFilterButton";
// import TableShimmer from "../../Components/TableShimmer";
// import { deleteConfirmation, exportToExcel, notifyError, notifySuccess, toIndianCurrency } from "../../MethodMaster/JSXComponentMothod";
// import { Narendra_Modi_Election_API_URL } from "../../Process";
// import { toggleOffcanvasStatus } from "../../Redux/Slices/ProjectSlice";
// import AddExistingVoter from "../AddExistingVoter/inde";
// import AddNewVoter from "../AddNewVoter";
// import ChangeHeadModal from "../ChangeHeadModal";
// import EditYojanaMemberDetail from "../EditYojanaMemberDetail";
// import YojanaSelect from "../YojanaSelect";
// import FilterMemberList from "./FilterMemberList";

// /* ============================================================
//    VIDHAN SABHA LIST
//    ============================================================ */
// const VIDHAN_SABHA_LIST = [
//   { id: "Sevapuri", name: "Sevapuri" },
//   { id: "Rohaniya", name: "Rohaniya" },
//   { id: "Varanasi North", name: "Varanasi North" },
//   { id: "Varanasi South", name: "Varanasi South" },
//   { id: "Varanasi Cantonment", name: "Varanasi Cantonment" },
// ];

// /* ============================================================
//    BEAUTIFUL TAB STYLES
//    ============================================================ */
// const TabStyles = () => (
//   <style>{`
//     .vidhan-sabha-bar {
//       display: flex;
//       flex-wrap: wrap;
//       gap: 10px;
//       padding: 14px 16px;
//       margin: 16px 16px 0;
//       background: linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%);
//       border-radius: 16px;
//       box-shadow: inset 0 0 0 1px rgba(59, 91, 219, 0.08);
//       list-style: none;
//     }
//     .vidhan-sabha-bar .vs-btn {
//       display: inline-flex;
//       align-items: center;
//       gap: 8px;
//       border: 1px solid rgba(59, 91, 219, 0.15);
//       background: #ffffff;
//       color: #3b4a6b;
//       font-weight: 600;
//       font-size: 13.5px;
//       padding: 8px 16px;
//       border-radius: 999px;
//       cursor: pointer;
//       transition: all 0.22s ease;
//       box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
//     }
//     .vidhan-sabha-bar .vs-btn:hover {
//       border-color: #5b8def;
//       color: #3b5bdb;
//       transform: translateY(-1px);
//       box-shadow: 0 6px 14px -6px rgba(59, 91, 219, 0.4);
//     }
//     .vidhan-sabha-bar .vs-btn.active {
//       color: #ffffff;
//       background: linear-gradient(135deg, #6c8cff 0%, #3b5bdb 100%);
//       border-color: transparent;
//       box-shadow: 0 10px 20px -8px rgba(59, 91, 219, 0.65),
//                   0 2px 6px -1px rgba(59, 91, 219, 0.4);
//       transform: translateY(-2px);
//     }
//     .vidhan-sabha-bar .vs-dot {
//       width: 8px;
//       height: 8px;
//       border-radius: 50%;
//       background: #c7d2fe;
//       transition: background 0.2s ease;
//     }
//     .vidhan-sabha-bar .vs-btn.active .vs-dot {
//       background: #ffffff;
//       box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
//     }
//     .vidhan-sabha-bar .vs-total {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       min-width: 22px;
//       height: 20px;
//       padding: 0 8px;
//       border-radius: 10px;
//       font-size: 11px;
//       font-weight: 700;
//       letter-spacing: 0.3px;
//       background: #eef2ff;
//       color: #3b5bdb;
//       border: 1px solid rgba(59, 91, 219, 0.15);
//     }
//     .vidhan-sabha-bar .vs-btn.active .vs-total {
//       background: rgba(255, 255, 255, 0.25);
//       color: #ffffff;
//       border-color: rgba(255, 255, 255, 0.35);
//     }
//     .theme-dark .vidhan-sabha-bar .vs-total {
//       background: rgba(141, 169, 255, 0.15);
//       color: #8da9ff;
//       border-color: rgba(141, 169, 255, 0.25);
//     }

//     .member-list-tabs {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 8px;
//       padding: 6px;
//       margin: 12px 16px 0;
//       background: #f1f3f9;
//       border-radius: 14px;
//       box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
//       list-style: none;
//       flex-wrap: wrap;
//     }
//     .member-list-tabs .tab-btn {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 10px;
//       border: none;
//       outline: none;
//       cursor: pointer;
//       padding: 10px 20px;
//       border-radius: 10px;
//       font-weight: 600;
//       font-size: 14px;
//       letter-spacing: 0.2px;
//       color: #5a6478;
//       background: transparent;
//       transition: color 0.25s ease, transform 0.2s ease, background 0.25s ease;
//     }
//     .member-list-tabs .tab-btn:hover:not(.active) {
//       color: #3b5bdb;
//       background: rgba(99, 132, 255, 0.08);
//     }
//     .member-list-tabs .tab-btn.active {
//       color: #ffffff;
//       background: linear-gradient(135deg, #5b8def 0%, #3b5bdb 100%);
//       box-shadow: 0 8px 18px -6px rgba(59, 91, 219, 0.55),
//                   0 2px 6px -1px rgba(59, 91, 219, 0.35);
//       transform: translateY(-1px);
//     }
//     .member-list-tabs .tab-btn.active.alt {
//       background: linear-gradient(135deg, #f59f4b 0%, #e8590c 100%);
//       box-shadow: 0 8px 18px -6px rgba(232, 89, 12, 0.55),
//                   0 2px 6px -1px rgba(232, 89, 12, 0.35);
//     }
//     .member-list-tabs .tab-icon {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       width: 26px;
//       height: 26px;
//       border-radius: 50%;
//       background: rgba(59, 91, 219, 0.12);
//       color: #3b5bdb;
//       transition: all 0.25s ease;
//     }
//     .member-list-tabs .tab-btn.active .tab-icon {
//       background: rgba(255, 255, 255, 0.25);
//       color: #ffffff;
//     }
//     .member-list-tabs .tab-badge {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       min-width: 24px;
//       height: 22px;
//       padding: 0 10px;
//       border-radius: 11px;
//       font-size: 12px;
//       font-weight: 700;
//       background: #ffffff;
//       color: #3b5bdb;
//       box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
//       letter-spacing: 0.3px;
//     }
//     .member-list-tabs .tab-btn.active .tab-badge {
//       background: rgba(255, 255, 255, 0.95);
//       color: #3b5bdb;
//     }
//     .member-list-tabs .tab-btn.active.alt .tab-badge {
//       color: #e8590c;
//     }

//     .theme-dark .vidhan-sabha-bar {
//       background: #1e2230;
//       box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
//     }
//     .theme-dark .vidhan-sabha-bar .vs-btn {
//       background: #2a2f3a;
//       border-color: rgba(255, 255, 255, 0.08);
//       color: #b8c0d0;
//     }
//     .theme-dark .member-list-tabs {
//       background: #2a2f3a;
//       box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
//     }
//     .theme-dark .member-list-tabs .tab-btn { color: #b8c0d0; }
//     .theme-dark .member-list-tabs .tab-icon {
//       background: rgba(141, 169, 255, 0.15);
//       color: #8da9ff;
//     }
//   `}</style>
// );

// /* ============================================================
//    PRINT COMPONENTS (unchanged)
//    ============================================================ */
// const PrintableSingleYojana = React.forwardRef(({ head }, ref) => {
//   return (
//     <div
//       ref={ref}
//       style={{
//         padding: "30px 50px",
//         fontFamily: "Arial, sans-serif",
//         background: "white",
//         color: "#000",
//       }}
//     >
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h3>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>૧૫૫ - ઓલપાડ વિધાનસભા</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ textAlign: "center", color: "#555", fontSize: "16px", marginBottom: "20px" }}>
//         Village: {head.PartNameEnglish} | Locality: {head.LocalityEnglish}
//       </p>

//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           fontSize: "15px",
//           tableLayout: "fixed",
//           marginBottom: "40px",
//         }}
//       >
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "43%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>
//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th>No</th>
//             <th>Yojana Name</th>
//             <th>Member & Amount</th>
//             <th>Total Amount</th>
//           </tr>
//         </thead>
//         <tbody>
//           {head.MemberYojnaDetails?.map((yojana, i) => {
//             const memberDetails = yojana.MemberDetails ?? [];
//             const maxNameLen = Math.max(...memberDetails.map((m) => m?.MemberName?.trim().length || 0));
//             const memberList = memberDetails.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const paddedName = name.padEnd(maxNameLen + 2);
//               const amtText = m.IsAmount
//                 ? m?.TimePeriod && m.TimePeriod !== "1"
//                   ? `${amount} × ${m.TimePeriod}`
//                   : amount
//                 : m.IsAmountEnterByUser
//                   ? toIndianCurrency(parseInt(m?.Amount || 0))
//                   : "1";
//               const entryDate = m.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${paddedName} ${amtText}\n   Entry Date: ${entryDate}`;
//             });
//             return (
//               <tr key={i} style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
//                 <td>{i + 1}</td>
//                 <td style={{ fontFamily: "monospace" }}>{yojana.GramYojnaName}</td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
//                   {memberList.join("\n")}
//                   <br />
//                   {yojana?.MemberDetails?.[0]?.TimePeriod === "12" ? " ( દર માસ ) " : yojana?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ textAlign: "right", fontFamily: "monospace" }}>
//                   {yojana?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(yojana.Amount)
//                     : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(yojana.Amount)
//                       : `${yojana?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr style={{ backgroundColor: "#FFF3E0", fontWeight: "bold" }}>
//             <td colSpan={3} style={{ textAlign: "right" }}>
//               Total Amount
//             </td>
//             <td style={{ textAlign: "right" }}>{toIndianCurrency(head.OverAllFamilyAmount || 0)}</td>
//           </tr>
//         </tfoot>
//       </table>
//     </div>
//   );
// });

// const ORIENTATION = "landscape";
// const PAGE_WIDTH_MM = ORIENTATION === "landscape" ? 297 : 210;
// const PAGE_HEIGHT_MM = ORIENTATION === "landscape" ? 210 : 297;
// const TOP_MARGIN_MM = 15;
// const BOTTOM_MARGIN_MM = 15;
// const LEFT_MARGIN_MM = 20;
// const RIGHT_MARGIN_MM = 20;
// const PRINTABLE_HEIGHT_MM = PAGE_HEIGHT_MM - TOP_MARGIN_MM - BOTTOM_MARGIN_MM;
// const PRINTABLE_WIDTH_MM = PAGE_WIDTH_MM - LEFT_MARGIN_MM - RIGHT_MARGIN_MM;
// const PX_TO_MM = 96 / 25.4;

// const PrintableAllYojanas = React.forwardRef(({ data, vidhanSabhaName }, ref) => {
//   const [pageGroups, setPageGroups] = useState([]);
//   const measureRef = useRef(null);

//   useEffect(() => {
//     if (!measureRef.current || !data.length) return;
//     const blocks = measureRef.current.querySelectorAll(".print-block");
//     const heightsPx = Array.from(blocks).map((b) => b.offsetHeight);
//     const printablePx = PRINTABLE_HEIGHT_MM * PX_TO_MM;

//     const groups = [];
//     let curGroup = [];
//     let curHeight = 0;

//     data.forEach((item, i) => {
//       const blockHeight = heightsPx[i];
//       const gap = i === 0 ? 0 : 30;
//       if (curHeight + gap + blockHeight > printablePx && curGroup.length) {
//         groups.push(curGroup);
//         curGroup = [item];
//         curHeight = blockHeight;
//       } else {
//         curGroup.push(item);
//         curHeight += gap + blockHeight;
//       }
//     });
//     if (curGroup.length) groups.push(curGroup);
//     setPageGroups(groups);
//   }, [data]);

//   return (
//     <div ref={ref} style={{ background: "white", fontFamily: "Arial, sans-serif" }}>
//       <div
//         ref={measureRef}
//         style={{
//           padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//           visibility: "hidden",
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: `${PRINTABLE_WIDTH_MM}mm`,
//         }}
//       >
//         {data.map((item, idx) => (
//           <PrintBlock key={idx} item={item} vidhanSabhaName={vidhanSabhaName} />
//         ))}
//       </div>

//       {pageGroups.map((group, pageIdx) => (
//         <div
//           key={pageIdx}
//           className="print-page"
//           style={{
//             width: `${PAGE_WIDTH_MM}mm`,
//             minHeight: `${PAGE_HEIGHT_MM}mm`,
//             padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
//             pageBreakAfter: pageIdx < pageGroups.length - 1 ? "always" : "auto",
//             boxSizing: "border-box",
//           }}
//         >
//           {group.map((item, idx) => (
//             <PrintBlock key={idx} item={item} isLastInGroup={idx === group.length - 1} vidhanSabhaName={vidhanSabhaName} />
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// });

// const PrintBlock = React.memo(({ item, isLastInGroup, vidhanSabhaName }) => {
//   const { head, yojanas } = item;

//   return (
//     <div className="print-block" style={{ marginBottom: isLastInGroup ? "0" : "30px", breakInside: "avoid" }}>
//       <h1 style={{ textAlign: "center", color: "#1A237E", fontSize: "32px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h1>
//       <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>{vidhanSabhaName || ""}</h3>
//       <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
//       <p style={{ fontSize: "16px", marginBottom: "15px" }}>
//         <strong>Village:</strong> {head.PartNameEnglish} | <strong>Locality:</strong> {head.LocalityEnglish}
//       </p>

//       <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px", tableLayout: "fixed" }}>
//         <colgroup>
//           <col style={{ width: "7%" }} />
//           <col style={{ width: "30%" }} />
//           <col style={{ width: "45%" }} />
//           <col style={{ width: "20%" }} />
//         </colgroup>

//         <thead>
//           <tr style={{ backgroundColor: "#E8F5E8" }}>
//             <th style={{ border: "1px solid #333", padding: "10px" }}>No</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Yojana</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Member & Amount</th>
//             <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Total Amount</th>
//           </tr>
//         </thead>

//         <tbody>
//           {yojanas.map((y, i) => {
//             const memberLines = y.MemberDetails?.map((m, idx) => {
//               const name = m?.MemberName?.trim() || "Unknown";
//               const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
//               const entryDate = m?.GramYojnaMemberEntryDate;
//               return `${idx + 1}) ${name.padEnd(25)} - ${
//                 m.IsAmount ? (m?.TimePeriod && m?.TimePeriod != "1" ? amount + " × " + m?.TimePeriod : amount) : m.IsAmountEnterByUser ? amount : "1"
//               }\n  Entry Date -${entryDate} `;
//             });

//             return (
//               <tr key={i}>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "center", verticalAlign: "top", fontFamily: "monospace" }}>{i + 1}</td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", wordBreak: "break-word", verticalAlign: "top", fontFamily: "monospace" }}>
//                   {y.GramYojnaName}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
//                   {memberLines.join("\n")}
//                   <br />
//                   {y?.MemberDetails?.[0]?.TimePeriod == "12" ? " ( દર માસ ) " : y?.MemberDetails?.[0]?.IsAmount ? " ( દર વર્ષે ) " : ""}
//                 </td>
//                 <td style={{ border: "1px solid #333", padding: "8px", textAlign: "right", verticalAlign: "top" }}>
//                   {y?.MemberDetails?.[0]?.IsAmount
//                     ? toIndianCurrency(y.Amount)
//                     : y?.MemberDetails?.[0]?.IsAmountEnterByUser
//                       ? toIndianCurrency(y.Amount)
//                       : `${y?.MemberDetails.length} સંખ્યા`}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//         <tfoot>
//           <tr>
//             <td colSpan={4} style={{ borderTop: "1px solid #000", padding: 0 }}></td>
//           </tr>
//           <tr>
//             <td
//               colSpan={3}
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//                 backgroundColor: "#FFF3E0",
//                 border: "1px solid #000",
//                 borderRight: "none",
//               }}
//             >
//               Total Amount
//             </td>
//             <td
//               style={{
//                 textAlign: "right",
//                 padding: "6px 8px",
//                 fontWeight: "bold",
//                 fontSize: "15px",
//                 color: "#000",
//                 backgroundColor: "#FFF3E0",
//                 fontFamily: "monospace",
//                 border: "1px solid #000",
//               }}
//             >
//               {toIndianCurrency(head.OverAllFamilyAmount || 0)}
//             </td>
//           </tr>
//         </tfoot>
//       </table>
//     </div>
//   );
// });

// /* ============================================================
//    SMALL HELPERS
//    ============================================================ */
// const renderGender = (g) => {
//   const v = (g || "").toLowerCase();
//   if (v === "f") return <span className="gender-badge female">Female</span>;
//   if (v === "m") return <span className="gender-badge male">Male</span>;
//   if (v === "other") return <span className="gender-badge unknown">Other</span>;
//   return <span className="gender-badge unknown">-</span>;
// };

// /* ============================================================
//    MAIN COMPONENT
//    ============================================================ */
// const ViewMemberList = () => {
//   const { DarkTheme } = useSelector((state) => state.ProjectSlice);
//   const dispatch = useDispatch();

//   const [addNewVoterShow, setAddNewVoterShow] = useState(false);
//   const [changeHeadData, setChangeHeadData] = useState("");
//   const [isChangeHeadOpen, setIsChangeHeadOpen] = useState(false);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [filterData, setFilterData] = useState({});
//   const [familyHeadMasterID, setFamilyHeadMasterID] = useState("");
//   const [headData, setHeadData] = useState({});
//   const [statusType, setStatusType] = useState("");
//   const [deadNonVoterHeadID, setDeadNonVoterHeadID] = useState("");
//   const [selectedVillage, setSelectedVillage] = useState("");
//   const [selectedLocality, setSelectedLocality] = useState("");
//   const [isAddExistingModalOpen, setIsAddExistingModalOpen] = useState(false);
//   const [selectedRecords, setSelectedRecords] = useState({});
//   const [filterStatus, setFilterStatus] = useState(false);
//   const [memberDetails, setMemberDetails] = useState([]);
//   const [yojanaSelectModalOpen, setYojanaSelectModal] = useState(false);
//   const [memberYojanaDetail, setMemberYojanaDetail] = useState([]);
//   const [yojanaDetails, setOpenYojanaDetails] = useState({});
//   const { mutate: addNotVoterDeath, isPending: inserting } = useNotVoterDeath();
//   const [deadNonVoterMemberID, setDeadNonVoterMemberID] = useState("");
//   const [selectedEditGramYojanaID, setSelectedEditGramYojanaID] = useState(null);
//   const [selectedEditMemberDetail, setSelectedEditMemberDetail] = useState({});
//   const [isEditMemberDetailModalOpen, setIsEditMemberDetailModalOpen] = useState(false);

//   const [isAssignFamily, setIsAssignFamily] = useState(true);

//   const resolveInitialVidhanSabha = () => {
//     const validIds = VIDHAN_SABHA_LIST.map((v) => v.id);
//     try {
//       const stored = localStorage.getItem("selectedVidhanSabha");
//       if (stored && validIds.includes(stored)) return stored;
//     } catch (e) {
//       /* ignore */
//     }
//     return VIDHAN_SABHA_LIST[0].id;
//   };

//   const [selectedVidhanSabha, setSelectedVidhanSabha] = useState(resolveInitialVidhanSabha);

//   const [tabCounts, setTabCounts] = useState({
//     FamilyCount: 0,
//     WithoutFamilyCount: 0,
//   });
//   const [vsTotalCounts, setVsTotalCounts] = useState({});

//   const singlePrintRefs = useRef({});
//   const allYojanaPrintRef = useRef();
//   const triggerAllPrint = useRef(() => {});
//   const [allYojanaData, setAllYojanaData] = useState([]);
//   const [preparingAllPrint, setPreparingAllPrint] = useState(false);

//   const filterRef = useRef();

//   const queryFilterData = { ...filterData, VidhanSabha: selectedVidhanSabha };

//   const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useMemberListDataPagination(rowsPerPage, queryFilterData, isAssignFamily);
//   const { mutate: deleteMember, isLoading: deleting } = useDeleteMember();
//   const { mutate: addChangeHead, isPending: changeHeadInserting } = useSetChangeHead();
//   const { mutate: exportMemberList, isPending: isExporting } = useMemberListExportExcel();

//   const pages = data?.pages || [];
//   const totalCount = data?.pages[0]?.TotalCount || 0;
//   const start = currentPage * rowsPerPage + 1;
//   const end = Math.min(start + (pages[currentPage]?.data?.length || 0) - 1, totalCount);

//   const effectiveFilterData = {
//     ...filterData,
//     IsAssignFamily: isAssignFamily,
//     VidhanSabha: selectedVidhanSabha,
//   };

//   const activeVidhanSabhaName = VIDHAN_SABHA_LIST.find((v) => v.id === selectedVidhanSabha)?.name || "";

//   useEffect(() => {
//     const fetchTabCounts = async () => {
//       try {
//         const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

//         const outsideValue = outside?.trim()?.toLowerCase() === "true";
//         const handicapValue = handicap?.trim()?.toLowerCase() === "true";

//         const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberCountWithFamilyAndWithoutFamilly`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             Name: name || "",
//             MobileNo: mobileNo || "",
//             Gender: gender || "",
//             IDCardNo: idCardNo || "",
//             OutSide: outsideValue,
//             Handicap: handicapValue,
//             Address: locality || "",
//             VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
//             IsActive: "true",
//             IsDelete: "false",
//             IsAssignFamily: isAssignFamily,
//           }),
//         });

//         if (!response.ok) return;

//         const result = await response.json();
//         if (!result?.status || !result?.data) return;

//         const counts = {};
//         (result.data.VidhansabhaCount || []).forEach((row) => {
//           if (row?.Vidhansabha) {
//             counts[row.Vidhansabha] = Number(row.TotalCount) || 0;
//           }
//         });
//         setVsTotalCounts(counts);

//         const currentRow = (result.data.VidhansabhaCount || []).find((row) => row?.Vidhansabha === selectedVidhanSabha);

//         setTabCounts({
//           FamilyCount: Number(currentRow?.WithFamilyCount ?? result.data.FamilyCount) || 0,
//           WithoutFamilyCount: Number(currentRow?.WithoutFamilyCount ?? result.data.WithoutFamilyCount) || 0,
//         });
//       } catch (err) {
//         console.error("Failed to fetch member counts:", err);
//       }
//     };

//     fetchTabCounts();
//   }, [selectedVidhanSabha, filterData, isAssignFamily]);

//   const handleVidhanSabhaChange = (id) => {
//     if (id === selectedVidhanSabha) return;
//     setSelectedVidhanSabha(id);
//     setCurrentPage(0);
//     setOpenYojanaDetails({});
//     setFilterData({});
//   };

//   const handleTabChange = (value) => {
//     if (value === isAssignFamily) return;
//     setIsAssignFamily(value);
//     setCurrentPage(0);
//     setOpenYojanaDetails({});
//   };

//   const printSingleYojana = (head) => {
//     const node = singlePrintRefs.current[head.FamilyHeadMasterID];
//     if (!node) return;

//     const win = window.open("", "_blank");
//     win.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>${head.FullNameEnglish} - Yojana</title>
//           <style>
//             body { font-family: Arial, sans-serif; background: white; }
//             table { width: 100%; border-collapse: collapse; font-size: 14px; }
//             th, td { border: 1px solid #333; padding: 10px; text-align: left; }
//             th { background: #E8F5E8; }
//             .indian-currency::before { content: "₹"; }
//           </style>
//         </head>
//         <body>${node.innerHTML}</body>
//       </html>
//     `);
//     win.document.close();
//     win.focus();
//     win.print();
//     setTimeout(() => win.close(), 1000);
//   };

//   const handlePrintAllYojanas = () => {
//     toast.dismiss();
//     setPreparingAllPrint(true);

//     exportMemberList(effectiveFilterData, {
//       onSuccess: (apiData) => {
//         const printData = apiData.filter((head) => head.MemberYojnaDetails?.length > 0).map((head) => ({ head, yojanas: head.MemberYojnaDetails }));

//         if (printData.length === 0) {
//           notifyError("No Yojana data found");
//           setPreparingAllPrint(false);
//           return;
//         }

//         setAllYojanaData(printData);
//         setTimeout(() => triggerAllPrint.current(), 300);
//       },
//       onError: () => {
//         notifyError("Print failed");
//         setPreparingAllPrint(false);
//       },
//     });
//   };

//   const printAllYojanas = useReactToPrint({
//     contentRef: allYojanaPrintRef,
//     documentTitle: `All_Yojanas_${new Date().toISOString().slice(0, 10)}`,
//     onAfterPrint: () => {
//       setPreparingAllPrint(false);
//       setAllYojanaData([]);
//     },
//   });

//   useEffect(() => {
//     triggerAllPrint.current = printAllYojanas;
//   }, [printAllYojanas]);

//   const handleRowsChange = async (e) => {
//     const limit = parseInt(e.target?.value);
//     setRowsPerPage(limit);
//     setCurrentPage(0);
//     await refetch();
//   };

//   const goToPage = async (index) => {
//     if (pages[index]) {
//       setCurrentPage(index);
//     } else if (hasNextPage) {
//       await fetchNextPage();
//       setCurrentPage(index);
//     }
//   };

//   const handleAddNewVoterClose = () => setAddNewVoterShow(false);

//   const handleChangeHeadClose = () => {
//     setIsChangeHeadOpen(false);
//     setChangeHeadData("");
//     setFamilyHeadMasterID("");
//     setHeadData({});
//     setStatusType("");
//   };

//   const handleCloseAddExistingModal = () => {
//     setSelectedVillage("");
//     setSelectedLocality("");
//     setSelectedRecords({});
//     setIsAddExistingModalOpen(false);
//     setFamilyHeadMasterID("");
//   };

//   const handleSetNonVoterDeath = (ele, StatusType, Status) => {
//     setDeadNonVoterMemberID(ele.ContactDetailID);
//     setStatusType(StatusType);
//     const payload = {
//       ContactDetailID: ele?.ContactDetailID || "",
//       StatusType: StatusType,
//       Death: StatusType === "Death" ? Status : false,
//       NotVoter: StatusType === "NotVoter" ? Status : false,
//       UpdatedByUserID: "",
//     };

//     Swal.fire({
//       title: "Are you sure?",
//       text: `You are marking this member as "${StatusType}".`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, proceed!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         addNotVoterDeath(payload, {
//           onSuccess: (res) => {
//             if (res?.status === true) {
//               notifySuccess("Successfully Inserted", false);
//               refetch();
//             } else {
//               notifyError(res?.message ? res.message : "Data Not Inserted", false);
//             }
//           },
//           onError: () => notifyError("Something went wrong", false),
//         });
//       } else {
//         setDeadNonVoterMemberID("");
//         setStatusType("");
//       }
//     });
//   };

//   const handleDeleteMember = async (item) => {
//     const result = await deleteConfirmation();
//     if (result?.isConfirmed) {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         ContactDetailID: item?.ContactDetailID || "",
//         FamilyMemberDetailID: item?.FamilyMemberDetailID || "",
//         VoterID: item?.VoterID || "",
//       };
//       deleteMember(payload, {
//         onSuccess: (res) => {
//           if (res?.status === true) {
//             notifySuccess("Deleted Successfully", DarkTheme ? true : false);
//             refetch();
//           } else {
//             notifyError(res?.message || "Not Deleted", DarkTheme ? true : false);
//           }
//         },
//         onError: () => notifyError("Something went wrong", false),
//       });
//     }
//   };

//   const handleDeathNotVoterChange = (head, StatusType) => {
//     setFamilyHeadMasterID(head.FamilyHeadMasterID);
//     setDeadNonVoterHeadID(head?.ContactDetailID);
//     setStatusType(StatusType);

//     if (head?.FamilyMemberDetails?.length > 0) {
//       setChangeHeadData(head);
//       setIsChangeHeadOpen(true);
//       setHeadData({
//         ContactDetailID: head?.ContactDetailID,
//         VoterID: head?.VoterID,
//         IsHead: false,
//         IsHandicap: head?.IsHandicap,
//         IsOutSide: head?.IsOutSide,
//       });
//     } else {
//       const payload = {
//         UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//         FamilyHeadMasterID: familyHeadMasterID || "",
//         ContactDetailID: head?.ContactDetailID || "",
//         StatusType: StatusType,
//         Death: StatusType?.toLowerCase() === "death" ? true : false,
//         NotVoter: StatusType?.toLowerCase() === "notvoter" ? true : false,
//         FamilyDetail: [],
//       };

//       Swal.fire({
//         title: "Are you sure?",
//         text: `You are marking this head as "${StatusType}".`,
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, proceed!",
//       }).then((result) => {
//         if (result.isConfirmed) {
//           addChangeHead(payload, {
//             onSuccess: (res) => {
//               if (res?.status === true) {
//                 notifySuccess("Successfully Inserted", false);
//                 setFamilyHeadMasterID("");
//                 setStatusType("");
//                 setDeadNonVoterHeadID("");
//                 refetch();
//               } else {
//                 notifyError(res?.message || "Data Not Inserted", false);
//               }
//             },
//             onError: () => notifyError("Something went wrong", false),
//           });
//         } else {
//           setFamilyHeadMasterID("");
//           setDeadNonVoterHeadID("");
//           setStatusType("");
//         }
//       });
//     }
//   };

//   const handleFilterStatusToggle = () => {
//     setFilterStatus(true);
//     dispatch(toggleOffcanvasStatus(true));
//   };

//   const handleExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (MemberListData) => {
//         if (!MemberListData?.length) return notifyError("No Data Found");
//         exportToExcelWithYojanaTable(MemberListData);
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   async function exportToExcelWithYojanaTable(data) {
//     const workbook = new ExcelJS.Workbook();
//     const sheet = workbook.addWorksheet("Family Yojana Report", {
//       pageSetup: { paperSize: 9, orientation: "landscape" },
//     });

//     let rowIndex = 1;
//     let familySr = 1;

//     data.forEach((head) => {
//       const members = head.FamilyMemberDetails || [];
//       const headName = head.FullNameEnglish || "";
//       const village = head.PartNameEnglish || "";
//       const locality = head.LocalityEnglish || "";
//       const overAllAmount = head.OverAllFamilyAmount || 0;

//       const headerRow = sheet.getRow(rowIndex++);
//       headerRow.values = [familySr, headName, village, locality, `₹${Number(overAllAmount).toLocaleString("en-IN")}.00`];
//       headerRow.font = { bold: true, size: 12 };
//       headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6E6E6" } };

//       const memberHeader = sheet.getRow(rowIndex++);
//       memberHeader.values = ["", "Member Name", "Mobile", "Gender", "Age", "ID Card No", "SL No"];
//       memberHeader.font = { bold: true };
//       memberHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9EAD3" } };

//       members.forEach((member) => {
//         const row = sheet.getRow(rowIndex++);
//         row.values = [
//           "",
//           member.FullNameEnglish || "",
//           member.MobileNo || "",
//           member.Gender === "M" ? "Male" : "Female",
//           member.Age || "",
//           member.IDCardNo || "",
//           member.SLNo || "",
//         ];
//       });

//       const yojanaHeader = sheet.getRow(rowIndex++);
//       if (head?.MemberYojnaDetails?.length) {
//         yojanaHeader.values = ["", "Yojana Name", "Members (with Amount)", "Total Amount"];
//         yojanaHeader.font = { bold: true, color: { argb: "FFFFFFFF" } };
//         yojanaHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4CAF50" } };
//       }

//       (head.MemberYojnaDetails || []).forEach((yojna) => {
//         const yojnaName = yojna.GramYojnaName || "";
//         const yojnaTotal = yojna.Amount || "0";
//         const details = yojna.MemberDetails || [];

//         const memberList = details
//           .map((d, i) => {
//             const name = d.MemberName || "Unknown";
//             const amt = d.IsAmount
//               ? d?.TimePeriod && d?.TimePeriod != "1"
//                 ? toIndianCurrency(parseInt(d?.Amount || 0)) + " × " + d?.TimePeriod
//                 : toIndianCurrency(parseInt(d?.Amount || 0))
//               : d.IsAmountEnterByUser
//                 ? toIndianCurrency(parseInt(d?.Amount || 0))
//                 : "1";
//             const entryDate = d?.GramYojnaMemberEntryDate;
//             return `${i + 1}) ${name} (${amt})\n   Entry Date: ${entryDate}`;
//           })
//           .join("\n");

//         const firstRow = sheet.getRow(rowIndex++);
//         firstRow.values = [
//           "",
//           yojnaName,
//           memberList + `${details?.[0]?.TimePeriod == "12" ? "\n ( દર માસ ) " : details?.[0]?.IsAmount ? "\n  ( દર વર્ષે ) " : ""}`,
//           details?.[0]?.IsAmount ? toIndianCurrency(yojnaTotal) : details?.[0]?.IsAmountEnterByUser ? toIndianCurrency(yojnaTotal) : `${details?.length} સંખ્યા`,
//         ];
//         firstRow.getCell(2).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(3).alignment = { vertical: "middle", wrapText: true };
//         firstRow.getCell(4).alignment = { vertical: "middle" };
//         const lines = memberList.split("\n").length;
//         if (lines > 1) {
//           for (let i = 1; i < lines; i++) {
//             const extraRow = sheet.getRow(rowIndex);
//             extraRow.values = ["", "", "", ""];
//             extraRow.getCell(3).value = { formula: `C${rowIndex - lines}` };
//           }
//         }
//         sheet.getRow(rowIndex++).height = 15;
//       });

//       familySr++;
//     });

//     sheet.columns = [{ width: 8 }, { width: 40 }, { width: 40 }, { width: 30 }, { width: 18 }, { width: 15 }, { width: 10 }, { width: 8 }, { width: 18 }, { width: 10 }];

//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], { type: "application/octet-stream" });
//     saveAs(blob, "Family_Yojana_Report.xlsx");
//   }

//   const handleYojanaExport = () => {
//     toast.dismiss();
//     exportMemberList(effectiveFilterData, {
//       onSuccess: (YojanaListData) => {
//         if (!YojanaListData?.length) return notifyError("No Data Found");
//         const exportData = [];
//         YojanaListData.forEach((head) => {
//           const yojanaDetails = head?.MemberYojnaDetails || [];
//           if (yojanaDetails.length > 0) {
//             yojanaDetails.forEach((yojana) => {
//               const members = yojana?.MemberDetails || [];
//               members.forEach((member) => {
//                 exportData.push({
//                   "Yojana Name": yojana?.GramYojnaName || "",
//                   "Yojana Amount": member?.Amount || "",
//                   "Member Name": member?.MemberName || "",
//                 });
//               });
//             });
//           }
//         });
//         if (exportData.length === 0) return notifyError("No Member Yojana Details Found");
//         exportToExcel(exportData, "Member_Yojana_List");
//       },
//       onError: () => notifyError("Export failed. Please try again."),
//     });
//   };

//   const handleSelectYojanaChange = (head) => {
//     const headDataLocal = {
//       FamilyHeadMasterID: head?.FamilyHeadMasterID || "",
//       FamilyMemberDetailID: "",
//       ContactDetailID: head?.ContactDetailID || "",
//       VoterID: head?.VoterID?.toString() || "",
//       FullNameEnglish: head?.FullNameEnglish || "",
//       FullNameGujarati: head?.FullNameGujarati || "",
//       MobileNo: head?.MobileNo || "",
//       Age: head?.Age || "",
//       Gender: head?.Gender || "",
//     };
//     const memberDetailsLocal = [
//       ...(head?.FamilyMemberDetails?.map((ele) => ({
//         FamilyMemberDetailID: ele?.FamilyMemberDetailID,
//         FamilyHeadMasterID: ele?.FamilyHeadMasterID || "",
//         ContactDetailID: ele?.ContactDetailID || "",
//         VoterID: ele?.VoterID?.toString() || "",
//         Type: ele?.Type || "",
//         FullNameEnglish: ele?.FullNameEnglish || "",
//         FullNameGujarati: ele?.FullNameGujarati || "",
//         LocalityEnglish: ele?.LocalityEnglish || "",
//         PartNameEnglish: ele?.PartNameEnglish || "",
//         MobileNo: ele?.MobileNo || "",
//         Age: ele?.Age || "",
//         Gender: ele?.Gender || "",
//         NotVoter: ele?.NotVoter || "",
//         Death: ele?.Death || "",
//         OutSide: ele?.OutSide || "",
//         Handicap: ele?.Handicap || "",
//         IDCardNo: ele?.IDCardNo || "",
//         SLNo: ele?.SLNo || "",
//       })) || []),
//       headDataLocal,
//     ];

//     setMemberDetails(memberDetailsLocal);
//     setYojanaSelectModal(true);
//     setFamilyHeadMasterID(head?.FamilyHeadMasterID);
//     setMemberYojanaDetail(head?.MemberYojnaDetails);
//   };

//   const handleEditMemberYojanaDetail = (head, idx, GramYojnaMemberID) => {
//     const memberDetail = head?.MemberYojnaDetails?.[idx]?.MemberDetails?.find((ele) => ele?.GramYojnaMemberID?.toString() === GramYojnaMemberID.toString());
//     const updatedMemberDetail = {
//       GramYojnaMemberID: memberDetail?.GramYojnaMemberID,
//       GramYojnaID: head?.MemberYojnaDetails?.[idx]?.GramYojnaID,
//       GramYojnaName: head?.MemberYojnaDetails?.[idx]?.GramYojnaName,
//       GramYojnaAmountDetailID: null,
//       Amount: memberDetail?.Amount?.toString(),
//       MemberName: memberDetail?.MemberName,
//       IsAmount: memberDetail?.IsAmount,
//       IsAmountEnterByUser: memberDetail?.IsAmountEnterByUser,
//       TimePeriod: memberDetail?.TimePeriod,
//       IsMultiple: memberDetail?.IsMultiple,
//     };
//     setSelectedEditMemberDetail(updatedMemberDetail);
//     setIsEditMemberDetailModalOpen(true);
//   };

//   const handleYojanaSelectClose = () => {
//     setYojanaSelectModal(false);
//     setMemberDetails([]);
//     setFamilyHeadMasterID("");
//     setMemberYojanaDetail([]);
//     setSelectedEditGramYojanaID(null);
//   };

//   const handleShowHideYojanaDetails = (id) => {
//     setOpenYojanaDetails((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const handleCloseEditMemberDetail = () => {
//     setSelectedEditMemberDetail({});
//     setIsEditMemberDetailModalOpen(false);
//   };

//   return (
//     <>
//       <TabStyles />

//       <FilterMemberList
//         filterData={filterData}
//         filterRef={filterRef}
//         filterStatus={filterStatus}
//         setFilterStatus={setFilterStatus}
//         setFilterData={setFilterData}
//         selectedVidhanSabha={selectedVidhanSabha}
//       />

//       <div className="flex-grow-1 w-100">
//         {/* ============== VIDHAN SABHA SELECTOR ============== */}
//         <ul className="vidhan-sabha-bar" role="tablist" aria-label="Vidhan Sabha">
//           {VIDHAN_SABHA_LIST.map((vs) => (
//             <li key={vs.id} role="presentation">
//               <button
//                 type="button"
//                 role="tab"
//                 aria-selected={selectedVidhanSabha === vs.id}
//                 className={`vs-btn ${selectedVidhanSabha === vs.id ? "active" : ""}`}
//                 onClick={() => handleVidhanSabhaChange(vs.id)}
//               >
//                 <span className="vs-dot" />
//                 <span>{vs.name}</span>
//                 <span className="vs-total">{(vsTotalCounts[vs.id] || 0).toLocaleString("en-IN")}</span>
//               </button>
//             </li>
//           ))}
//         </ul>

//         {/* ============== WITH / WITHOUT FAMILY TOGGLE ============== */}
//         <ul className="member-list-tabs" role="tablist">
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={isAssignFamily} className={`tab-btn ${isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(true)}>
//               <span className="tab-icon">
//                 <UserCheck size={15} />
//               </span>
//               <span>Members With Family</span>
//               <span className="tab-badge">{tabCounts.FamilyCount.toLocaleString("en-IN")}</span>
//             </button>
//           </li>
//           <li role="presentation">
//             <button type="button" role="tab" aria-selected={!isAssignFamily} className={`tab-btn alt ${!isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(false)}>
//               <span className="tab-icon">
//                 <User size={15} />
//               </span>
//               <span>Members Without Family</span>
//               <span className="tab-badge">{tabCounts.WithoutFamilyCount.toLocaleString("en-IN")}</span>
//             </button>
//           </li>
//         </ul>

//         {isLoading || isError || isFetching ? (
//           <TableShimmer theme={DarkTheme ? "dark" : "light"} />
//         ) : (
//           <div className="flex-grow-1 py-0 px-2 w-100">
//             <div className="row g-6 mb-6">
//               <div className="col-sm-12 col-xl-12">
//                 <div className="card">
//                   <div className="card-datatable">
//                     <div id="DataTables_Table_0_wrapper" className="dt-container dt-bootstrap5 dt-empty-footer">
//                       <div className="justify-content-between dt-layout-table px-4">
//                         <div className="d-md-flex justify-content-between align-items-center dt-layout-full table-responsive">
//                           <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
//                             <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />

//                             <button
//                               onClick={handlePrintAllYojanas}
//                               disabled={preparingAllPrint || isExporting}
//                               className="btn btn-danger btn-sm d-flex align-items-center gap-2 ms-3"
//                             >
//                               <Printer size={18} />
//                               {preparingAllPrint ? "Preparing..." : "Print All Yojanas"}
//                             </button>

//                             <div className="dt-buttons btn-group flex-md-row flex-column d-flex gap-3 mb-md-0 mb-4">
//                               <TableFilterButton handleFilterStatusToggle={handleFilterStatusToggle} />
//                               <ExcelButton
//                                 isExportingMain={isExporting}
//                                 isExportingSecondary={isExporting}
//                                 handleExportMain={handleExport}
//                                 primaryExcel="Member Details"
//                                 handleExportSecondary={handleYojanaExport}
//                                 secondaryExcel="Yojana Details"
//                               />
//                             </div>
//                           </div>

//                           <table className="datatables-users Merge-List table dataTable dtr-column" id="DataTables_Table_0">
//                             <thead className="table-header-light border-top">
//                               <tr>
//                                 <th rowSpan={2}>Sr No</th>
//                                 <th rowSpan={2}>Yojana Details</th>
//                                 <th rowSpan={2} style={{ width: "20%", verticalAlign: "middle" }}>
//                                   <Home size={16} className="me-1" />
//                                   Head &amp; Address
//                                 </th>
//                                 <th colSpan={8} className="text-center">
//                                   <Users size={16} className="me-1" />
//                                   Member Details
//                                 </th>
//                               </tr>
//                               <tr>
//                                 <th>Family Member</th>
//                                 <th>Mobile</th>
//                                 <th>Gender</th>
//                                 <th>Age</th>
//                                 <th>Non Voter</th>
//                                 <th>Death</th>
//                                 <th>Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {pages[currentPage]?.data?.map((head, headIndex) => {
//                                 const hasMembers = Array.isArray(head.FamilyMemberDetails) && head.FamilyMemberDetails.length > 0;
//                                 const memberCount = hasMembers ? head.FamilyMemberDetails.length : 1;
//                                 const absoluteIndex = currentPage * rowsPerPage + headIndex + 1;
//                                 const rowKey = head.FamilyHeadMasterID || head.VoterID || `head-${headIndex}`;
//                                 const toggleKey = head.VoterID || head.FamilyHeadMasterID;

//                                 return (
//                                   <React.Fragment key={rowKey}>
//                                     {hasMembers ? (
//                                       <>
//                                         {head.FamilyMemberDetails.map((ele, memberIndex) => (
//                                           <tr key={`${rowKey}-${memberIndex}`}>
//                                             {memberIndex === 0 && (
//                                               <>
//                                                 <td rowSpan={memberCount} className="align-top">
//                                                   {absoluteIndex}
//                                                 </td>
//                                                 <td rowSpan={memberCount} className="align-top">
//                                                   {head.MemberYojnaDetails?.length > 0 && (
//                                                     <i
//                                                       onClick={() => handleShowHideYojanaDetails(toggleKey)}
//                                                       className={`icon-base ti tabler-${
//                                                         yojanaDetails[toggleKey] ? "chevron-down" : "chevron-right"
//                                                       } icon-md cursor-pointer scaleX-n1-rtl`}
//                                                     />
//                                                   )}
//                                                 </td>
//                                                 <td rowSpan={memberCount} className="align-top">
//                                                   {head.FullNameEnglish || "-"}
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Village / Area:</strong> {head.PartNameEnglish || "-"}
//                                                   </span>
//                                                   <br />
//                                                   <span className="custom-font">
//                                                     <strong>Locality:</strong> {head.LocalityEnglish || "-"}
//                                                   </span>
//                                                   <br />
//                                                   <br />
//                                                   <div className="d-flex gap-2">
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Death</span>
//                                                       </strong>
//                                                     </label>
//                                                     <label className="d-flex align-items-center gap-1">
//                                                       <input
//                                                         type="checkbox"
//                                                         className="custom-checkbox cursor-pointer"
//                                                         checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                         onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                       />
//                                                       <strong>
//                                                         <span className="cursor-pointer custom-font">Non Voter</span>
//                                                       </strong>
//                                                     </label>
//                                                   </div>
//                                                   <br />
//                                                   {head?.OverAllFamilyAmount ? (
//                                                     <div>
//                                                       <strong>OverAll Yojana Amount: </strong>
//                                                       <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                                     </div>
//                                                   ) : (
//                                                     <div>
//                                                       <strong>OverAll Yojana Amount: </strong>
//                                                       <span>-</span>
//                                                     </div>
//                                                   )}
//                                                   <br />
//                                                   {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                                 </td>
//                                               </>
//                                             )}
//                                             <td>
//                                               {ele.FullNameEnglish || "-"}
//                                               <br />
//                                               <br />
//                                               {`${ele?.IsHandicap === "true" ? "Handicap" : ""}${ele?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                             </td>
//                                             <td>{ele.MobileNo ? `+91 ${ele.MobileNo}` : "-"}</td>
//                                             <td>{renderGender(ele.Gender)}</td>
//                                             <td>{ele.Age || "-"}</td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "NotVoter", !ele?.NotVoter)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             <td>
//                                               <input
//                                                 type="checkbox"
//                                                 checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
//                                                 onChange={() => handleSetNonVoterDeath(ele, "Death", !ele?.Death)}
//                                                 style={{ width: "18px", height: "18px" }}
//                                               />
//                                             </td>
//                                             {memberIndex === 0 && (
//                                               <td rowSpan={memberCount} className="text-center align-top p-2">
//                                                 <div className="d-flex flex-column gap-2">
//                                                   <button
//                                                     className="btn btn-sm btn-outline-warning fw-semibold"
//                                                     onClick={() => {
//                                                       setChangeHeadData(head);
//                                                       setIsChangeHeadOpen(true);
//                                                       setFamilyHeadMasterID(head.FamilyHeadMasterID);
//                                                       setHeadData({
//                                                         ContactDetailID: head?.ContactDetailID,
//                                                         VoterID: head?.VoterID,
//                                                         IsHead: false,
//                                                         IsHandicap: head?.IsHandicap,
//                                                         IsOutSide: head?.IsOutSide,
//                                                       });
//                                                     }}
//                                                   >
//                                                     Change Head
//                                                   </button>
//                                                 </div>
//                                               </td>
//                                             )}
//                                           </tr>
//                                         ))}

//                                         <AnimatePresence>
//                                           {yojanaDetails[toggleKey] && (
//                                             <motion.tr
//                                               key={`yojana-${rowKey}`}
//                                               initial={{ opacity: 0 }}
//                                               animate={{ opacity: 1 }}
//                                               exit={{ opacity: 0 }}
//                                               style={{ background: "#f7f7f7" }}
//                                             >
//                                               <td colSpan={10} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana?.GramYojnaName || "-"}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName || "-"}
//                                                                     </span>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div key={inx} className="member-row amount-row">
//                                                                   <span className="custom-font indian-currency">
//                                                                     {ele.IsAmount
//                                                                       ? ele?.TimePeriod && ele?.TimePeriod !== "1"
//                                                                         ? `${toIndianCurrency(parseInt(ele?.Amount || 0))} × ${ele?.TimePeriod}`
//                                                                         : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                       : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                   </span>
//                                                                 </div>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod === "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : "-"}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">
//                                                                 {yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? toIndianCurrency(yojana.Amount)
//                                                                   : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                                                                     ? toIndianCurrency(yojana.Amount)
//                                                                     : yojana?.MemberDetails?.length
//                                                                       ? `${yojana.MemberDetails.length} સંખ્યા`
//                                                                       : "-"}
//                                                               </span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     ) : (
//                                       <>
//                                         <tr>
//                                           {/* Sr No */}
//                                           <td>{absoluteIndex}</td>

//                                           {/* Yojana Details expander */}
//                                           <td>
//                                             {head.MemberYojnaDetails?.length > 0 && (
//                                               <i
//                                                 onClick={() => handleShowHideYojanaDetails(toggleKey)}
//                                                 className={`icon-base ti tabler-${
//                                                   yojanaDetails[toggleKey] ? "chevron-down" : "chevron-right"
//                                                 } icon-md cursor-pointer scaleX-n1-rtl`}
//                                               />
//                                             )}
//                                           </td>

//                                           {/* Head & Address */}
//                                           <td>
//                                             {head.FullNameEnglish || "-"}
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Village / Area:</strong> {head.PartNameEnglish || "-"}
//                                             </span>
//                                             <br />
//                                             <span className="custom-font">
//                                               <strong>Locality:</strong> {head.LocalityEnglish || "-"}
//                                             </span>
//                                             <br />
//                                             <br />

//                                             <div className="d-flex gap-2">
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "Death")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Death</span>
//                                                 </strong>
//                                               </label>
//                                               <label className="d-flex align-items-center gap-1">
//                                                 <input
//                                                   type="checkbox"
//                                                   className="custom-checkbox cursor-pointer"
//                                                   checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
//                                                   onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
//                                                 />
//                                                 <strong>
//                                                   <span className="cursor-pointer custom-font">Non Voter</span>
//                                                 </strong>
//                                               </label>
//                                             </div>

//                                             <br />
//                                             {head?.OverAllFamilyAmount ? (
//                                               <div>
//                                                 <strong>OverAll Yojana Amount: </strong>
//                                                 <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
//                                               </div>
//                                             ) : (
//                                               <div>
//                                                 <strong>OverAll Yojana Amount: </strong>
//                                                 <span>-</span>
//                                               </div>
//                                             )}
//                                             <br />
//                                             {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                           </td>

//                                           {/* Name */}
//                                           <td>
//                                             {head.FullNameEnglish || "-"}
//                                             <div
//                                               style={{
//                                                 marginTop: "4px",
//                                                 fontSize: "11px",
//                                                 fontStyle: "italic",
//                                                 color: "#9aa4b2",
//                                                 lineHeight: 1.2,
//                                               }}
//                                             >
//                                               (Head — no family members linked)
//                                             </div>
//                                             <br />
//                                             {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
//                                           </td>

//                                           {/* Mobile */}
//                                           <td>{head.MobileNo ? `+91 ${head.MobileNo}` : "-"}</td>

//                                           {/* Gender */}
//                                           <td>{renderGender(head.Gender)}</td>

//                                           {/* Age */}
//                                           <td>{head.Age || "-"}</td>

//                                           {/* Non Voter */}
//                                           <td>
//                                             <input
//                                               type="checkbox"
//                                               checked={head?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
//                                               onChange={() => handleSetNonVoterDeath(head, "NotVoter", !head?.NotVoter)}
//                                               style={{ width: "18px", height: "18px" }}
//                                             />
//                                           </td>

//                                           {/* Death */}
//                                           <td>
//                                             <input
//                                               type="checkbox"
//                                               checked={head?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
//                                               onChange={() => handleSetNonVoterDeath(head, "Death", !head?.Death)}
//                                               style={{ width: "18px", height: "18px" }}
//                                             />
//                                           </td>

//                                           {/* Actions */}
//                                           <td className="text-center align-top p-2">
//                                             <div className="d-flex flex-column gap-2">
//                                               <button
//                                                 className="btn btn-sm btn-outline-warning fw-semibold"
//                                                 onClick={() => {
//                                                   setChangeHeadData(head);
//                                                   setIsChangeHeadOpen(true);
//                                                   setFamilyHeadMasterID(head.FamilyHeadMasterID);
//                                                   setHeadData({
//                                                     ContactDetailID: head?.ContactDetailID,
//                                                     VoterID: head?.VoterID,
//                                                     IsHead: false,
//                                                     IsHandicap: head?.IsHandicap,
//                                                     IsOutSide: head?.IsOutSide,
//                                                   });
//                                                 }}
//                                               >
//                                                 Change Head
//                                               </button>
//                                             </div>
//                                           </td>
//                                         </tr>

//                                         <AnimatePresence>
//                                           {yojanaDetails[toggleKey] && (
//                                             <motion.tr
//                                               key={`yojana-${rowKey}`}
//                                               initial={{ opacity: 0 }}
//                                               animate={{ opacity: 1 }}
//                                               exit={{ opacity: 0 }}
//                                               style={{ background: "#f7f7f7" }}
//                                             >
//                                               <td colSpan={10} className="p-0">
//                                                 <div className="p-3 border-top">
//                                                   <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
//                                                   <div className="table-responsive">
//                                                     <table className="table table-sm table-bordered">
//                                                       <thead className="table-light">
//                                                         <tr>
//                                                           <th>Yojana Name</th>
//                                                           <th>Members</th>
//                                                           <th>Amount</th>
//                                                           <th>Total Amount</th>
//                                                         </tr>
//                                                       </thead>
//                                                       <tbody>
//                                                         {head?.MemberYojnaDetails?.map((yojana, idx) => (
//                                                           <tr key={idx}>
//                                                             <td>{yojana?.GramYojnaName || "-"}</td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div
//                                                                   key={ele?.GramYojnaMemberID ?? inx}
//                                                                   style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "4px 0",
//                                                                     borderBottom: "1px dashed #ddd",
//                                                                   }}
//                                                                 >
//                                                                   <div style={{ display: "flex", flexDirection: "column" }}>
//                                                                     <span>
//                                                                       {inx + 1}) {ele?.MemberName || "-"}
//                                                                     </span>
//                                                                   </div>
//                                                                   {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
//                                                                     <button
//                                                                       type="button"
//                                                                       className="btn btn-sm btn-outline-primary"
//                                                                       onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
//                                                                     >
//                                                                       Edit
//                                                                     </button>
//                                                                   )}
//                                                                 </div>
//                                                               ))}
//                                                             </td>
//                                                             <td>
//                                                               {yojana?.MemberDetails?.map((ele, inx) => (
//                                                                 <div key={inx} className="member-row amount-row">
//                                                                   <span className="custom-font indian-currency">
//                                                                     {ele.IsAmount
//                                                                       ? ele?.TimePeriod && ele?.TimePeriod !== "1"
//                                                                         ? `${toIndianCurrency(parseInt(ele?.Amount || 0))} × ${ele?.TimePeriod}`
//                                                                         : toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                       : ele.IsAmountEnterByUser
//                                                                         ? toIndianCurrency(parseInt(ele?.Amount || 0))
//                                                                         : "1"}
//                                                                   </span>
//                                                                 </div>
//                                                               ))}
//                                                               {yojana?.MemberDetails?.[0]?.TimePeriod === "12"
//                                                                 ? " ( દર માસ ) "
//                                                                 : yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? " ( દર વર્ષે ) "
//                                                                   : "-"}
//                                                             </td>
//                                                             <td>
//                                                               <span className="custom-font indian-currency">
//                                                                 {yojana?.MemberDetails?.[0]?.IsAmount
//                                                                   ? toIndianCurrency(yojana.Amount)
//                                                                   : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
//                                                                     ? toIndianCurrency(yojana.Amount)
//                                                                     : yojana?.MemberDetails?.length
//                                                                       ? `${yojana.MemberDetails.length} સંખ્યા`
//                                                                       : "-"}
//                                                               </span>
//                                                             </td>
//                                                           </tr>
//                                                         ))}
//                                                       </tbody>
//                                                     </table>
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </motion.tr>
//                                           )}
//                                         </AnimatePresence>
//                                       </>
//                                     )}
//                                   </React.Fragment>
//                                 );
//                               })}
//                             </tbody>
//                           </table>

//                           {/* Hidden per-head print nodes rendered OUTSIDE the table (valid HTML) */}
//                           <div style={{ display: "none" }}>
//                             {pages[currentPage]?.data?.map((head, i) =>
//                               head?.MemberYojnaDetails?.length > 0 ? (
//                                 <PrintableSingleYojana
//                                   key={`print-${head.FamilyHeadMasterID || head.VoterID || i}`}
//                                   ref={(el) => {
//                                     if (el) singlePrintRefs.current[head.FamilyHeadMasterID] = el;
//                                   }}
//                                   head={head}
//                                 />
//                               ) : null,
//                             )}
//                           </div>

//                           <div className="row mx-3 justify-content-between">
//                             <PageEntries start={start} end={end} totalCount={totalCount} />
//                             <PaginationButtons
//                               currentPage={currentPage}
//                               setCurrentPage={setCurrentPage}
//                               goToPage={goToPage}
//                               pages={pages}
//                               hasNextPage={hasNextPage}
//                               fetchNextPage={fetchNextPage}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* HIDDEN ALL YOJANA PRINT */}
//       <div style={{ display: "none" }}>
//         <PrintableAllYojanas ref={allYojanaPrintRef} data={allYojanaData} vidhanSabhaName={activeVidhanSabhaName} />
//       </div>

//       {/* MODALS */}
//       <AddNewVoter show={addNewVoterShow} onClose={handleAddNewVoterClose} refetch={refetch} familyHeadMasterID={familyHeadMasterID} />
//       <ChangeHeadModal
//         show={isChangeHeadOpen}
//         data={changeHeadData}
//         handleClose={handleChangeHeadClose}
//         familyHeadMasterID={familyHeadMasterID}
//         refetch={refetch}
//         headData={headData}
//         statusType={statusType}
//         deadNonVoterHeadID={deadNonVoterHeadID}
//       />
//       <AddExistingVoter
//         show={isAddExistingModalOpen}
//         selectedVillage={selectedVillage}
//         selectedLocality={selectedLocality}
//         handleClose={handleCloseAddExistingModal}
//         selectedRecords={selectedRecords}
//         setSelectedRecords={setSelectedRecords}
//         refetchMemberList={refetch}
//         familyHeadMasterID={familyHeadMasterID}
//       />
//       <YojanaSelect
//         selectedEditGramYojanaID={selectedEditGramYojanaID}
//         memberDetails={memberDetails}
//         show={yojanaSelectModalOpen}
//         handleClose={handleYojanaSelectClose}
//         familyHeadMasterID={familyHeadMasterID}
//         memberYojanaDetail={memberYojanaDetail}
//         refetchMemberList={refetch}
//       />

//       <EditYojanaMemberDetail
//         selectedEditMemberDetail={selectedEditMemberDetail}
//         open={isEditMemberDetailModalOpen}
//         onClose={handleCloseEditMemberDetail}
//         refetchMemberList={refetch}
//       />

//       {(inserting || deleting || changeHeadInserting || preparingAllPrint || isExporting) && <Loader />}
//     </>
//   );
// };

// export default ViewMemberList;

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { AnimatePresence, motion } from "framer-motion";
import Cookies from "js-cookie";
import { Home, Printer, User, UserCheck, Users } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useDeleteMember } from "../../API_Master/DeleteMutateAPI";
import { useMemberListExportExcel } from "../../API_Master/ExcelAPI";
import { useMemberListDataPagination } from "../../API_Master/FetchAPI";
import { useNotVoterDeath, useSetChangeHead } from "../../API_Master/MutateAPI";
import ExcelButton from "../../CommonComponents/ExcelButton";
import Loader from "../../CommonComponents/Loader";
import PageCountSelect from "../../CommonComponents/PageCountSelect";
import PageEntries from "../../CommonComponents/PageEntries";
import PaginationButtons from "../../CommonComponents/PaginationButtons";
import TableFilterButton from "../../CommonComponents/TableFilterButton";
import TableShimmer from "../../Components/TableShimmer";
import { deleteConfirmation, exportToExcel, notifyError, notifySuccess, toIndianCurrency } from "../../MethodMaster/JSXComponentMothod";
import { Narendra_Modi_Election_API_URL, HIDE_ZERO_AMOUNT_YOJANA } from "../../Process";
import { toggleOffcanvasStatus } from "../../Redux/Slices/ProjectSlice";
import AddExistingVoter from "../AddExistingVoter/inde";
import AddNewVoter from "../AddNewVoter";
import ChangeHeadModal from "../ChangeHeadModal";
import EditYojanaMemberDetail from "../EditYojanaMemberDetail";
import YojanaSelect from "../YojanaSelect";
import FilterMemberList from "./FilterMemberList";

/* ============================================================
   HIDDEN ZERO AMOUNT YOJANA HELPERS
   ============================================================ */
const isHiddenZeroAmountYojana = (yojana) => {
  if (!yojana || !HIDE_ZERO_AMOUNT_YOJANA) return false;
  const name = yojana?.GramYojnaName;
  const id = yojana?.GramYojnaID;
  const list = Array.isArray(HIDE_ZERO_AMOUNT_YOJANA) ? HIDE_ZERO_AMOUNT_YOJANA : [HIDE_ZERO_AMOUNT_YOJANA];
  return list.some((v) => {
    if (v == null) return false;
    if (typeof v === "object") {
      return v.GramYojnaName === name || v.GramYojnaID === id;
    }
    return v === name || v === id;
  });
};

const isAmountMissing = (member) => member?.Amount == null || member?.Amount === "";

/* ============================================================
   VIDHAN SABHA LIST
   ============================================================ */
const VIDHAN_SABHA_LIST = [
  { id: "Sevapuri", name: "Sevapuri" },
  { id: "Rohaniya", name: "Rohaniya" },
  { id: "Varanasi North", name: "Varanasi North" },
  { id: "Varanasi South", name: "Varanasi South" },
  { id: "Varanasi Cantonment", name: "Varanasi Cantonment" },
];

/* ============================================================
   BEAUTIFUL TAB STYLES
   ============================================================ */
const TabStyles = () => (
  <style>{`
    .vidhan-sabha-bar {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      padding: 14px 16px;
      margin: 16px 16px 0;
      background: linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%);
      border-radius: 16px;
      box-shadow: inset 0 0 0 1px rgba(59, 91, 219, 0.08);
      list-style: none;
    }
    .vidhan-sabha-bar .vs-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      border: 1px solid rgba(59, 91, 219, 0.15);
      background: #ffffff;
      color: #3b4a6b;
      font-weight: 600;
      font-size: 13.5px;
      padding: 8px 16px;
      border-radius: 999px;
      cursor: pointer;
      transition: all 0.22s ease;
      box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
    }
    .vidhan-sabha-bar .vs-btn:hover {
      border-color: #5b8def;
      color: #3b5bdb;
      transform: translateY(-1px);
      box-shadow: 0 6px 14px -6px rgba(59, 91, 219, 0.4);
    }
    .vidhan-sabha-bar .vs-btn.active {
      color: #ffffff;
      background: linear-gradient(135deg, #6c8cff 0%, #3b5bdb 100%);
      border-color: transparent;
      box-shadow: 0 10px 20px -8px rgba(59, 91, 219, 0.65),
                  0 2px 6px -1px rgba(59, 91, 219, 0.4);
      transform: translateY(-2px);
    }
    .vidhan-sabha-bar .vs-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #c7d2fe;
      transition: background 0.2s ease;
    }
    .vidhan-sabha-bar .vs-btn.active .vs-dot {
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
    }
    .vidhan-sabha-bar .vs-total {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 22px;
      height: 20px;
      padding: 0 8px;
      border-radius: 10px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.3px;
      background: #eef2ff;
      color: #3b5bdb;
      border: 1px solid rgba(59, 91, 219, 0.15);
    }
    .vidhan-sabha-bar .vs-btn.active .vs-total {
      background: rgba(255, 255, 255, 0.25);
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.35);
    }
    .theme-dark .vidhan-sabha-bar .vs-total {
      background: rgba(141, 169, 255, 0.15);
      color: #8da9ff;
      border-color: rgba(141, 169, 255, 0.25);
    }

    .member-list-tabs {
      position: relative;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 6px;
      margin: 12px 16px 0;
      background: #f1f3f9;
      border-radius: 14px;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
      list-style: none;
      flex-wrap: wrap;
    }
    .member-list-tabs .tab-btn {
      position: relative;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 10px 20px;
      border-radius: 10px;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.2px;
      color: #5a6478;
      background: transparent;
      transition: color 0.25s ease, transform 0.2s ease, background 0.25s ease;
    }
    .member-list-tabs .tab-btn:hover:not(.active) {
      color: #3b5bdb;
      background: rgba(99, 132, 255, 0.08);
    }
    .member-list-tabs .tab-btn.active {
      color: #ffffff;
      background: linear-gradient(135deg, #5b8def 0%, #3b5bdb 100%);
      box-shadow: 0 8px 18px -6px rgba(59, 91, 219, 0.55),
                  0 2px 6px -1px rgba(59, 91, 219, 0.35);
      transform: translateY(-1px);
    }
    .member-list-tabs .tab-btn.active.alt {
      background: linear-gradient(135deg, #f59f4b 0%, #e8590c 100%);
      box-shadow: 0 8px 18px -6px rgba(232, 89, 12, 0.55),
                  0 2px 6px -1px rgba(232, 89, 12, 0.35);
    }
    .member-list-tabs .tab-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: rgba(59, 91, 219, 0.12);
      color: #3b5bdb;
      transition: all 0.25s ease;
    }
    .member-list-tabs .tab-btn.active .tab-icon {
      background: rgba(255, 255, 255, 0.25);
      color: #ffffff;
    }
    .member-list-tabs .tab-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 24px;
      height: 22px;
      padding: 0 10px;
      border-radius: 11px;
      font-size: 12px;
      font-weight: 700;
      background: #ffffff;
      color: #3b5bdb;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
      letter-spacing: 0.3px;
    }
    .member-list-tabs .tab-btn.active .tab-badge {
      background: rgba(255, 255, 255, 0.95);
      color: #3b5bdb;
    }
    .member-list-tabs .tab-btn.active.alt .tab-badge {
      color: #e8590c;
    }

    .theme-dark .vidhan-sabha-bar {
      background: #1e2230;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
    }
    .theme-dark .vidhan-sabha-bar .vs-btn {
      background: #2a2f3a;
      border-color: rgba(255, 255, 255, 0.08);
      color: #b8c0d0;
    }
    .theme-dark .member-list-tabs {
      background: #2a2f3a;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
    }
    .theme-dark .member-list-tabs .tab-btn { color: #b8c0d0; }
    .theme-dark .member-list-tabs .tab-icon {
      background: rgba(141, 169, 255, 0.15);
      color: #8da9ff;
    }
  `}</style>
);

/* ============================================================
   PRINT COMPONENTS (unchanged)
   ============================================================ */
const PrintableSingleYojana = React.forwardRef(({ head }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        padding: "30px 50px",
        fontFamily: "Arial, sans-serif",
        background: "white",
        color: "#000",
      }}
    >
      <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h3>
      <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>૧૫૫ - ઓલપાડ વિધાનસભા</h3>
      <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
      <p style={{ textAlign: "center", color: "#555", fontSize: "16px", marginBottom: "20px" }}>
        Village: {head.PartNameEnglish} | Locality: {head.LocalityEnglish}
      </p>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "15px",
          tableLayout: "fixed",
          marginBottom: "40px",
        }}
      >
        <colgroup>
          <col style={{ width: "7%" }} />
          <col style={{ width: "30%" }} />
          <col style={{ width: "43%" }} />
          <col style={{ width: "20%" }} />
        </colgroup>
        <thead>
          <tr style={{ backgroundColor: "#E8F5E8" }}>
            <th>No</th>
            <th>Yojana Name</th>
            <th>Member & Amount</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {head.MemberYojnaDetails?.map((yojana, i) => {
            const memberDetails = yojana.MemberDetails ?? [];
            const maxNameLen = Math.max(...memberDetails.map((m) => m?.MemberName?.trim().length || 0));
            const hideYojana = isHiddenZeroAmountYojana(yojana);
            const memberList = memberDetails.map((m, idx) => {
              const name = m?.MemberName?.trim() || "Unknown";
              const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
              const paddedName = name.padEnd(maxNameLen + 2);
              const amtText =
                hideYojana && isAmountMissing(m)
                  ? "-"
                  : m.IsAmount
                    ? m?.TimePeriod && m.TimePeriod !== "1"
                      ? `${amount} × ${m.TimePeriod}`
                      : amount
                    : m.IsAmountEnterByUser
                      ? toIndianCurrency(parseInt(m?.Amount || 0))
                      : "1";
              const entryDate = m.GramYojnaMemberEntryDate;
              return `${idx + 1}) ${paddedName} ${amtText}\n   Entry Date: ${entryDate}`;
            });
            return (
              <tr key={i} style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                <td>{i + 1}</td>
                <td style={{ fontFamily: "monospace" }}>{yojana.GramYojnaName}</td>
                <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
                  {memberList.join("\n")}
                  <br />
                  {hideYojana && isAmountMissing(yojana?.MemberDetails?.[0])
                    ? ""
                    : yojana?.MemberDetails?.[0]?.TimePeriod === "12"
                      ? " ( દર માસ ) "
                      : yojana?.MemberDetails?.[0]?.IsAmount
                        ? " ( દર વર્ષે ) "
                        : ""}
                </td>
                <td style={{ textAlign: "right", fontFamily: "monospace" }}>
                  {hideYojana && isAmountMissing(yojana?.MemberDetails?.[0])
                    ? "-"
                    : yojana?.MemberDetails?.[0]?.IsAmount
                      ? toIndianCurrency(yojana.Amount)
                      : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
                        ? toIndianCurrency(yojana.Amount)
                        : `${yojana?.MemberDetails.length} સંખ્યા`}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr style={{ backgroundColor: "#FFF3E0", fontWeight: "bold" }}>
            <td colSpan={3} style={{ textAlign: "right" }}>
              Total Amount
            </td>
            <td style={{ textAlign: "right" }}>{toIndianCurrency(head.OverAllFamilyAmount || 0)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

const ORIENTATION = "landscape";
const PAGE_WIDTH_MM = ORIENTATION === "landscape" ? 297 : 210;
const PAGE_HEIGHT_MM = ORIENTATION === "landscape" ? 210 : 297;
const TOP_MARGIN_MM = 15;
const BOTTOM_MARGIN_MM = 15;
const LEFT_MARGIN_MM = 20;
const RIGHT_MARGIN_MM = 20;
const PRINTABLE_HEIGHT_MM = PAGE_HEIGHT_MM - TOP_MARGIN_MM - BOTTOM_MARGIN_MM;
const PRINTABLE_WIDTH_MM = PAGE_WIDTH_MM - LEFT_MARGIN_MM - RIGHT_MARGIN_MM;
const PX_TO_MM = 96 / 25.4;

const PrintableAllYojanas = React.forwardRef(({ data, vidhanSabhaName }, ref) => {
  const [pageGroups, setPageGroups] = useState([]);
  const measureRef = useRef(null);

  useEffect(() => {
    if (!measureRef.current || !data.length) return;
    const blocks = measureRef.current.querySelectorAll(".print-block");
    const heightsPx = Array.from(blocks).map((b) => b.offsetHeight);
    const printablePx = PRINTABLE_HEIGHT_MM * PX_TO_MM;

    const groups = [];
    let curGroup = [];
    let curHeight = 0;

    data.forEach((item, i) => {
      const blockHeight = heightsPx[i];
      const gap = i === 0 ? 0 : 30;
      if (curHeight + gap + blockHeight > printablePx && curGroup.length) {
        groups.push(curGroup);
        curGroup = [item];
        curHeight = blockHeight;
      } else {
        curGroup.push(item);
        curHeight += gap + blockHeight;
      }
    });
    if (curGroup.length) groups.push(curGroup);
    setPageGroups(groups);
  }, [data]);

  return (
    <div ref={ref} style={{ background: "white", fontFamily: "Arial, sans-serif" }}>
      <div
        ref={measureRef}
        style={{
          padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
          visibility: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          width: `${PRINTABLE_WIDTH_MM}mm`,
        }}
      >
        {data.map((item, idx) => (
          <PrintBlock key={idx} item={item} vidhanSabhaName={vidhanSabhaName} />
        ))}
      </div>

      {pageGroups.map((group, pageIdx) => (
        <div
          key={pageIdx}
          className="print-page"
          style={{
            width: `${PAGE_WIDTH_MM}mm`,
            minHeight: `${PAGE_HEIGHT_MM}mm`,
            padding: `${TOP_MARGIN_MM}mm ${RIGHT_MARGIN_MM}mm ${BOTTOM_MARGIN_MM}mm ${LEFT_MARGIN_MM}mm`,
            pageBreakAfter: pageIdx < pageGroups.length - 1 ? "always" : "auto",
            boxSizing: "border-box",
          }}
        >
          {group.map((item, idx) => (
            <PrintBlock key={idx} item={item} isLastInGroup={idx === group.length - 1} vidhanSabhaName={vidhanSabhaName} />
          ))}
        </div>
      ))}
    </div>
  );
});

const PrintBlock = React.memo(({ item, isLastInGroup, vidhanSabhaName }) => {
  const { head, yojanas } = item;

  return (
    <div className="print-block" style={{ marginBottom: isLastInGroup ? "0" : "30px", breakInside: "avoid" }}>
      <h1 style={{ textAlign: "center", color: "#1A237E", fontSize: "32px", marginBottom: "-15px" }}>સરકાર દ્વારા મળેલ લાભો</h1>
      <h3 style={{ textAlign: "center", color: "#1A237E", fontSize: "20px", marginBottom: "-15px" }}>{vidhanSabhaName || ""}</h3>
      <h4 style={{ textAlign: "center", color: "#1A237E", fontSize: "-15px" }}>લાભાર્થી પરિવાર : {head.FullNameEnglish}</h4>
      <p style={{ fontSize: "16px", marginBottom: "15px" }}>
        <strong>Village:</strong> {head.PartNameEnglish} | <strong>Locality:</strong> {head.LocalityEnglish}
      </p>

      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px", tableLayout: "fixed" }}>
        <colgroup>
          <col style={{ width: "7%" }} />
          <col style={{ width: "30%" }} />
          <col style={{ width: "45%" }} />
          <col style={{ width: "20%" }} />
        </colgroup>

        <thead>
          <tr style={{ backgroundColor: "#E8F5E8" }}>
            <th style={{ border: "1px solid #333", padding: "10px" }}>No</th>
            <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Yojana</th>
            <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Member & Amount</th>
            <th style={{ border: "1px solid #333", padding: "10px", fontFamily: "monospace" }}>Total Amount</th>
          </tr>
        </thead>

        <tbody>
          {yojanas.map((y, i) => {
            const hideYojana = isHiddenZeroAmountYojana(y);
            const memberLines = y.MemberDetails?.map((m, idx) => {
              const name = m?.MemberName?.trim() || "Unknown";
              const amount = toIndianCurrency(parseInt(m?.Amount?.trim() || 0));
              const entryDate = m?.GramYojnaMemberEntryDate;
              const amtText =
                hideYojana && isAmountMissing(m)
                  ? "-"
                  : m.IsAmount
                    ? m?.TimePeriod && m?.TimePeriod != "1"
                      ? amount + " × " + m?.TimePeriod
                      : amount
                    : m.IsAmountEnterByUser
                      ? amount
                      : "1";
              return `${idx + 1}) ${name.padEnd(25)} - ${amtText}\n  Entry Date -${entryDate} `;
            });

            return (
              <tr key={i}>
                <td style={{ border: "1px solid #333", padding: "8px", textAlign: "center", verticalAlign: "top", fontFamily: "monospace" }}>{i + 1}</td>
                <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", wordBreak: "break-word", verticalAlign: "top", fontFamily: "monospace" }}>
                  {y.GramYojnaName}
                </td>
                <td style={{ border: "1px solid #333", padding: "8px", whiteSpace: "pre-line", fontFamily: "monospace", verticalAlign: "top" }}>
                  {memberLines.join("\n")}
                  <br />
                  {hideYojana && isAmountMissing(y?.MemberDetails?.[0])
                    ? ""
                    : y?.MemberDetails?.[0]?.TimePeriod == "12"
                      ? " ( દર માસ ) "
                      : y?.MemberDetails?.[0]?.IsAmount
                        ? " ( દર વર્ષે ) "
                        : ""}
                </td>
                <td style={{ border: "1px solid #333", padding: "8px", textAlign: "right", verticalAlign: "top" }}>
                  {hideYojana && isAmountMissing(y?.MemberDetails?.[0])
                    ? "-"
                    : y?.MemberDetails?.[0]?.IsAmount
                      ? toIndianCurrency(y.Amount)
                      : y?.MemberDetails?.[0]?.IsAmountEnterByUser
                        ? toIndianCurrency(y.Amount)
                        : `${y?.MemberDetails.length} સંખ્યા`}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={4} style={{ borderTop: "1px solid #000", padding: 0 }}></td>
          </tr>
          <tr>
            <td
              colSpan={3}
              style={{
                textAlign: "right",
                padding: "6px 8px",
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor: "#FFF3E0",
                border: "1px solid #000",
                borderRight: "none",
              }}
            >
              Total Amount
            </td>
            <td
              style={{
                textAlign: "right",
                padding: "6px 8px",
                fontWeight: "bold",
                fontSize: "15px",
                color: "#000",
                backgroundColor: "#FFF3E0",
                fontFamily: "monospace",
                border: "1px solid #000",
              }}
            >
              {toIndianCurrency(head.OverAllFamilyAmount || 0)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

/* ============================================================
   SMALL HELPERS
   ============================================================ */
const renderGender = (g) => {
  const v = (g || "").toLowerCase();
  if (v === "f") return <span className="gender-badge female">Female</span>;
  if (v === "m") return <span className="gender-badge male">Male</span>;
  if (v === "other") return <span className="gender-badge unknown">Other</span>;
  return <span className="gender-badge unknown">-</span>;
};

/* ============================================================
   MAIN COMPONENT
   ============================================================ */
const ViewMemberList = () => {
  const { DarkTheme } = useSelector((state) => state.ProjectSlice);
  const dispatch = useDispatch();

  const [addNewVoterShow, setAddNewVoterShow] = useState(false);
  const [changeHeadData, setChangeHeadData] = useState("");
  const [isChangeHeadOpen, setIsChangeHeadOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [filterData, setFilterData] = useState({});
  const [familyHeadMasterID, setFamilyHeadMasterID] = useState("");
  const [headData, setHeadData] = useState({});
  const [statusType, setStatusType] = useState("");
  const [deadNonVoterHeadID, setDeadNonVoterHeadID] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  const [selectedLocality, setSelectedLocality] = useState("");
  const [isAddExistingModalOpen, setIsAddExistingModalOpen] = useState(false);
  const [selectedRecords, setSelectedRecords] = useState({});
  const [filterStatus, setFilterStatus] = useState(false);
  const [memberDetails, setMemberDetails] = useState([]);
  const [yojanaSelectModalOpen, setYojanaSelectModal] = useState(false);
  const [memberYojanaDetail, setMemberYojanaDetail] = useState([]);
  const [yojanaDetails, setOpenYojanaDetails] = useState({});
  const { mutate: addNotVoterDeath, isPending: inserting } = useNotVoterDeath();
  const [deadNonVoterMemberID, setDeadNonVoterMemberID] = useState("");
  const [selectedEditGramYojanaID, setSelectedEditGramYojanaID] = useState(null);
  const [selectedEditMemberDetail, setSelectedEditMemberDetail] = useState({});
  const [isEditMemberDetailModalOpen, setIsEditMemberDetailModalOpen] = useState(false);

  const [isAssignFamily, setIsAssignFamily] = useState(true);

  const resolveInitialVidhanSabha = () => {
    const validIds = VIDHAN_SABHA_LIST.map((v) => v.id);
    try {
      const stored = localStorage.getItem("selectedVidhanSabha");
      if (stored && validIds.includes(stored)) return stored;
    } catch (e) {
      /* ignore */
    }
    return VIDHAN_SABHA_LIST[0].id;
  };

  const [selectedVidhanSabha, setSelectedVidhanSabha] = useState(resolveInitialVidhanSabha);

  const [tabCounts, setTabCounts] = useState({
    FamilyCount: 0,
    WithoutFamilyCount: 0,
  });
  const [vsTotalCounts, setVsTotalCounts] = useState({});

  const singlePrintRefs = useRef({});
  const allYojanaPrintRef = useRef();
  const triggerAllPrint = useRef(() => {});
  const [allYojanaData, setAllYojanaData] = useState([]);
  const [preparingAllPrint, setPreparingAllPrint] = useState(false);

  const filterRef = useRef();

  const queryFilterData = { ...filterData, VidhanSabha: selectedVidhanSabha };

  const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useMemberListDataPagination(rowsPerPage, queryFilterData, isAssignFamily);
  const { mutate: deleteMember, isLoading: deleting } = useDeleteMember();
  const { mutate: addChangeHead, isPending: changeHeadInserting } = useSetChangeHead();
  const { mutate: exportMemberList, isPending: isExporting } = useMemberListExportExcel();

  const pages = data?.pages || [];
  const totalCount = data?.pages[0]?.TotalCount || 0;
  const start = currentPage * rowsPerPage + 1;
  const end = Math.min(start + (pages[currentPage]?.data?.length || 0) - 1, totalCount);

  const effectiveFilterData = {
    ...filterData,
    IsAssignFamily: isAssignFamily,
    VidhanSabha: selectedVidhanSabha,
  };

  const activeVidhanSabhaName = VIDHAN_SABHA_LIST.find((v) => v.id === selectedVidhanSabha)?.name || "";

  useEffect(() => {
    const fetchTabCounts = async () => {
      try {
        const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

        const outsideValue = outside?.trim()?.toLowerCase() === "true";
        const handicapValue = handicap?.trim()?.toLowerCase() === "true";

        const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberCountWithFamilyAndWithoutFamilly`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Name: name || "",
            MobileNo: mobileNo || "",
            Gender: gender || "",
            IDCardNo: idCardNo || "",
            OutSide: outsideValue,
            Handicap: handicapValue,
            Address: locality || "",
            VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
            IsActive: "true",
            IsDelete: "false",
            IsAssignFamily: isAssignFamily,
          }),
        });

        if (!response.ok) return;

        const result = await response.json();
        if (!result?.status || !result?.data) return;

        const counts = {};
        (result.data.VidhansabhaCount || []).forEach((row) => {
          if (row?.Vidhansabha) {
            counts[row.Vidhansabha] = Number(row.TotalCount) || 0;
          }
        });
        setVsTotalCounts(counts);

        const currentRow = (result.data.VidhansabhaCount || []).find((row) => row?.Vidhansabha === selectedVidhanSabha);

        setTabCounts({
          FamilyCount: Number(currentRow?.WithFamilyCount ?? result.data.FamilyCount) || 0,
          WithoutFamilyCount: Number(currentRow?.WithoutFamilyCount ?? result.data.WithoutFamilyCount) || 0,
        });
      } catch (err) {
        console.error("Failed to fetch member counts:", err);
      }
    };

    fetchTabCounts();
  }, [selectedVidhanSabha, filterData, isAssignFamily]);

  const handleVidhanSabhaChange = (id) => {
    if (id === selectedVidhanSabha) return;
    setSelectedVidhanSabha(id);
    setCurrentPage(0);
    setOpenYojanaDetails({});
    setFilterData({});
  };

  const handleTabChange = (value) => {
    if (value === isAssignFamily) return;
    setIsAssignFamily(value);
    setCurrentPage(0);
    setOpenYojanaDetails({});
  };

  const printSingleYojana = (head) => {
    const node = singlePrintRefs.current[head.FamilyHeadMasterID];
    if (!node) return;

    const win = window.open("", "_blank");
    win.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${head.FullNameEnglish} - Yojana</title>
          <style>
            body { font-family: Arial, sans-serif; background: white; }
            table { width: 100%; border-collapse: collapse; font-size: 14px; }
            th, td { border: 1px solid #333; padding: 10px; text-align: left; }
            th { background: #E8F5E8; }
            .indian-currency::before { content: "₹"; }
          </style>
        </head>
        <body>${node.innerHTML}</body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.print();
    setTimeout(() => win.close(), 1000);
  };

  const handlePrintAllYojanas = () => {
    toast.dismiss();
    setPreparingAllPrint(true);

    exportMemberList(effectiveFilterData, {
      onSuccess: (apiData) => {
        const printData = apiData.filter((head) => head.MemberYojnaDetails?.length > 0).map((head) => ({ head, yojanas: head.MemberYojnaDetails }));

        if (printData.length === 0) {
          notifyError("No Yojana data found");
          setPreparingAllPrint(false);
          return;
        }

        setAllYojanaData(printData);
        setTimeout(() => triggerAllPrint.current(), 300);
      },
      onError: () => {
        notifyError("Print failed");
        setPreparingAllPrint(false);
      },
    });
  };

  const printAllYojanas = useReactToPrint({
    contentRef: allYojanaPrintRef,
    documentTitle: `All_Yojanas_${new Date().toISOString().slice(0, 10)}`,
    onAfterPrint: () => {
      setPreparingAllPrint(false);
      setAllYojanaData([]);
    },
  });

  useEffect(() => {
    triggerAllPrint.current = printAllYojanas;
  }, [printAllYojanas]);

  const handleRowsChange = async (e) => {
    const limit = parseInt(e.target?.value);
    setRowsPerPage(limit);
    setCurrentPage(0);
    await refetch();
  };

  const goToPage = async (index) => {
    if (pages[index]) {
      setCurrentPage(index);
    } else if (hasNextPage) {
      await fetchNextPage();
      setCurrentPage(index);
    }
  };

  const handleAddNewVoterClose = () => setAddNewVoterShow(false);

  const handleChangeHeadClose = () => {
    setIsChangeHeadOpen(false);
    setChangeHeadData("");
    setFamilyHeadMasterID("");
    setHeadData({});
    setStatusType("");
  };

  const handleCloseAddExistingModal = () => {
    setSelectedVillage("");
    setSelectedLocality("");
    setSelectedRecords({});
    setIsAddExistingModalOpen(false);
    setFamilyHeadMasterID("");
  };

  const handleSetNonVoterDeath = (ele, StatusType, Status) => {
    setDeadNonVoterMemberID(ele.ContactDetailID);
    setStatusType(StatusType);
    const payload = {
      ContactDetailID: ele?.ContactDetailID || "",
      StatusType: StatusType,
      Death: StatusType === "Death" ? Status : false,
      NotVoter: StatusType === "NotVoter" ? Status : false,
      UpdatedByUserID: "",
    };

    Swal.fire({
      title: "Are you sure?",
      text: `You are marking this member as "${StatusType}".`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, proceed!",
    }).then((result) => {
      if (result.isConfirmed) {
        addNotVoterDeath(payload, {
          onSuccess: (res) => {
            if (res?.status === true) {
              notifySuccess("Successfully Inserted", false);
              refetch();
            } else {
              notifyError(res?.message ? res.message : "Data Not Inserted", false);
            }
          },
          onError: () => notifyError("Something went wrong", false),
        });
      } else {
        setDeadNonVoterMemberID("");
        setStatusType("");
      }
    });
  };

  const handleDeleteMember = async (item) => {
    const result = await deleteConfirmation();
    if (result?.isConfirmed) {
      const payload = {
        UserID: Cookies.get("Mukesh_Patel_UserID") || "",
        ContactDetailID: item?.ContactDetailID || "",
        FamilyMemberDetailID: item?.FamilyMemberDetailID || "",
        VoterID: item?.VoterID || "",
      };
      deleteMember(payload, {
        onSuccess: (res) => {
          if (res?.status === true) {
            notifySuccess("Deleted Successfully", DarkTheme ? true : false);
            refetch();
          } else {
            notifyError(res?.message || "Not Deleted", DarkTheme ? true : false);
          }
        },
        onError: () => notifyError("Something went wrong", false),
      });
    }
  };

  const handleDeathNotVoterChange = (head, StatusType) => {
    setFamilyHeadMasterID(head.FamilyHeadMasterID);
    setDeadNonVoterHeadID(head?.ContactDetailID);
    setStatusType(StatusType);

    if (head?.FamilyMemberDetails?.length > 0) {
      setChangeHeadData(head);
      setIsChangeHeadOpen(true);
      setHeadData({
        ContactDetailID: head?.ContactDetailID,
        VoterID: head?.VoterID,
        IsHead: false,
        IsHandicap: head?.IsHandicap,
        IsOutSide: head?.IsOutSide,
      });
    } else {
      const payload = {
        UserID: Cookies.get("Mukesh_Patel_UserID") || "",
        FamilyHeadMasterID: familyHeadMasterID || "",
        ContactDetailID: head?.ContactDetailID || "",
        StatusType: StatusType,
        Death: StatusType?.toLowerCase() === "death" ? true : false,
        NotVoter: StatusType?.toLowerCase() === "notvoter" ? true : false,
        FamilyDetail: [],
      };

      Swal.fire({
        title: "Are you sure?",
        text: `You are marking this head as "${StatusType}".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, proceed!",
      }).then((result) => {
        if (result.isConfirmed) {
          addChangeHead(payload, {
            onSuccess: (res) => {
              if (res?.status === true) {
                notifySuccess("Successfully Inserted", false);
                setFamilyHeadMasterID("");
                setStatusType("");
                setDeadNonVoterHeadID("");
                refetch();
              } else {
                notifyError(res?.message || "Data Not Inserted", false);
              }
            },
            onError: () => notifyError("Something went wrong", false),
          });
        } else {
          setFamilyHeadMasterID("");
          setDeadNonVoterHeadID("");
          setStatusType("");
        }
      });
    }
  };

  const handleFilterStatusToggle = () => {
    setFilterStatus(true);
    dispatch(toggleOffcanvasStatus(true));
  };

  const handleExport = () => {
    toast.dismiss();
    exportMemberList(effectiveFilterData, {
      onSuccess: (MemberListData) => {
        if (!MemberListData?.length) return notifyError("No Data Found");
        exportToExcelWithYojanaTable(MemberListData);
      },
      onError: () => notifyError("Export failed. Please try again."),
    });
  };

  async function exportToExcelWithYojanaTable(data) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Family Yojana Report", {
      pageSetup: { paperSize: 9, orientation: "landscape" },
    });

    let rowIndex = 1;
    let familySr = 1;

    data.forEach((head) => {
      const members = head.FamilyMemberDetails || [];
      const headName = head.FullNameEnglish || "";
      const village = head.PartNameEnglish || "";
      const locality = head.LocalityEnglish || "";
      const overAllAmount = head.OverAllFamilyAmount || 0;

      const headerRow = sheet.getRow(rowIndex++);
      headerRow.values = [familySr, headName, village, locality, `₹${Number(overAllAmount).toLocaleString("en-IN")}.00`];
      headerRow.font = { bold: true, size: 12 };
      headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6E6E6" } };

      const memberHeader = sheet.getRow(rowIndex++);
      memberHeader.values = ["", "Member Name", "Mobile", "Gender", "Age", "ID Card No", "SL No"];
      memberHeader.font = { bold: true };
      memberHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9EAD3" } };

      members.forEach((member) => {
        const row = sheet.getRow(rowIndex++);
        row.values = [
          "",
          member.FullNameEnglish || "",
          member.MobileNo || "",
          member.Gender === "M" ? "Male" : "Female",
          member.Age || "",
          member.IDCardNo || "",
          member.SLNo || "",
        ];
      });

      const yojanaHeader = sheet.getRow(rowIndex++);
      if (head?.MemberYojnaDetails?.length) {
        yojanaHeader.values = ["", "Yojana Name", "Members (with Amount)", "Total Amount"];
        yojanaHeader.font = { bold: true, color: { argb: "FFFFFFFF" } };
        yojanaHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4CAF50" } };
      }

      (head.MemberYojnaDetails || []).forEach((yojna) => {
        const yojnaName = yojna.GramYojnaName || "";
        const yojnaTotal = yojna.Amount || "0";
        const details = yojna.MemberDetails || [];
        const hideYojana = isHiddenZeroAmountYojana(yojna);

        const memberList = details
          .map((d, i) => {
            const name = d.MemberName || "Unknown";
            const amt =
              hideYojana && isAmountMissing(d)
                ? "-"
                : d.IsAmount
                  ? d?.TimePeriod && d?.TimePeriod != "1"
                    ? toIndianCurrency(parseInt(d?.Amount || 0)) + " × " + d?.TimePeriod
                    : toIndianCurrency(parseInt(d?.Amount || 0))
                  : d.IsAmountEnterByUser
                    ? toIndianCurrency(parseInt(d?.Amount || 0))
                    : "1";
            const entryDate = d?.GramYojnaMemberEntryDate;
            return `${i + 1}) ${name} (${amt})\n   Entry Date: ${entryDate}`;
          })
          .join("\n");

        const firstRow = sheet.getRow(rowIndex++);
        firstRow.values = [
          "",
          yojnaName,
          memberList +
            `${hideYojana && isAmountMissing(details?.[0]) ? "" : details?.[0]?.TimePeriod == "12" ? "\n ( દર માસ ) " : details?.[0]?.IsAmount ? "\n  ( દર વર્ષે ) " : ""}`,
          hideYojana && isAmountMissing(details?.[0])
            ? "-"
            : details?.[0]?.IsAmount
              ? toIndianCurrency(yojnaTotal)
              : details?.[0]?.IsAmountEnterByUser
                ? toIndianCurrency(yojnaTotal)
                : `${details?.length} સંખ્યા`,
        ];
        firstRow.getCell(2).alignment = { vertical: "middle", wrapText: true };
        firstRow.getCell(3).alignment = { vertical: "middle", wrapText: true };
        firstRow.getCell(4).alignment = { vertical: "middle" };
        const lines = memberList.split("\n").length;
        if (lines > 1) {
          for (let i = 1; i < lines; i++) {
            const extraRow = sheet.getRow(rowIndex);
            extraRow.values = ["", "", "", ""];
            extraRow.getCell(3).value = { formula: `C${rowIndex - lines}` };
          }
        }
        sheet.getRow(rowIndex++).height = 15;
      });

      familySr++;
    });

    sheet.columns = [{ width: 8 }, { width: 40 }, { width: 40 }, { width: 30 }, { width: 18 }, { width: 15 }, { width: 10 }, { width: 8 }, { width: 18 }, { width: 10 }];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, "Family_Yojana_Report.xlsx");
  }

  const handleYojanaExport = () => {
    toast.dismiss();
    exportMemberList(effectiveFilterData, {
      onSuccess: (YojanaListData) => {
        if (!YojanaListData?.length) return notifyError("No Data Found");
        const exportData = [];
        YojanaListData.forEach((head) => {
          const yojanaDetails = head?.MemberYojnaDetails || [];
          if (yojanaDetails.length > 0) {
            yojanaDetails.forEach((yojana) => {
              const members = yojana?.MemberDetails || [];
              const hideYojana = isHiddenZeroAmountYojana(yojana);
              members.forEach((member) => {
                exportData.push({
                  "Yojana Name": yojana?.GramYojnaName || "",
                  "Yojana Amount": hideYojana && isAmountMissing(member) ? "-" : member?.Amount || "",
                  "Member Name": member?.MemberName || "",
                });
              });
            });
          }
        });
        if (exportData.length === 0) return notifyError("No Member Yojana Details Found");
        exportToExcel(exportData, "Member_Yojana_List");
      },
      onError: () => notifyError("Export failed. Please try again."),
    });
  };

  const handleSelectYojanaChange = (head) => {
    const headDataLocal = {
      FamilyHeadMasterID: head?.FamilyHeadMasterID || "",
      FamilyMemberDetailID: "",
      ContactDetailID: head?.ContactDetailID || "",
      VoterID: head?.VoterID?.toString() || "",
      FullNameEnglish: head?.FullNameEnglish || "",
      FullNameGujarati: head?.FullNameGujarati || "",
      MobileNo: head?.MobileNo || "",
      Age: head?.Age || "",
      Gender: head?.Gender || "",
    };
    const memberDetailsLocal = [
      ...(head?.FamilyMemberDetails?.map((ele) => ({
        FamilyMemberDetailID: ele?.FamilyMemberDetailID,
        FamilyHeadMasterID: ele?.FamilyHeadMasterID || "",
        ContactDetailID: ele?.ContactDetailID || "",
        VoterID: ele?.VoterID?.toString() || "",
        Type: ele?.Type || "",
        FullNameEnglish: ele?.FullNameEnglish || "",
        FullNameGujarati: ele?.FullNameGujarati || "",
        LocalityEnglish: ele?.LocalityEnglish || "",
        PartNameEnglish: ele?.PartNameEnglish || "",
        MobileNo: ele?.MobileNo || "",
        Age: ele?.Age || "",
        Gender: ele?.Gender || "",
        NotVoter: ele?.NotVoter || "",
        Death: ele?.Death || "",
        OutSide: ele?.OutSide || "",
        Handicap: ele?.Handicap || "",
        IDCardNo: ele?.IDCardNo || "",
        SLNo: ele?.SLNo || "",
      })) || []),
      headDataLocal,
    ];

    setMemberDetails(memberDetailsLocal);
    setYojanaSelectModal(true);
    setFamilyHeadMasterID(head?.FamilyHeadMasterID);
    setMemberYojanaDetail(head?.MemberYojnaDetails);
  };

  const handleEditMemberYojanaDetail = (head, idx, GramYojnaMemberID) => {
    const memberDetail = head?.MemberYojnaDetails?.[idx]?.MemberDetails?.find((ele) => ele?.GramYojnaMemberID?.toString() === GramYojnaMemberID.toString());
    const updatedMemberDetail = {
      GramYojnaMemberID: memberDetail?.GramYojnaMemberID,
      GramYojnaID: head?.MemberYojnaDetails?.[idx]?.GramYojnaID,
      GramYojnaName: head?.MemberYojnaDetails?.[idx]?.GramYojnaName,
      GramYojnaAmountDetailID: null,
      Amount: memberDetail?.Amount?.toString(),
      MemberName: memberDetail?.MemberName,
      IsAmount: memberDetail?.IsAmount,
      IsAmountEnterByUser: memberDetail?.IsAmountEnterByUser,
      TimePeriod: memberDetail?.TimePeriod,
      IsMultiple: memberDetail?.IsMultiple,
    };
    setSelectedEditMemberDetail(updatedMemberDetail);
    setIsEditMemberDetailModalOpen(true);
  };

  const handleYojanaSelectClose = () => {
    setYojanaSelectModal(false);
    setMemberDetails([]);
    setFamilyHeadMasterID("");
    setMemberYojanaDetail([]);
    setSelectedEditGramYojanaID(null);
  };

  const handleShowHideYojanaDetails = (id) => {
    setOpenYojanaDetails((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleCloseEditMemberDetail = () => {
    setSelectedEditMemberDetail({});
    setIsEditMemberDetailModalOpen(false);
  };

  return (
    <>
      <TabStyles />

      <FilterMemberList
        filterData={filterData}
        filterRef={filterRef}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        setFilterData={setFilterData}
        selectedVidhanSabha={selectedVidhanSabha}
      />

      <div className="flex-grow-1 w-100">
        {/* ============== VIDHAN SABHA SELECTOR ============== */}
        <ul className="vidhan-sabha-bar" role="tablist" aria-label="Vidhan Sabha">
          {VIDHAN_SABHA_LIST.map((vs) => (
            <li key={vs.id} role="presentation">
              <button
                type="button"
                role="tab"
                aria-selected={selectedVidhanSabha === vs.id}
                className={`vs-btn ${selectedVidhanSabha === vs.id ? "active" : ""}`}
                onClick={() => handleVidhanSabhaChange(vs.id)}
              >
                <span className="vs-dot" />
                <span>{vs.name}</span>
                <span className="vs-total">{(vsTotalCounts[vs.id] || 0).toLocaleString("en-IN")}</span>
              </button>
            </li>
          ))}
        </ul>

        {/* ============== WITH / WITHOUT FAMILY TOGGLE ============== */}
        <ul className="member-list-tabs" role="tablist">
          <li role="presentation">
            <button type="button" role="tab" aria-selected={isAssignFamily} className={`tab-btn ${isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(true)}>
              <span className="tab-icon">
                <UserCheck size={15} />
              </span>
              <span>Members With Family</span>
              <span className="tab-badge">{tabCounts.FamilyCount.toLocaleString("en-IN")}</span>
            </button>
          </li>
          <li role="presentation">
            <button type="button" role="tab" aria-selected={!isAssignFamily} className={`tab-btn alt ${!isAssignFamily ? "active" : ""}`} onClick={() => handleTabChange(false)}>
              <span className="tab-icon">
                <User size={15} />
              </span>
              <span>Members Without Family</span>
              <span className="tab-badge">{tabCounts.WithoutFamilyCount.toLocaleString("en-IN")}</span>
            </button>
          </li>
        </ul>

        {isLoading || isError || isFetching ? (
          <TableShimmer theme={DarkTheme ? "dark" : "light"} />
        ) : (
          <div className="flex-grow-1 py-0 px-2 w-100">
            <div className="row g-6 mb-6">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-datatable">
                    <div id="DataTables_Table_0_wrapper" className="dt-container dt-bootstrap5 dt-empty-footer">
                      <div className="justify-content-between dt-layout-table px-4">
                        <div className="d-md-flex justify-content-between align-items-center dt-layout-full table-responsive">
                          <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
                            <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />

                            <button
                              onClick={handlePrintAllYojanas}
                              disabled={preparingAllPrint || isExporting}
                              className="btn btn-danger btn-sm d-flex align-items-center gap-2 ms-3"
                            >
                              <Printer size={18} />
                              {preparingAllPrint ? "Preparing..." : "Print All Yojanas"}
                            </button>

                            <div className="dt-buttons btn-group flex-md-row flex-column d-flex gap-3 mb-md-0 mb-4">
                              <TableFilterButton handleFilterStatusToggle={handleFilterStatusToggle} />
                              <ExcelButton
                                isExportingMain={isExporting}
                                isExportingSecondary={isExporting}
                                handleExportMain={handleExport}
                                primaryExcel="Member Details"
                                handleExportSecondary={handleYojanaExport}
                                secondaryExcel="Yojana Details"
                              />
                            </div>
                          </div>

                          <table className="datatables-users Merge-List table dataTable dtr-column" id="DataTables_Table_0">
                            <thead className="table-header-light border-top">
                              <tr>
                                <th rowSpan={2}>Sr No</th>
                                <th rowSpan={2}>Yojana Details</th>
                                <th rowSpan={2} style={{ width: "20%", verticalAlign: "middle" }}>
                                  <Home size={16} className="me-1" />
                                  Head &amp; Address
                                </th>
                                <th colSpan={8} className="text-center">
                                  <Users size={16} className="me-1" />
                                  Member Details
                                </th>
                              </tr>
                              <tr>
                                <th>Family Member</th>
                                <th>Mobile</th>
                                <th>Gender</th>
                                <th>Age</th>
                                <th>Non Voter</th>
                                <th>Death</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pages[currentPage]?.data?.map((head, headIndex) => {
                                const hasMembers = Array.isArray(head.FamilyMemberDetails) && head.FamilyMemberDetails.length > 0;
                                const memberCount = hasMembers ? head.FamilyMemberDetails.length : 1;
                                const absoluteIndex = currentPage * rowsPerPage + headIndex + 1;
                                const rowKey = head.FamilyHeadMasterID || head.VoterID || `head-${headIndex}`;
                                const toggleKey = head.VoterID || head.FamilyHeadMasterID;

                                return (
                                  <React.Fragment key={rowKey}>
                                    {hasMembers ? (
                                      <>
                                        {head.FamilyMemberDetails.map((ele, memberIndex) => (
                                          <tr key={`${rowKey}-${memberIndex}`}>
                                            {memberIndex === 0 && (
                                              <>
                                                <td rowSpan={memberCount} className="align-top">
                                                  {absoluteIndex}
                                                </td>
                                                <td rowSpan={memberCount} className="align-top">
                                                  {head.MemberYojnaDetails?.length > 0 && (
                                                    <i
                                                      onClick={() => handleShowHideYojanaDetails(toggleKey)}
                                                      className={`icon-base ti tabler-${
                                                        yojanaDetails[toggleKey] ? "chevron-down" : "chevron-right"
                                                      } icon-md cursor-pointer scaleX-n1-rtl`}
                                                    />
                                                  )}
                                                </td>
                                                <td rowSpan={memberCount} className="align-top">
                                                  {head.FullNameEnglish || "-"}
                                                  <br />
                                                  <span className="custom-font">
                                                    <strong>Village / Area:</strong> {head.PartNameEnglish || "-"}
                                                  </span>
                                                  <br />
                                                  <span className="custom-font">
                                                    <strong>Locality:</strong> {head.LocalityEnglish || "-"}
                                                  </span>
                                                  <br />
                                                  <br />
                                                  <div className="d-flex gap-2">
                                                    <label className="d-flex align-items-center gap-1">
                                                      <input
                                                        type="checkbox"
                                                        className="custom-checkbox cursor-pointer"
                                                        checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
                                                        onChange={() => handleDeathNotVoterChange(head, "Death")}
                                                      />
                                                      <strong>
                                                        <span className="cursor-pointer custom-font">Death</span>
                                                      </strong>
                                                    </label>
                                                    <label className="d-flex align-items-center gap-1">
                                                      <input
                                                        type="checkbox"
                                                        className="custom-checkbox cursor-pointer"
                                                        checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
                                                        onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
                                                      />
                                                      <strong>
                                                        <span className="cursor-pointer custom-font">Non Voter</span>
                                                      </strong>
                                                    </label>
                                                  </div>
                                                  <br />
                                                  {head?.OverAllFamilyAmount ? (
                                                    <div>
                                                      <strong>OverAll Yojana Amount: </strong>
                                                      <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
                                                    </div>
                                                  ) : (
                                                    <div>
                                                      <strong>OverAll Yojana Amount: </strong>
                                                      <span>-</span>
                                                    </div>
                                                  )}
                                                  <br />
                                                  {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
                                                </td>
                                              </>
                                            )}
                                            <td>
                                              {ele.FullNameEnglish || "-"}
                                              <br />
                                              <br />
                                              {`${ele?.IsHandicap === "true" ? "Handicap" : ""}${ele?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
                                            </td>
                                            <td>{ele.MobileNo ? `+91 ${ele.MobileNo}` : "-"}</td>
                                            <td>{renderGender(ele.Gender)}</td>
                                            <td>{ele.Age || "-"}</td>
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
                                                onChange={() => handleSetNonVoterDeath(ele, "NotVoter", !ele?.NotVoter)}
                                                style={{ width: "18px", height: "18px" }}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={ele?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
                                                onChange={() => handleSetNonVoterDeath(ele, "Death", !ele?.Death)}
                                                style={{ width: "18px", height: "18px" }}
                                              />
                                            </td>
                                            {memberIndex === 0 && (
                                              <td rowSpan={memberCount} className="text-center align-top p-2">
                                                <div className="d-flex flex-column gap-2">
                                                  <button
                                                    className="btn btn-sm btn-outline-warning fw-semibold"
                                                    onClick={() => {
                                                      setChangeHeadData(head);
                                                      setIsChangeHeadOpen(true);
                                                      setFamilyHeadMasterID(head.FamilyHeadMasterID);
                                                      setHeadData({
                                                        ContactDetailID: head?.ContactDetailID,
                                                        VoterID: head?.VoterID,
                                                        IsHead: false,
                                                        IsHandicap: head?.IsHandicap,
                                                        IsOutSide: head?.IsOutSide,
                                                      });
                                                    }}
                                                  >
                                                    Change Head
                                                  </button>
                                                </div>
                                              </td>
                                            )}
                                          </tr>
                                        ))}

                                        <AnimatePresence>
                                          {yojanaDetails[toggleKey] && (
                                            <motion.tr
                                              key={`yojana-${rowKey}`}
                                              initial={{ opacity: 0 }}
                                              animate={{ opacity: 1 }}
                                              exit={{ opacity: 0 }}
                                              style={{ background: "#f7f7f7" }}
                                            >
                                              <td colSpan={10} className="p-0">
                                                <div className="p-3 border-top">
                                                  <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
                                                  <div className="table-responsive">
                                                    <table className="table table-sm table-bordered">
                                                      <thead className="table-light">
                                                        <tr>
                                                          <th>Yojana Name</th>
                                                          <th>Members</th>
                                                          <th>Amount</th>
                                                          <th>Total Amount</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {head?.MemberYojnaDetails?.map((yojana, idx) => (
                                                          <tr key={idx}>
                                                            <td>{yojana?.GramYojnaName || "-"}</td>
                                                            <td>
                                                              {yojana?.MemberDetails?.map((ele, inx) => (
                                                                <div
                                                                  key={ele?.GramYojnaMemberID ?? inx}
                                                                  style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    padding: "4px 0",
                                                                    borderBottom: "1px dashed #ddd",
                                                                  }}
                                                                >
                                                                  <div style={{ display: "flex", flexDirection: "column" }}>
                                                                    <span>
                                                                      {inx + 1}) {ele?.MemberName || "-"}
                                                                    </span>
                                                                  </div>
                                                                  {/* {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
                                                                    <button
                                                                      type="button"
                                                                      className="btn btn-sm btn-outline-primary"
                                                                      onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
                                                                    >
                                                                      Edit
                                                                    </button>
                                                                  )} */}
                                                                </div>
                                                              ))}
                                                            </td>
                                                            <td>
                                                              {yojana?.MemberDetails?.map((ele, inx) => {
                                                                const hideYojana = isHiddenZeroAmountYojana(yojana);
                                                                const hideAmt = hideYojana && isAmountMissing(ele);
                                                                return (
                                                                  <div key={inx} className="member-row amount-row">
                                                                    <span className="custom-font indian-currency">
                                                                      {hideAmt
                                                                        ? "-"
                                                                        : ele.IsAmount
                                                                          ? ele?.TimePeriod && ele?.TimePeriod !== "1"
                                                                            ? `${toIndianCurrency(parseInt(ele?.Amount || "0"))} × ${ele?.TimePeriod}`
                                                                            : toIndianCurrency(parseInt(ele?.Amount || "-"))
                                                                          : ele.IsAmountEnterByUser
                                                                            ? toIndianCurrency(parseInt(ele?.Amount || "-"))
                                                                            : "1"}
                                                                    </span>
                                                                  </div>
                                                                );
                                                              })}
                                                              {isHiddenZeroAmountYojana(yojana) && isAmountMissing(yojana?.MemberDetails?.[0])
                                                                ? ""
                                                                : yojana?.MemberDetails?.[0]?.TimePeriod === "12"
                                                                  ? " ( દર માસ ) "
                                                                  : yojana?.MemberDetails?.[0]?.IsAmount
                                                                    ? " ( દર વર્ષે ) "
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                              <span className="custom-font indian-currency">
                                                                {isHiddenZeroAmountYojana(yojana) && isAmountMissing(yojana?.MemberDetails?.[0])
                                                                  ? "-"
                                                                  : yojana?.MemberDetails?.[0]?.IsAmount
                                                                    ? toIndianCurrency(yojana.Amount)
                                                                    : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
                                                                      ? toIndianCurrency(yojana.Amount)
                                                                      : yojana?.MemberDetails?.length
                                                                        ? `${yojana.MemberDetails.length} સંખ્યા`
                                                                        : "-"}
                                                              </span>
                                                            </td>
                                                          </tr>
                                                        ))}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </td>
                                            </motion.tr>
                                          )}
                                        </AnimatePresence>
                                      </>
                                    ) : (
                                      <>
                                        <tr>
                                          {/* Sr No */}
                                          <td>{absoluteIndex}</td>

                                          {/* Yojana Details expander */}
                                          <td>
                                            {head.MemberYojnaDetails?.length > 0 && (
                                              <i
                                                onClick={() => handleShowHideYojanaDetails(toggleKey)}
                                                className={`icon-base ti tabler-${
                                                  yojanaDetails[toggleKey] ? "chevron-down" : "chevron-right"
                                                } icon-md cursor-pointer scaleX-n1-rtl`}
                                              />
                                            )}
                                          </td>

                                          {/* Head & Address */}
                                          <td>
                                            {head.FullNameEnglish || "-"}
                                            <br />
                                            <span className="custom-font">
                                              <strong>Village / Area:</strong> {head.PartNameEnglish || "-"}
                                            </span>
                                            <br />
                                            <span className="custom-font">
                                              <strong>Locality:</strong> {head.LocalityEnglish || "-"}
                                            </span>
                                            <br />
                                            <br />

                                            <div className="d-flex gap-2">
                                              <label className="d-flex align-items-center gap-1">
                                                <input
                                                  type="checkbox"
                                                  className="custom-checkbox cursor-pointer"
                                                  checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "death"}
                                                  onChange={() => handleDeathNotVoterChange(head, "Death")}
                                                />
                                                <strong>
                                                  <span className="cursor-pointer custom-font">Death</span>
                                                </strong>
                                              </label>
                                              <label className="d-flex align-items-center gap-1">
                                                <input
                                                  type="checkbox"
                                                  className="custom-checkbox cursor-pointer"
                                                  checked={head?.ContactDetailID === deadNonVoterHeadID && statusType?.toLowerCase() === "notvoter"}
                                                  onChange={() => handleDeathNotVoterChange(head, "NotVoter")}
                                                />
                                                <strong>
                                                  <span className="cursor-pointer custom-font">Non Voter</span>
                                                </strong>
                                              </label>
                                            </div>

                                            <br />
                                            {head?.OverAllFamilyAmount ? (
                                              <div>
                                                <strong>OverAll Yojana Amount: </strong>
                                                <span className="custom-font indian-currency">{toIndianCurrency(head.OverAllFamilyAmount)}</span>
                                              </div>
                                            ) : (
                                              <div>
                                                <strong>OverAll Yojana Amount: </strong>
                                                <span>-</span>
                                              </div>
                                            )}
                                            <br />
                                            {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
                                          </td>

                                          {/* Name */}
                                          <td>
                                            {head.FullNameEnglish || "-"}
                                            <div
                                              style={{
                                                marginTop: "4px",
                                                fontSize: "11px",
                                                fontStyle: "italic",
                                                color: "#9aa4b2",
                                                lineHeight: 1.2,
                                              }}
                                            >
                                              (Head — no family members linked)
                                            </div>
                                            <br />
                                            {`${head?.IsHandicap === "true" ? "Handicap" : ""}${head?.IsOutSide === "true" ? " (Outside)" : ""}` || "-"}
                                          </td>

                                          {/* Mobile */}
                                          <td>{head.MobileNo ? `+91 ${head.MobileNo}` : "-"}</td>

                                          {/* Gender */}
                                          <td>{renderGender(head.Gender)}</td>

                                          {/* Age */}
                                          <td>{head.Age || "-"}</td>

                                          {/* Non Voter */}
                                          <td>
                                            <input
                                              type="checkbox"
                                              checked={head?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "notvoter"}
                                              onChange={() => handleSetNonVoterDeath(head, "NotVoter", !head?.NotVoter)}
                                              style={{ width: "18px", height: "18px" }}
                                            />
                                          </td>

                                          {/* Death */}
                                          <td>
                                            <input
                                              type="checkbox"
                                              checked={head?.ContactDetailID === deadNonVoterMemberID && statusType?.toLowerCase() === "death"}
                                              onChange={() => handleSetNonVoterDeath(head, "Death", !head?.Death)}
                                              style={{ width: "18px", height: "18px" }}
                                            />
                                          </td>

                                          {/* Actions */}
                                          <td className="text-center align-top p-2">
                                            <div className="d-flex flex-column gap-2">
                                              <button
                                                className="btn btn-sm btn-outline-warning fw-semibold"
                                                onClick={() => {
                                                  setChangeHeadData(head);
                                                  setIsChangeHeadOpen(true);
                                                  setFamilyHeadMasterID(head.FamilyHeadMasterID);
                                                  setHeadData({
                                                    ContactDetailID: head?.ContactDetailID,
                                                    VoterID: head?.VoterID,
                                                    IsHead: false,
                                                    IsHandicap: head?.IsHandicap,
                                                    IsOutSide: head?.IsOutSide,
                                                  });
                                                }}
                                              >
                                                Change Head
                                              </button>
                                            </div>
                                          </td>
                                        </tr>

                                        <AnimatePresence>
                                          {yojanaDetails[toggleKey] && (
                                            <motion.tr
                                              key={`yojana-${rowKey}`}
                                              initial={{ opacity: 0 }}
                                              animate={{ opacity: 1 }}
                                              exit={{ opacity: 0 }}
                                              style={{ background: "#f7f7f7" }}
                                            >
                                              <td colSpan={10} className="p-0">
                                                <div className="p-3 border-top">
                                                  <h6 className="fw-bold mb-2 text-primary">Yojana Details</h6>
                                                  <div className="table-responsive">
                                                    <table className="table table-sm table-bordered">
                                                      <thead className="table-light">
                                                        <tr>
                                                          <th>Yojana Name</th>
                                                          <th>Members</th>
                                                          <th>Amount</th>
                                                          <th>Total Amount</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {head?.MemberYojnaDetails?.map((yojana, idx) => (
                                                          <tr key={idx}>
                                                            <td>{yojana?.GramYojnaName || "-"}</td>
                                                            <td>
                                                              {yojana?.MemberDetails?.map((ele, inx) => (
                                                                <div
                                                                  key={ele?.GramYojnaMemberID ?? inx}
                                                                  style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    padding: "4px 0",
                                                                    borderBottom: "1px dashed #ddd",
                                                                  }}
                                                                >
                                                                  <div style={{ display: "flex", flexDirection: "column" }}>
                                                                    <span>
                                                                      {inx + 1}) {ele?.MemberName || "-"}
                                                                    </span>
                                                                  </div>
                                                                  {/* {(ele?.IsAmountEnterByUser || ele?.IsMultiple) && (
                                                                    <button
                                                                      type="button"
                                                                      className="btn btn-sm btn-outline-primary"
                                                                      onClick={() => handleEditMemberYojanaDetail(head, idx, ele?.GramYojnaMemberID)}
                                                                    >
                                                                      Edit
                                                                    </button>
                                                                  )} */}
                                                                </div>
                                                              ))}
                                                            </td>
                                                            <td>
                                                              {yojana?.MemberDetails?.map((ele, inx) => {
                                                                const hideYojana = isHiddenZeroAmountYojana(yojana);
                                                                const hideAmt = hideYojana && isAmountMissing(ele);
                                                                return (
                                                                  <div key={inx} className="member-row amount-row">
                                                                    <span className="custom-font indian-currency">
                                                                      {hideAmt
                                                                        ? "-"
                                                                        : ele.IsAmount
                                                                          ? ele?.TimePeriod && ele?.TimePeriod !== "1"
                                                                            ? `${toIndianCurrency(parseInt(ele?.Amount || "-"))} × ${ele?.TimePeriod}`
                                                                            : toIndianCurrency(parseInt(ele?.Amount || "-"))
                                                                          : ele.IsAmountEnterByUser
                                                                            ? toIndianCurrency(parseInt(ele?.Amount || "-"))
                                                                            : "1"}
                                                                    </span>
                                                                  </div>
                                                                );
                                                              })}
                                                              {isHiddenZeroAmountYojana(yojana) && isAmountMissing(yojana?.MemberDetails?.[0])
                                                                ? ""
                                                                : yojana?.MemberDetails?.[0]?.TimePeriod === "12"
                                                                  ? " ( દર માસ ) "
                                                                  : yojana?.MemberDetails?.[0]?.IsAmount
                                                                    ? " ( દર વર્ષે ) "
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                              <span className="custom-font indian-currency">
                                                                {isHiddenZeroAmountYojana(yojana) && isAmountMissing(yojana?.MemberDetails?.[0])
                                                                  ? "-"
                                                                  : yojana?.MemberDetails?.[0]?.IsAmount
                                                                    ? toIndianCurrency(yojana.Amount)
                                                                    : yojana?.MemberDetails?.[0]?.IsAmountEnterByUser
                                                                      ? toIndianCurrency(yojana.Amount)
                                                                      : yojana?.MemberDetails?.length
                                                                        ? `${yojana.MemberDetails.length} સંખ્યા`
                                                                        : "-"}
                                                              </span>
                                                            </td>
                                                          </tr>
                                                        ))}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </td>
                                            </motion.tr>
                                          )}
                                        </AnimatePresence>
                                      </>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>

                          {/* Hidden per-head print nodes rendered OUTSIDE the table (valid HTML) */}
                          <div style={{ display: "none" }}>
                            {pages[currentPage]?.data?.map((head, i) =>
                              head?.MemberYojnaDetails?.length > 0 ? (
                                <PrintableSingleYojana
                                  key={`print-${head.FamilyHeadMasterID || head.VoterID || i}`}
                                  ref={(el) => {
                                    if (el) singlePrintRefs.current[head.FamilyHeadMasterID] = el;
                                  }}
                                  head={head}
                                />
                              ) : null,
                            )}
                          </div>

                          <div className="row mx-3 justify-content-between">
                            <PageEntries start={start} end={end} totalCount={totalCount} />
                            <PaginationButtons
                              currentPage={currentPage}
                              setCurrentPage={setCurrentPage}
                              goToPage={goToPage}
                              pages={pages}
                              hasNextPage={hasNextPage}
                              fetchNextPage={fetchNextPage}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* HIDDEN ALL YOJANA PRINT */}
      <div style={{ display: "none" }}>
        <PrintableAllYojanas ref={allYojanaPrintRef} data={allYojanaData} vidhanSabhaName={activeVidhanSabhaName} />
      </div>

      {/* MODALS */}
      <AddNewVoter show={addNewVoterShow} onClose={handleAddNewVoterClose} refetch={refetch} familyHeadMasterID={familyHeadMasterID} />
      <ChangeHeadModal
        show={isChangeHeadOpen}
        data={changeHeadData}
        handleClose={handleChangeHeadClose}
        familyHeadMasterID={familyHeadMasterID}
        refetch={refetch}
        headData={headData}
        statusType={statusType}
        deadNonVoterHeadID={deadNonVoterHeadID}
      />
      <AddExistingVoter
        show={isAddExistingModalOpen}
        selectedVillage={selectedVillage}
        selectedLocality={selectedLocality}
        handleClose={handleCloseAddExistingModal}
        selectedRecords={selectedRecords}
        setSelectedRecords={setSelectedRecords}
        refetchMemberList={refetch}
        familyHeadMasterID={familyHeadMasterID}
      />
      <YojanaSelect
        selectedEditGramYojanaID={selectedEditGramYojanaID}
        memberDetails={memberDetails}
        show={yojanaSelectModalOpen}
        handleClose={handleYojanaSelectClose}
        familyHeadMasterID={familyHeadMasterID}
        memberYojanaDetail={memberYojanaDetail}
        refetchMemberList={refetch}
      />

      <EditYojanaMemberDetail
        selectedEditMemberDetail={selectedEditMemberDetail}
        open={isEditMemberDetailModalOpen}
        onClose={handleCloseEditMemberDetail}
        refetchMemberList={refetch}
      />

      {(inserting || deleting || changeHeadInserting || preparingAllPrint || isExporting) && <Loader />}
    </>
  );
};

export default ViewMemberList;
